/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AttendeeCountOutput
 */
export interface AttendeeCountOutput {
    /**
     * 
     * @type {number}
     * @memberof AttendeeCountOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface BulkExportTicketsInput
 */
export interface BulkExportTicketsInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkExportTicketsInput
     */
    'event_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetCategoriesByEventsInput
 */
export interface BulkGetCategoriesByEventsInput {
    /**
     * List of event IDs to get categories for
     * @type {Array<string>}
     * @memberof BulkGetCategoriesByEventsInput
     */
    'event_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetEventsByCommunitiesInput
 */
export interface BulkGetEventsByCommunitiesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetEventsByCommunitiesInput
     */
    'community_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetEventsInput
 */
export interface BulkGetEventsInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetEventsInput
     */
    'event_ids': Array<string>;
    /**
     * 
     * @type {ExperienceType}
     * @memberof BulkGetEventsInput
     */
    'experience_type'?: ExperienceType;
}


/**
 * 
 * @export
 * @interface BulkGetSessionLocationsInput
 */
export interface BulkGetSessionLocationsInput {
    /**
     * List of event IDs to get session locations for
     * @type {Array<string>}
     * @memberof BulkGetSessionLocationsInput
     */
    'event_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetSessionLocationsOutput
 */
export interface BulkGetSessionLocationsOutput {
    /**
     * 
     * @type {Array<SessionLocationOutput>}
     * @memberof BulkGetSessionLocationsOutput
     */
    'session_locations': Array<SessionLocationOutput>;
    /**
     * 
     * @type {number}
     * @memberof BulkGetSessionLocationsOutput
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface BulkGetSessionsTemporalInput
 */
export interface BulkGetSessionsTemporalInput {
    /**
     * 
     * @type {TemporalRelation}
     * @memberof BulkGetSessionsTemporalInput
     */
    'temporal_relation': TemporalRelation;
    /**
     * List of community IDs to get temporal sessions from. None or empty list means all communities.
     * @type {Array<string>}
     * @memberof BulkGetSessionsTemporalInput
     */
    'community_ids'?: Array<string>;
    /**
     * Optional filter for sessions starting from this date (inclusive)
     * @type {string}
     * @memberof BulkGetSessionsTemporalInput
     */
    'start_date_from'?: string;
    /**
     * Optional filter for sessions starting up to this date (inclusive)
     * @type {string}
     * @memberof BulkGetSessionsTemporalInput
     */
    'start_date_to'?: string;
}


/**
 * 
 * @export
 * @interface BulkGetTagsByEventsInput
 */
export interface BulkGetTagsByEventsInput {
    /**
     * List of event IDs to get tags for
     * @type {Array<string>}
     * @memberof BulkGetTagsByEventsInput
     */
    'event_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetTicketTypesByEventIdInput
 */
export interface BulkGetTicketTypesByEventIdInput {
    /**
     * List of event IDs to retrieve ticket types for (1-50 events per request)
     * @type {Array<string>}
     * @memberof BulkGetTicketTypesByEventIdInput
     */
    'event_ids': Array<string>;
}
/**
 * Response model for bulk ticket types by event IDs
 * @export
 * @interface BulkGetTicketTypesByEventIdOutput
 */
export interface BulkGetTicketTypesByEventIdOutput {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof BulkGetTicketTypesByEventIdOutput
     */
    'event_ticket_types': { [key: string]: Array<string>; };
    /**
     * 
     * @type {number}
     * @memberof BulkGetTicketTypesByEventIdOutput
     */
    'total_events': number;
    /**
     * 
     * @type {number}
     * @memberof BulkGetTicketTypesByEventIdOutput
     */
    'total_ticket_types': number;
}
/**
 * Input for bulk listing group promos across multiple communities
 * @export
 * @interface BulkListGroupPromosInput
 */
export interface BulkListGroupPromosInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkListGroupPromosInput
     */
    'community_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkMarkSessionsNotViewedInput
 */
export interface BulkMarkSessionsNotViewedInput {
    /**
     * List of session IDs to mark as not viewed
     * @type {Array<string>}
     * @memberof BulkMarkSessionsNotViewedInput
     */
    'session_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkMarkSessionsViewedInput
 */
export interface BulkMarkSessionsViewedInput {
    /**
     * List of session IDs to mark as viewed
     * @type {Array<string>}
     * @memberof BulkMarkSessionsViewedInput
     */
    'session_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSessionAttendeeCountOutput
 */
export interface BulkSessionAttendeeCountOutput {
    /**
     * 
     * @type {Array<SessionAttendeeCountOutput>}
     * @memberof BulkSessionAttendeeCountOutput
     */
    'counts': Array<SessionAttendeeCountOutput>;
}
/**
 * 
 * @export
 * @interface BulkSessionData
 */
export interface BulkSessionData {
    /**
     * 
     * @type {Array<SessionTag>}
     * @memberof BulkSessionData
     */
    'session_tags'?: Array<SessionTag>;
    /**
     * 
     * @type {Array<SessionCategory>}
     * @memberof BulkSessionData
     */
    'session_categories'?: Array<SessionCategory>;
    /**
     * 
     * @type {Array<SessionAttendee>}
     * @memberof BulkSessionData
     */
    'attendees'?: Array<SessionAttendee>;
}
/**
 * 
 * @export
 * @interface BulkSessionDataInput
 */
export interface BulkSessionDataInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSessionDataInput
     */
    'session_ids': Array<string>;
    /**
     * 
     * @type {SessionAttendeeRole}
     * @memberof BulkSessionDataInput
     */
    'attendee_role'?: SessionAttendeeRole;
}


/**
 * 
 * @export
 * @interface BulkSessionDataOutput
 */
export interface BulkSessionDataOutput {
    /**
     * 
     * @type {Array<SessionDataOutput>}
     * @memberof BulkSessionDataOutput
     */
    'session_data': Array<SessionDataOutput>;
}
/**
 * 
 * @export
 * @interface BulkSessionFavoriteCountOutput
 */
export interface BulkSessionFavoriteCountOutput {
    /**
     * 
     * @type {Array<SessionFavoriteCountOutput>}
     * @memberof BulkSessionFavoriteCountOutput
     */
    'counts': Array<SessionFavoriteCountOutput>;
}
/**
 * 
 * @export
 * @interface BulkSessionIdsInput
 */
export interface BulkSessionIdsInput {
    /**
     * List of session IDs to process
     * @type {Array<string>}
     * @memberof BulkSessionIdsInput
     */
    'session_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSessionVoteCountOutput
 */
export interface BulkSessionVoteCountOutput {
    /**
     * 
     * @type {Array<SessionVoteCountOutput>}
     * @memberof BulkSessionVoteCountOutput
     */
    'counts': Array<SessionVoteCountOutput>;
}
/**
 * Input model for calculating checkout total with taxes.
 * @export
 * @interface CalculateTotalInput
 */
export interface CalculateTotalInput {
    /**
     * List of ticket types with quantities
     * @type {Array<CalculateTotalTicketItem>}
     * @memberof CalculateTotalInput
     */
    'tickets': Array<CalculateTotalTicketItem>;
    /**
     * Optional promo code to apply
     * @type {string}
     * @memberof CalculateTotalInput
     */
    'promo_code'?: string;
}
/**
 * Line item in total calculation response.
 * @export
 * @interface CalculateTotalLineItem
 */
export interface CalculateTotalLineItem {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CalculateTotalLineItem
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof CalculateTotalLineItem
     */
    'ticket_type_name': string;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalLineItem
     */
    'unit_price': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalLineItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalLineItem
     */
    'line_total': number;
}
/**
 * Response model for calculate total endpoint.
 * @export
 * @interface CalculateTotalOutput
 */
export interface CalculateTotalOutput {
    /**
     * 
     * @type {Array<CalculateTotalLineItem>}
     * @memberof CalculateTotalOutput
     */
    'line_items': Array<CalculateTotalLineItem>;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalOutput
     */
    'subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalOutput
     */
    'tax_rate': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalOutput
     */
    'tax_amount': number;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalOutput
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof CalculateTotalOutput
     */
    'promo_code_applied'?: string;
    /**
     * 
     * @type {number}
     * @memberof CalculateTotalOutput
     */
    'discount_amount'?: number;
}
/**
 * Single ticket type with quantity for total calculation.
 * @export
 * @interface CalculateTotalTicketItem
 */
export interface CalculateTotalTicketItem {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CalculateTotalTicketItem
     */
    'ticket_type_id': string;
    /**
     * Number of tickets
     * @type {number}
     * @memberof CalculateTotalTicketItem
     */
    'quantity': number;
}
/**
 * Input for cancelling a payout.
 * @export
 * @interface CancelPayoutInput
 */
export interface CancelPayoutInput {
    /**
     * 
     * @type {string}
     * @memberof CancelPayoutInput
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface CategoriesOutput
 */
export interface CategoriesOutput {
    /**
     * 
     * @type {Array<Category>}
     * @memberof CategoriesOutput
     */
    'categories': Array<Category>;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Category
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Category
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Category
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface CategoryInput
 */
export interface CategoryInput {
    /**
     * 
     * @type {string}
     * @memberof CategoryInput
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CategoryInput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryInput
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CategoryOutput
 */
export interface CategoryOutput {
    /**
     * 
     * @type {Category}
     * @memberof CategoryOutput
     */
    'category': Category;
}
/**
 * 
 * @export
 * @interface CheckoutInput
 */
export interface CheckoutInput {
    /**
     * Stripe payment method ID
     * @type {string}
     * @memberof CheckoutInput
     */
    'payment_method_id': string;
    /**
     * Optional promo/discount code
     * @type {string}
     * @memberof CheckoutInput
     */
    'discount_code'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CheckoutInput
     */
    'event_id': string;
    /**
     * Tickets with attendee info (assigned immediately)
     * @type {Array<CheckoutTicketInput>}
     * @memberof CheckoutInput
     */
    'tickets'?: Array<CheckoutTicketInput>;
    /**
     * Tickets without attendee info (generates promo codes)
     * @type {Array<UnassignedTicketInput>}
     * @memberof CheckoutInput
     */
    'unassigned_tickets'?: Array<UnassignedTicketInput>;
    /**
     * Email of purchaser (required for unassigned tickets, becomes GroupPromoEditor)
     * @type {string}
     * @memberof CheckoutInput
     */
    'purchaser_email'?: string;
    /**
     * 
     * @type {GWYCInput}
     * @memberof CheckoutInput
     */
    'gwyc'?: GWYCInput;
}
/**
 * Response for create-intent endpoint.  Contains everything the mobile client needs to initialize Payment Sheet. For free tickets (total_cents=0), returns status=\"completed\" with ticket_ids.
 * @export
 * @interface CheckoutIntentOutput
 */
export interface CheckoutIntentOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'checkout_id': string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'client_secret'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'ephemeral_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'publishable_key'?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckoutIntentOutput
     */
    'total_cents': number;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutIntentOutput
     */
    'status'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckoutIntentOutput
     */
    'ticket_ids'?: Array<string>;
    /**
     * 
     * @type {WonkaTicketsCheckoutOutputsGroupPromoOutput}
     * @memberof CheckoutIntentOutput
     */
    'group_promo'?: WonkaTicketsCheckoutOutputsGroupPromoOutput;
}
/**
 * Response for checkout status polling endpoint.  Mobile clients poll this after Payment Sheet completes to get ticket IDs.
 * @export
 * @interface CheckoutStatusOutput
 */
export interface CheckoutStatusOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CheckoutStatusOutput
     */
    'checkout_id': string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutStatusOutput
     */
    'status': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckoutStatusOutput
     */
    'ticket_ids'?: Array<string>;
    /**
     * 
     * @type {WonkaTicketsCheckoutOutputsGroupPromoOutput}
     * @memberof CheckoutStatusOutput
     */
    'group_promo'?: WonkaTicketsCheckoutOutputsGroupPromoOutput;
    /**
     * 
     * @type {string}
     * @memberof CheckoutStatusOutput
     */
    'error_message'?: string;
}
/**
 * Ticket with full attendee info - will be assigned immediately.
 * @export
 * @interface CheckoutTicketInput
 */
export interface CheckoutTicketInput {
    /**
     * Attendee first name
     * @type {string}
     * @memberof CheckoutTicketInput
     */
    'first_name': string;
    /**
     * Attendee last name
     * @type {string}
     * @memberof CheckoutTicketInput
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutTicketInput
     */
    'email': string;
    /**
     * Phone number in a standard format
     * @type {string}
     * @memberof CheckoutTicketInput
     */
    'phone_number'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CheckoutTicketInput
     */
    'ticket_type_id': string;
}
/**
 * Output for Stripe Connect account information.
 * @export
 * @interface ConnectAccountOutput
 */
export interface ConnectAccountOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'stripe_account_id'?: string;
    /**
     * 
     * @type {ConnectAccountStatus}
     * @memberof ConnectAccountOutput
     */
    'status': ConnectAccountStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'charges_enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'payouts_enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'details_submitted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'onboarding_complete': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'requirements_past_due': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConnectAccountOutput
     */
    'platform_fee_percent': number;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'business_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'bank_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectAccountOutput
     */
    'bank_last_four'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'needs_attention': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'is_ready_for_payments': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectAccountOutput
     */
    'is_ready_for_payouts': boolean;
}


/**
 * Status of a Stripe Connect Express account.
 * @export
 * @enum {string}
 */

export const ConnectAccountStatus = {
    NotCreated: 'not_created',
    Onboarding: 'onboarding',
    Restricted: 'restricted',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type ConnectAccountStatus = typeof ConnectAccountStatus[keyof typeof ConnectAccountStatus];


/**
 * Output for Connect account balance.
 * @export
 * @interface ConnectBalanceOutput
 */
export interface ConnectBalanceOutput {
    /**
     * 
     * @type {number}
     * @memberof ConnectBalanceOutput
     */
    'available_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ConnectBalanceOutput
     */
    'pending_amount': number;
    /**
     * 
     * @type {string}
     * @memberof ConnectBalanceOutput
     */
    'currency': string;
}
/**
 * Output for a Connect payout.
 * @export
 * @interface ConnectPayoutOutput
 */
export interface ConnectPayoutOutput {
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ConnectPayoutOutput
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'currency': string;
    /**
     * 
     * @type {ConnectPayoutStatus}
     * @memberof ConnectPayoutOutput
     */
    'status': ConnectPayoutStatus;
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'arrival_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectPayoutOutput
     */
    'failure_message'?: string;
}


/**
 * Status of a payout to a connected account (from Stripe webhooks).
 * @export
 * @enum {string}
 */

export const ConnectPayoutStatus = {
    InTransit: 'in_transit',
    Paid: 'paid',
    Failed: 'failed',
    Canceled: 'canceled'
} as const;

export type ConnectPayoutStatus = typeof ConnectPayoutStatus[keyof typeof ConnectPayoutStatus];


/**
 * Output for a Connect transaction.
 * @export
 * @interface ConnectTransactionOutput
 */
export interface ConnectTransactionOutput {
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof ConnectTransactionOutput
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ConnectTransactionOutput
     */
    'fee': number;
    /**
     * 
     * @type {number}
     * @memberof ConnectTransactionOutput
     */
    'net': number;
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectTransactionOutput
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface CreateCategoryInput
 */
export interface CreateCategoryInput {
    /**
     * 
     * @type {CategoryInput}
     * @memberof CreateCategoryInput
     */
    'category': CategoryInput;
}
/**
 * Input for creating a checkout intent (pre-PaymentSheet).  This is called before displaying Payment Sheet to the user. Returns credentials needed to initialize Payment Sheet.
 * @export
 * @interface CreateCheckoutIntentInput
 */
export interface CreateCheckoutIntentInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateCheckoutIntentInput
     */
    'event_id': string;
    /**
     * Optional promo/discount code
     * @type {string}
     * @memberof CreateCheckoutIntentInput
     */
    'discount_code'?: string;
    /**
     * Tickets with attendee info (assigned immediately after payment)
     * @type {Array<CheckoutTicketInput>}
     * @memberof CreateCheckoutIntentInput
     */
    'tickets'?: Array<CheckoutTicketInput>;
    /**
     * Tickets without attendee info (generates promo codes after payment)
     * @type {Array<UnassignedTicketInput>}
     * @memberof CreateCheckoutIntentInput
     */
    'unassigned_tickets'?: Array<UnassignedTicketInput>;
    /**
     * Email of purchaser (required for unassigned tickets)
     * @type {string}
     * @memberof CreateCheckoutIntentInput
     */
    'purchaser_email'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateCheckoutIntentInput
     */
    'user_id'?: string;
    /**
     * 
     * @type {GWYCInput}
     * @memberof CreateCheckoutIntentInput
     */
    'gwyc'?: GWYCInput;
}
/**
 * Input for creating a Stripe Connect Express account.
 * @export
 * @interface CreateConnectAccountInput
 */
export interface CreateConnectAccountInput {
    /**
     * Email for the account owner
     * @type {string}
     * @memberof CreateConnectAccountInput
     */
    'email': string;
    /**
     * Two-letter country code
     * @type {string}
     * @memberof CreateConnectAccountInput
     */
    'country'?: string;
    /**
     * Optional business name
     * @type {string}
     * @memberof CreateConnectAccountInput
     */
    'business_name'?: string;
}
/**
 * 
 * @export
 * @interface CreateEventInput
 */
export interface CreateEventInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateEventInput
     */
    'user_id': string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof CreateEventInput
     */
    'experience_type': ExperienceType;
    /**
     * 
     * @type {PermissionType}
     * @memberof CreateEventInput
     */
    'permission_type'?: PermissionType;
    /**
     * 
     * @type {string}
     * @memberof CreateEventInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventInput
     */
    'description'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateEventInput
     */
    'event_location_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventInput
     */
    'scheduled_end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventInput
     */
    'ticketing_platform_url'?: string;
}


/**
 * 
 * @export
 * @interface CreateEventLocationInput
 */
export interface CreateEventLocationInput {
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLocationInput
     */
    'wayfinding_instructions'?: string;
}
/**
 * 
 * @export
 * @interface CreateEventTagsInput
 */
export interface CreateEventTagsInput {
    /**
     * 
     * @type {Array<EventTag>}
     * @memberof CreateEventTagsInput
     */
    'event_tags': Array<EventTag>;
}
/**
 * Input for creating a gram social share.
 * @export
 * @interface CreateGramSocialShareInput
 */
export interface CreateGramSocialShareInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramSocialShareInput
     */
    'gram_storage_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramSocialShareInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramSocialShareInput
     */
    'session_id': string;
}
/**
 * Input for creating a gram with a specific template and storing it to AWS S3.
 * @export
 * @interface CreateGramWithSpecificTemplateInput
 */
export interface CreateGramWithSpecificTemplateInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramWithSpecificTemplateInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramWithSpecificTemplateInput
     */
    'event_id': string;
    /**
     * Google Drive folder ID containing the specific SVG template
     * @type {string}
     * @memberof CreateGramWithSpecificTemplateInput
     */
    'google_drive_folder_id': string;
    /**
     * Name of the specific SVG template file to use (e.g., \'template_001.svg\')
     * @type {string}
     * @memberof CreateGramWithSpecificTemplateInput
     */
    'template_name': string;
    /**
     * Output file format (PNG, JPEG, etc.)
     * @type {string}
     * @memberof CreateGramWithSpecificTemplateInput
     */
    'file_format'?: string;
}
/**
 * Input for creating a gram and storing it to AWS S3.
 * @export
 * @interface CreateGramWithStorageInput
 */
export interface CreateGramWithStorageInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramWithStorageInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGramWithStorageInput
     */
    'event_id': string;
    /**
     * Google Drive folder ID containing SVG templates
     * @type {string}
     * @memberof CreateGramWithStorageInput
     */
    'google_drive_folder_id': string;
    /**
     * Output file format (PNG, JPEG, etc.)
     * @type {string}
     * @memberof CreateGramWithStorageInput
     */
    'file_format'?: string;
}
/**
 * Input for creating a group promo editor relationship
 * @export
 * @interface CreateGroupPromoEditorInput
 */
export interface CreateGroupPromoEditorInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateGroupPromoEditorInput
     */
    'user_id': string;
}
/**
 * Input for creating a group promo
 * @export
 * @interface CreateGroupPromoInput
 */
export interface CreateGroupPromoInput {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupPromoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupPromoInput
     */
    'description'?: string;
}
/**
 * Input for creating an onboarding link.
 * @export
 * @interface CreateOnboardingLinkInput
 */
export interface CreateOnboardingLinkInput {
    /**
     * URL to redirect after onboarding completes
     * @type {string}
     * @memberof CreateOnboardingLinkInput
     */
    'return_url': string;
    /**
     * URL to redirect if link expires
     * @type {string}
     * @memberof CreateOnboardingLinkInput
     */
    'refresh_url': string;
}
/**
 * 
 * @export
 * @interface CreatePromoInput
 */
export interface CreatePromoInput {
    /**
     * 
     * @type {string}
     * @memberof CreatePromoInput
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreatePromoInput
     */
    'event_id': string;
    /**
     * 
     * @type {DiscountType}
     * @memberof CreatePromoInput
     */
    'discount_type': DiscountType;
    /**
     * 
     * @type {number}
     * @memberof CreatePromoInput
     */
    'discount': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromoInput
     */
    'is_stackable': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePromoInput
     */
    'max_uses'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePromoInput
     */
    'ticket_type_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreatePromoInput
     */
    'discount_code': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromoInput
     */
    'is_system_generated'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreatePromoInput
     */
    'group_promo_id'?: string;
}


/**
 * 
 * @export
 * @interface CreateRoomInput
 */
export interface CreateRoomInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateRoomInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateRoomInput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomInput
     */
    'start_date': string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof CreateRoomInput
     */
    'experience_type': ExperienceType;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomInput
     */
    'topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomInput
     */
    'topic_description': string;
}


/**
 * 
 * @export
 * @interface CreateRoomOutput
 */
export interface CreateRoomOutput {
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'created_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'modified_date'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'slug': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'scheduled_end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'actual_end_date'?: string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof CreateRoomOutput
     */
    'experience_type': ExperienceType;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'topic_description': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoomOutput
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoomOutput
     */
    'is_live'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomOutput
     */
    'url': string;
}


/**
 * 
 * @export
 * @interface CreateSessionCategoriesInput
 */
export interface CreateSessionCategoriesInput {
    /**
     * 
     * @type {SessionCategoryInput}
     * @memberof CreateSessionCategoriesInput
     */
    'session_categories': SessionCategoryInput;
}
/**
 * 
 * @export
 * @interface CreateSessionInput
 */
export interface CreateSessionInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateSessionInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateSessionInput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionInput
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionInput
     */
    'topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionInput
     */
    'topic_description': string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof CreateSessionInput
     */
    'status'?: SessionStatus;
}


/**
 * 
 * @export
 * @interface CreateSessionLocationInput
 */
export interface CreateSessionLocationInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionLocationInput
     */
    'wayfinding_instructions'?: string;
}
/**
 * 
 * @export
 * @interface CreateSessionTagsInput
 */
export interface CreateSessionTagsInput {
    /**
     * List of session-tag links to create
     * @type {Array<SessionTagInput>}
     * @memberof CreateSessionTagsInput
     */
    'session_tags': Array<SessionTagInput>;
}
/**
 * 
 * @export
 * @interface CreateTagInput
 */
export interface CreateTagInput {
    /**
     * Name of the tag
     * @type {string}
     * @memberof CreateTagInput
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTagInput
     */
    'event_id': string;
    /**
     * Optional description of the tag
     * @type {string}
     * @memberof CreateTagInput
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateTicketInput
 */
export interface CreateTicketInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketInput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketInput
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface CreateTicketReceiptInput
 */
export interface CreateTicketReceiptInput {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'email': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketReceiptInput
     */
    'original_price': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketReceiptInput
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof CreateTicketReceiptInput
     */
    'status'?: TicketReceiptStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'promo_code_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptInput
     */
    'promo_code'?: string;
}


/**
 * Response model for ticket receipt creation
 * @export
 * @interface CreateTicketReceiptOutput
 */
export interface CreateTicketReceiptOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketReceiptOutput
     */
    'receipt_id': string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof CreateTicketReceiptOutput
     */
    'status': TicketReceiptStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketReceiptOutput
     */
    'payment_intent_id'?: string;
}


/**
 * 
 * @export
 * @interface CreateTicketTokenOutput
 */
export interface CreateTicketTokenOutput {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketTokenOutput
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface CreateTicketTypeInput
 */
export interface CreateTicketTypeInput {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'description': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketTypeInput
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketTypeInput
     */
    'max_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'sale_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'sale_end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketTypeInput
     */
    'is_hidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketTypeInput
     */
    'is_waitlistable'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateTicketTypeInput
     */
    'form_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketTypeInput
     */
    'is_gwyc_type'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketTypeInput
     */
    'suggested_gwyc_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketTypeInput
     */
    'max_gwyc_amount'?: number;
}
/**
 * Input for creating a user promo relationship
 * @export
 * @interface CreateUserPromoInput
 */
export interface CreateUserPromoInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateUserPromoInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateUserPromoInput
     */
    'promo_id': string;
}
/**
 * 
 * @export
 * @interface CreateVideoRoomInput
 */
export interface CreateVideoRoomInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateVideoRoomInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateVideoRoomInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateVideoRoomInput
     */
    'room_id': string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof CreateVideoRoomInput
     */
    'experience_type': ExperienceType;
}


/**
 * Response model for ticket deactivation endpoint
 * @export
 * @interface DeactivateTicketOutput
 */
export interface DeactivateTicketOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeactivateTicketOutput
     */
    'ticket_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateTicketOutput
     */
    'is_active': boolean;
}
/**
 * Response model for event location deletion endpoint
 * @export
 * @interface DeleteEventLocationOutput
 */
export interface DeleteEventLocationOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteEventLocationOutput
     */
    'event_location_id': string;
}
/**
 * Response model for event deletion endpoint
 * @export
 * @interface DeleteEventOutput
 */
export interface DeleteEventOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteEventOutput
     */
    'event_id': string;
}
/**
 * Response model for group promo editor deletion by user and group IDs
 * @export
 * @interface DeleteGroupPromoEditorByUserAndGroupOutput
 */
export interface DeleteGroupPromoEditorByUserAndGroupOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteGroupPromoEditorByUserAndGroupOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteGroupPromoEditorByUserAndGroupOutput
     */
    'group_promo_id': string;
}
/**
 * Response model for group promo editor deletion endpoint
 * @export
 * @interface DeleteGroupPromoEditorOutput
 */
export interface DeleteGroupPromoEditorOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteGroupPromoEditorOutput
     */
    'group_promo_editor_id': string;
}
/**
 * Response model for group promo deletion endpoint
 * @export
 * @interface DeleteGroupPromoOutput
 */
export interface DeleteGroupPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteGroupPromoOutput
     */
    'group_promo_id': string;
}
/**
 * Response model for promo deletion endpoint
 * @export
 * @interface DeletePromoOutput
 */
export interface DeletePromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeletePromoOutput
     */
    'promo_id': string;
}
/**
 * Response model for session location deletion endpoint
 * @export
 * @interface DeleteSessionLocationOutput
 */
export interface DeleteSessionLocationOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteSessionLocationOutput
     */
    'session_location_id': string;
}
/**
 * Response model for ticket deletion endpoint
 * @export
 * @interface DeleteTicketOutput
 */
export interface DeleteTicketOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteTicketOutput
     */
    'ticket_id': string;
}
/**
 * Response model for user promo deletion by user and promo IDs
 * @export
 * @interface DeleteUserPromoByUserAndPromoOutput
 */
export interface DeleteUserPromoByUserAndPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteUserPromoByUserAndPromoOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteUserPromoByUserAndPromoOutput
     */
    'promo_id': string;
}
/**
 * Response model for user promo deletion endpoint
 * @export
 * @interface DeleteUserPromoOutput
 */
export interface DeleteUserPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteUserPromoOutput
     */
    'user_promo_id': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DiscountType = {
    Percent: 'percent',
    Fixed: 'fixed'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];


/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Event
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Event
     */
    'community_id': string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof Event
     */
    'experience_type': ExperienceType;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Event
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'scheduled_end_date'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Event
     */
    'event_location_id'?: string;
    /**
     * 
     * @type {PermissionType}
     * @memberof Event
     */
    'permission_type': PermissionType;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'ticketing_platform_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface EventLocation
 */
export interface EventLocation {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventLocation
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventLocation
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLocation
     */
    'wayfinding_instructions'?: string;
}
/**
 * Output for event revenue summary.
 * @export
 * @interface EventRevenueOutput
 */
export interface EventRevenueOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventRevenueOutput
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof EventRevenueOutput
     */
    'total_revenue': number;
    /**
     * 
     * @type {number}
     * @memberof EventRevenueOutput
     */
    'total_refunds': number;
    /**
     * 
     * @type {number}
     * @memberof EventRevenueOutput
     */
    'net_revenue': number;
}
/**
 * 
 * @export
 * @interface EventTag
 */
export interface EventTag {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventTag
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTag
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventTag
     */
    'event_id': string;
}
/**
 * Model for ticket count per event
 * @export
 * @interface EventTicketCount
 */
export interface EventTicketCount {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventTicketCount
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof EventTicketCount
     */
    'ticket_count': number;
}
/**
 * Response model for getting ticket counts across multiple events
 * @export
 * @interface EventTicketCountsResponse
 */
export interface EventTicketCountsResponse {
    /**
     * 
     * @type {Array<EventTicketCount>}
     * @memberof EventTicketCountsResponse
     */
    'events': Array<EventTicketCount>;
    /**
     * 
     * @type {number}
     * @memberof EventTicketCountsResponse
     */
    'total_events': number;
    /**
     * 
     * @type {number}
     * @memberof EventTicketCountsResponse
     */
    'total_tickets': number;
}
/**
 * Response model for all ticket summaries for an event
 * @export
 * @interface EventTicketSummariesOutput
 */
export interface EventTicketSummariesOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof EventTicketSummariesOutput
     */
    'event_id': string;
    /**
     * 
     * @type {Array<TicketTypeSummaryOutput>}
     * @memberof EventTicketSummariesOutput
     */
    'summaries': Array<TicketTypeSummaryOutput>;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ExperienceType = {
    Sunrise: 'SUNRISE',
    PrivateRoom: 'PRIVATE_ROOM',
    Topic: 'TOPIC',
    InPerson: 'IN_PERSON',
    Custom: 'CUSTOM',
    NoSession: 'NO_SESSION',
    MultiSession: 'MULTI_SESSION',
    SingleSession: 'SINGLE_SESSION'
} as const;

export type ExperienceType = typeof ExperienceType[keyof typeof ExperienceType];


/**
 * Give What You Can contribution for the transaction.  Optional additional contribution at checkout level (single per transaction). The ticket_type_id must reference a ticket type with is_gwyc_type=True.
 * @export
 * @interface GWYCInput
 */
export interface GWYCInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GWYCInput
     */
    'ticket_type_id': string;
    /**
     * Contribution amount chosen by user
     * @type {number}
     * @memberof GWYCInput
     */
    'amount': number;
}
/**
 * Generated promo code for an unassigned ticket.
 * @export
 * @interface GeneratedPromoCodeOutput
 */
export interface GeneratedPromoCodeOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GeneratedPromoCodeOutput
     */
    'promo_id': string;
    /**
     * 
     * @type {string}
     * @memberof GeneratedPromoCodeOutput
     */
    'discount_code': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GeneratedPromoCodeOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof GeneratedPromoCodeOutput
     */
    'ticket_type_name'?: string;
}
/**
 * 
 * @export
 * @interface GetSessionsByCategoriesInput
 */
export interface GetSessionsByCategoriesInput {
    /**
     * List of category IDs to search for
     * @type {Array<string>}
     * @memberof GetSessionsByCategoriesInput
     */
    'category_ids': Array<string>;
    /**
     * If True, return sessions that have all the specified categories
     * @type {boolean}
     * @memberof GetSessionsByCategoriesInput
     */
    'match_all'?: boolean;
}
/**
 * 
 * @export
 * @interface GetSessionsByTagsInput
 */
export interface GetSessionsByTagsInput {
    /**
     * List of tag IDs to search for
     * @type {Array<string>}
     * @memberof GetSessionsByTagsInput
     */
    'tag_ids': Array<string>;
    /**
     * If True, return sessions that have all the specified tags
     * @type {boolean}
     * @memberof GetSessionsByTagsInput
     */
    'match_all'?: boolean;
}
/**
 * 
 * @export
 * @interface GetSessionsByTagsOrCategoriesInput
 */
export interface GetSessionsByTagsOrCategoriesInput {
    /**
     * List of tag IDs to search for
     * @type {Array<string>}
     * @memberof GetSessionsByTagsOrCategoriesInput
     */
    'tag_ids'?: Array<string>;
    /**
     * List of category IDs to search for
     * @type {Array<string>}
     * @memberof GetSessionsByTagsOrCategoriesInput
     */
    'category_ids'?: Array<string>;
    /**
     * If True, sessions must have all specified tags
     * @type {boolean}
     * @memberof GetSessionsByTagsOrCategoriesInput
     */
    'match_all_tags'?: boolean;
    /**
     * If True, sessions must have all specified categories
     * @type {boolean}
     * @memberof GetSessionsByTagsOrCategoriesInput
     */
    'match_all_categories'?: boolean;
}
/**
 * 
 * @export
 * @interface GetSessionsByViewTypeInput
 */
export interface GetSessionsByViewTypeInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetSessionsByViewTypeInput
     */
    'event_id': string;
    /**
     * 
     * @type {ViewType}
     * @memberof GetSessionsByViewTypeInput
     */
    'view_type': ViewType;
}


/**
 * 
 * @export
 * @interface GetTicketOutput
 */
export interface GetTicketOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetTicketOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetTicketOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetTicketOutput
     */
    'organization_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetTicketOutput
     */
    'event_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTicketOutput
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTicketOutput
     */
    'is_checked_in'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GetTicketOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTicketOutput
     */
    'token'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTicketOutput
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof GetTicketOutput
     */
    'created_date'?: string;
}
/**
 * Output model for acknowledging gram creation requests that will be processed asynchronously.
 * @export
 * @interface GramCreationAcknowledgmentOutput
 */
export interface GramCreationAcknowledgmentOutput {
    /**
     * 
     * @type {string}
     * @memberof GramCreationAcknowledgmentOutput
     */
    'message': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramCreationAcknowledgmentOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramCreationAcknowledgmentOutput
     */
    'event_id': string;
}
/**
 * Output model for gram social share information.
 * @export
 * @interface GramSocialShareOutput
 */
export interface GramSocialShareOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareOutput
     */
    'gram_storage_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareOutput
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof GramSocialShareOutput
     */
    'slug': string;
}
/**
 * Output model for gram social share with associated storage information.
 * @export
 * @interface GramSocialShareWithStorageOutput
 */
export interface GramSocialShareWithStorageOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'gram_storage_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'slug': string;
    /**
     * 
     * @type {GramStorageUrlOutput}
     * @memberof GramSocialShareWithStorageOutput
     */
    'gram_storage': GramStorageUrlOutput;
    /**
     * 
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'session_topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof GramSocialShareWithStorageOutput
     */
    'session_topic_description': string;
}
/**
 * Output model for gram storage information.
 * @export
 * @interface GramStorageOutput
 */
export interface GramStorageOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageOutput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageOutput
     */
    'aws_file_key': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageOutput
     */
    'file_format': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageOutput
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageOutput
     */
    'google_drive_folder_id': string;
}
/**
 * Output model for gram storage with temporary AWS URL.
 * @export
 * @interface GramStorageUrlOutput
 */
export interface GramStorageUrlOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'file_format': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof GramStorageUrlOutput
     */
    'aws_file_url': string;
}
/**
 * Output model for GroupPromoEditor records
 * @export
 * @interface GroupPromoEditorOutput
 */
export interface GroupPromoEditorOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GroupPromoEditorOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GroupPromoEditorOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GroupPromoEditorOutput
     */
    'group_promo_id': string;
}
/**
 * Metadata-only output for GroupPromo (used in bulk listings)
 * @export
 * @interface GroupPromoMetadataOutput
 */
export interface GroupPromoMetadataOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GroupPromoMetadataOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof GroupPromoMetadataOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPromoMetadataOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPromoMetadataOutput
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPromoMetadataOutput
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface JoinRoomInput
 */
export interface JoinRoomInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof JoinRoomInput
     */
    'room_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof JoinRoomInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface JoinRoomOutput
 */
export interface JoinRoomOutput {
    /**
     * 
     * @type {string}
     * @memberof JoinRoomOutput
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface JoinSessionInput
 */
export interface JoinSessionInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof JoinSessionInput
     */
    'user_id': string;
    /**
     * 
     * @type {SessionAttendeeRole}
     * @memberof JoinSessionInput
     */
    'role'?: SessionAttendeeRole;
}


/**
 * 
 * @export
 * @interface LeaveRoomInput
 */
export interface LeaveRoomInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LeaveRoomInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LeaveRoomInput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LeaveRoomInput
     */
    'room_id': string;
}
/**
 * Output for community ledger balance.
 * @export
 * @interface LedgerBalanceOutput
 */
export interface LedgerBalanceOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LedgerBalanceOutput
     */
    'community_id': string;
    /**
     * 
     * @type {number}
     * @memberof LedgerBalanceOutput
     */
    'total_credits': number;
    /**
     * 
     * @type {number}
     * @memberof LedgerBalanceOutput
     */
    'total_debits': number;
    /**
     * 
     * @type {number}
     * @memberof LedgerBalanceOutput
     */
    'available_balance': number;
    /**
     * 
     * @type {number}
     * @memberof LedgerBalanceOutput
     */
    'pending_payout': number;
}
/**
 * Output for a single ledger entry.
 * @export
 * @interface LedgerEntryOutput
 */
export interface LedgerEntryOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'id': string;
    /**
     * 
     * @type {LedgerEntryType}
     * @memberof LedgerEntryOutput
     */
    'entry_type': LedgerEntryType;
    /**
     * 
     * @type {LedgerEntrySource}
     * @memberof LedgerEntryOutput
     */
    'source': LedgerEntrySource;
    /**
     * 
     * @type {number}
     * @memberof LedgerEntryOutput
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof LedgerEntryOutput
     */
    'balance_after': number;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'reference_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'reference_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'description'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerEntryOutput
     */
    'created_date': string;
}


/**
 * Source of a ledger entry.
 * @export
 * @enum {string}
 */

export const LedgerEntrySource = {
    TicketSale: 'ticket_sale',
    Payout: 'payout',
    Refund: 'refund',
    Adjustment: 'adjustment',
    PlatformFee: 'platform_fee',
    StripeFee: 'stripe_fee',
    Dispute: 'dispute',
    DisputeReversal: 'dispute_reversal',
    ExternalRefund: 'external_refund'
} as const;

export type LedgerEntrySource = typeof LedgerEntrySource[keyof typeof LedgerEntrySource];


/**
 * Type of ledger entry.
 * @export
 * @enum {string}
 */

export const LedgerEntryType = {
    Credit: 'credit',
    Debit: 'debit'
} as const;

export type LedgerEntryType = typeof LedgerEntryType[keyof typeof LedgerEntryType];


/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * Output for onboarding link creation.
 * @export
 * @interface OnboardingLinkOutput
 */
export interface OnboardingLinkOutput {
    /**
     * 
     * @type {string}
     * @memberof OnboardingLinkOutput
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingLinkOutput
     */
    'expires_at': string;
}
/**
 * Paginated output for ledger entries.
 * @export
 * @interface PaginatedLedgerEntriesOutput
 */
export interface PaginatedLedgerEntriesOutput {
    /**
     * 
     * @type {number}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'limit': number;
    /**
     * 
     * @type {Array<LedgerEntryOutput>}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'results': Array<LedgerEntryOutput>;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLedgerEntriesOutput
     */
    'previous'?: string;
}
/**
 * Paginated output for payouts.
 * @export
 * @interface PaginatedPayoutsOutput
 */
export interface PaginatedPayoutsOutput {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPayoutsOutput
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPayoutsOutput
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPayoutsOutput
     */
    'limit': number;
    /**
     * 
     * @type {Array<PayoutOutput>}
     * @memberof PaginatedPayoutsOutput
     */
    'results': Array<PayoutOutput>;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPayoutsOutput
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPayoutsOutput
     */
    'previous'?: string;
}
/**
 * Output for a single payout.
 * @export
 * @interface PayoutOutput
 */
export interface PayoutOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PayoutOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PayoutOutput
     */
    'community_id': string;
    /**
     * 
     * @type {number}
     * @memberof PayoutOutput
     */
    'amount': number;
    /**
     * 
     * @type {PayoutStatus}
     * @memberof PayoutOutput
     */
    'status': PayoutStatus;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'requested_at': string;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'processed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'stripe_transfer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'initiated_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutOutput
     */
    'failure_reason'?: string;
}


/**
 * Status of a payout.
 * @export
 * @enum {string}
 */

export const PayoutStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PermissionType = {
    Public: 'public',
    Private: 'private',
    Protected: 'protected'
} as const;

export type PermissionType = typeof PermissionType[keyof typeof PermissionType];


/**
 * Input for processing a payout (admin).
 * @export
 * @interface ProcessPayoutInput
 */
export interface ProcessPayoutInput {
    /**
     * Stripe transfer ID if using Stripe Connect
     * @type {string}
     * @memberof ProcessPayoutInput
     */
    'stripe_transfer_id'?: string;
}
/**
 * 
 * @export
 * @interface Promo
 */
export interface Promo {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Promo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Promo
     */
    'event_id': string;
    /**
     * 
     * @type {DiscountType}
     * @memberof Promo
     */
    'discount_type': DiscountType;
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'discount_code': string;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'discount': number;
    /**
     * 
     * @type {boolean}
     * @memberof Promo
     */
    'is_stackable': boolean;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'max_uses'?: number;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'num_times_used'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Promo
     */
    'is_system_generated'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Promo
     */
    'group_promo_id'?: string;
    /**
     * 
     * @type {Array<TicketType>}
     * @memberof Promo
     */
    'ticket_types': Array<TicketType>;
    /**
     * 
     * @type {boolean}
     * @memberof Promo
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface PromoWithReceipts
 */
export interface PromoWithReceipts {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PromoWithReceipts
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoWithReceipts
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PromoWithReceipts
     */
    'event_id': string;
    /**
     * 
     * @type {DiscountType}
     * @memberof PromoWithReceipts
     */
    'discount_type': DiscountType;
    /**
     * 
     * @type {string}
     * @memberof PromoWithReceipts
     */
    'discount_code': string;
    /**
     * 
     * @type {number}
     * @memberof PromoWithReceipts
     */
    'discount': number;
    /**
     * 
     * @type {boolean}
     * @memberof PromoWithReceipts
     */
    'is_stackable': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromoWithReceipts
     */
    'max_uses'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoWithReceipts
     */
    'num_times_used'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PromoWithReceipts
     */
    'is_system_generated'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PromoWithReceipts
     */
    'group_promo_id'?: string;
    /**
     * 
     * @type {Array<TicketType>}
     * @memberof PromoWithReceipts
     */
    'ticket_types': Array<TicketType>;
    /**
     * 
     * @type {Array<Receipt>}
     * @memberof PromoWithReceipts
     */
    'receipts'?: Array<Receipt>;
    /**
     * 
     * @type {boolean}
     * @memberof PromoWithReceipts
     */
    'is_active'?: boolean;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PublicExperienceInput = {
    Sunrise: 'SUNRISE',
    Topic: 'TOPIC',
    Custom: 'CUSTOM'
} as const;

export type PublicExperienceInput = typeof PublicExperienceInput[keyof typeof PublicExperienceInput];


/**
 * 
 * @export
 * @interface PublicTicket
 */
export interface PublicTicket {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PublicTicket
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PublicTicket
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PublicTicket
     */
    'event_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTicket
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTicket
     */
    'is_checked_in'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PublicTicket
     */
    'ticket_type_id': string;
}
/**
 * 
 * @export
 * @interface RaisedHand
 */
export interface RaisedHand {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RaisedHand
     */
    'user_id': string;
}
/**
 * Receipt for a checkout transaction - one per checkout.
 * @export
 * @interface Receipt
 */
export interface Receipt {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Receipt
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Receipt
     */
    'checkout_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Receipt
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof Receipt
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Receipt
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Receipt
     */
    'last_name'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Receipt
     */
    'user_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Receipt
     */
    'total_amount': number;
    /**
     * 
     * @type {string}
     * @memberof Receipt
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof Receipt
     */
    'status'?: TicketReceiptStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Receipt
     */
    'promo_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Receipt
     */
    'promo_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Receipt
     */
    'is_active'?: boolean;
}


/**
 * Output model for receipt line item.
 * @export
 * @interface ReceiptLineItemOutput
 */
export interface ReceiptLineItemOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptLineItemOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptLineItemOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof ReceiptLineItemOutput
     */
    'original_price': number;
    /**
     * 
     * @type {number}
     * @memberof ReceiptLineItemOutput
     */
    'final_price': number;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptLineItemOutput
     */
    'promo_applied': boolean;
    /**
     * 
     * @type {ReceiptLineItemStatus}
     * @memberof ReceiptLineItemOutput
     */
    'status': ReceiptLineItemStatus;
}


/**
 * Status enum for individual receipt line items
 * @export
 * @enum {string}
 */

export const ReceiptLineItemStatus = {
    Active: 'active',
    Refunded: 'refunded',
    Cancelled: 'cancelled'
} as const;

export type ReceiptLineItemStatus = typeof ReceiptLineItemStatus[keyof typeof ReceiptLineItemStatus];


/**
 * Output model for receipt (v2 - new model).
 * @export
 * @interface ReceiptOutput
 */
export interface ReceiptOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'checkout_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptOutput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'last_name'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptOutput
     */
    'user_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceiptOutput
     */
    'total_amount': number;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof ReceiptOutput
     */
    'status': TicketReceiptStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReceiptOutput
     */
    'promo_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptOutput
     */
    'promo_code'?: string;
    /**
     * 
     * @type {Array<ReceiptLineItemOutput>}
     * @memberof ReceiptOutput
     */
    'line_items'?: Array<ReceiptLineItemOutput>;
}


/**
 * Input for recording a manual adjustment (admin).
 * @export
 * @interface RecordAdjustmentInput
 */
export interface RecordAdjustmentInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RecordAdjustmentInput
     */
    'community_id': string;
    /**
     * Adjustment amount
     * @type {number}
     * @memberof RecordAdjustmentInput
     */
    'amount': number;
    /**
     * True for credit, False for debit
     * @type {boolean}
     * @memberof RecordAdjustmentInput
     */
    'is_credit': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecordAdjustmentInput
     */
    'description': string;
}
/**
 * Single line item to refund - must provide ticket_type_id and either ticket_id or promo_id
 * @export
 * @interface RefundLineItemInput
 */
export interface RefundLineItemInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundLineItemInput
     */
    'ticket_type_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundLineItemInput
     */
    'ticket_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundLineItemInput
     */
    'promo_id'?: string;
}
/**
 * Enum for ticket refund reasons
 * @export
 * @enum {string}
 */

export const RefundReason = {
    RequestedByCustomer: 'requested_by_customer',
    EventCancelled: 'event_cancelled',
    Duplicate: 'duplicate',
    Fraudulent: 'fraudulent',
    Other: 'other'
} as const;

export type RefundReason = typeof RefundReason[keyof typeof RefundReason];


/**
 * Input model for refunding a receipt
 * @export
 * @interface RefundReceiptInput
 */
export interface RefundReceiptInput {
    /**
     * 
     * @type {RefundReason}
     * @memberof RefundReceiptInput
     */
    'reason'?: RefundReason;
    /**
     * List of line items to refund with their associated ticket or promo to deactivate
     * @type {Array<RefundLineItemInput>}
     * @memberof RefundReceiptInput
     */
    'line_items': Array<RefundLineItemInput>;
}


/**
 * Response model for receipt refund
 * @export
 * @interface RefundReceiptOutput
 */
export interface RefundReceiptOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundReceiptOutput
     */
    'receipt_id': string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof RefundReceiptOutput
     */
    'status': TicketReceiptStatus;
    /**
     * 
     * @type {string}
     * @memberof RefundReceiptOutput
     */
    'refund_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RefundReceiptOutput
     */
    'tickets_deactivated'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RefundReceiptOutput
     */
    'promos_deactivated'?: Array<string>;
}


/**
 * Input model for refunding a ticket (legacy - uses ticket_id in path)
 * @export
 * @interface RefundTicketInput
 */
export interface RefundTicketInput {
    /**
     * 
     * @type {RefundReason}
     * @memberof RefundTicketInput
     */
    'reason'?: RefundReason;
}


/**
 * Response model for ticket refund
 * @export
 * @interface RefundTicketOutput
 */
export interface RefundTicketOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundTicketOutput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RefundTicketOutput
     */
    'receipt_id': string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof RefundTicketOutput
     */
    'status': TicketReceiptStatus;
    /**
     * 
     * @type {string}
     * @memberof RefundTicketOutput
     */
    'refund_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefundTicketOutput
     */
    'refunded_at': string;
}


/**
 * Input for requesting a payout.
 * @export
 * @interface RequestPayoutInput
 */
export interface RequestPayoutInput {
    /**
     * Amount to payout (max $3,000)
     * @type {number}
     * @memberof RequestPayoutInput
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof RequestPayoutInput
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'created_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'modified_date'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Room
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Room
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'slug': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Room
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'scheduled_end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'actual_end_date'?: string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof Room
     */
    'experience_type': ExperienceType;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'topic_description': string;
    /**
     * 
     * @type {boolean}
     * @memberof Room
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Room
     */
    'is_live'?: boolean;
}


/**
 * 
 * @export
 * @interface RoomAttendee
 */
export interface RoomAttendee {
    /**
     * 
     * @type {string}
     * @memberof RoomAttendee
     */
    'created_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomAttendee
     */
    'modified_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoomAttendee
     */
    'is_active': boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RoomAttendee
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RoomAttendee
     */
    'room_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RoomAttendee
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RoomAttendee
     */
    'event_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof RoomAttendee
     */
    'is_host': boolean;
}
/**
 * 
 * @export
 * @interface RoomStatsOutput
 */
export interface RoomStatsOutput {
    /**
     * 
     * @type {Room}
     * @memberof RoomStatsOutput
     */
    'room': Room;
    /**
     * 
     * @type {number}
     * @memberof RoomStatsOutput
     */
    'attendee_count': number;
}
/**
 * 
 * @export
 * @interface SessionAttendee
 */
export interface SessionAttendee {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendee
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendee
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendee
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendee
     */
    'session_id': string;
    /**
     * 
     * @type {SessionAttendeeRole}
     * @memberof SessionAttendee
     */
    'role': SessionAttendeeRole;
    /**
     * 
     * @type {boolean}
     * @memberof SessionAttendee
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface SessionAttendeeCountOutput
 */
export interface SessionAttendeeCountOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendeeCountOutput
     */
    'session_id': string;
    /**
     * 
     * @type {number}
     * @memberof SessionAttendeeCountOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SessionAttendeeOutput
 */
export interface SessionAttendeeOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendeeOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendeeOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendeeOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionAttendeeOutput
     */
    'session_id': string;
    /**
     * 
     * @type {SessionAttendeeRole}
     * @memberof SessionAttendeeOutput
     */
    'role': SessionAttendeeRole;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const SessionAttendeeRole = {
    Speaker: 'speaker',
    Moderator: 'moderator',
    Attendee: 'attendee'
} as const;

export type SessionAttendeeRole = typeof SessionAttendeeRole[keyof typeof SessionAttendeeRole];


/**
 * 
 * @export
 * @interface SessionAttendeesOutput
 */
export interface SessionAttendeesOutput {
    /**
     * 
     * @type {Array<SessionAttendeeOutput>}
     * @memberof SessionAttendeesOutput
     */
    'attendees': Array<SessionAttendeeOutput>;
}
/**
 * 
 * @export
 * @interface SessionCategoriesOutput
 */
export interface SessionCategoriesOutput {
    /**
     * 
     * @type {Array<SessionCategory>}
     * @memberof SessionCategoriesOutput
     */
    'session_categories': Array<SessionCategory>;
}
/**
 * 
 * @export
 * @interface SessionCategory
 */
export interface SessionCategory {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionCategory
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionCategory
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionCategory
     */
    'category_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionCategory
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface SessionCategoryInput
 */
export interface SessionCategoryInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionCategoryInput
     */
    'session_id': string;
    /**
     * List of category IDs to assign to the session
     * @type {Array<string>}
     * @memberof SessionCategoryInput
     */
    'category_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SessionDataOutput
 */
export interface SessionDataOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionDataOutput
     */
    'session_id': string;
    /**
     * 
     * @type {BulkSessionData}
     * @memberof SessionDataOutput
     */
    'data': BulkSessionData;
}
/**
 * 
 * @export
 * @interface SessionFavoriteCountOutput
 */
export interface SessionFavoriteCountOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionFavoriteCountOutput
     */
    'session_id': string;
    /**
     * 
     * @type {number}
     * @memberof SessionFavoriteCountOutput
     */
    'favorite_count': number;
}
/**
 * 
 * @export
 * @interface SessionFavoriteInput
 */
export interface SessionFavoriteInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionFavoriteInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SessionFavoriteOutput
 */
export interface SessionFavoriteOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionFavoriteOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionFavoriteOutput
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionFavoriteOutput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SessionFavoritesOutput
 */
export interface SessionFavoritesOutput {
    /**
     * 
     * @type {Array<SessionFavoriteOutput>}
     * @memberof SessionFavoritesOutput
     */
    'favorites': Array<SessionFavoriteOutput>;
}
/**
 * 
 * @export
 * @interface SessionLocation
 */
export interface SessionLocation {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionLocation
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionLocation
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocation
     */
    'wayfinding_instructions'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionLocation
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface SessionLocationOutput
 */
export interface SessionLocationOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionLocationOutput
     */
    'wayfinding_instructions'?: string;
}
/**
 * 
 * @export
 * @interface SessionOutput
 */
export interface SessionOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionOutput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionOutput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionOutput
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionOutput
     */
    'topic_name': string;
    /**
     * 
     * @type {string}
     * @memberof SessionOutput
     */
    'topic_description': string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionOutput
     */
    'status': SessionStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionOutput
     */
    'location_id'?: string;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const SessionStatus = {
    AwaitingReview: 'awaiting_review',
    Accepted: 'accepted',
    Voting: 'voting',
    Scheduled: 'scheduled',
    Confirmed: 'confirmed',
    Rejected: 'rejected'
} as const;

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


/**
 * 
 * @export
 * @interface SessionTag
 */
export interface SessionTag {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionTag
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionTag
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionTag
     */
    'tag_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionTag
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface SessionTagInput
 */
export interface SessionTagInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionTagInput
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionTagInput
     */
    'tag_id': string;
}
/**
 * 
 * @export
 * @interface SessionTagsOutput
 */
export interface SessionTagsOutput {
    /**
     * 
     * @type {Array<SessionTag>}
     * @memberof SessionTagsOutput
     */
    'session_tags': Array<SessionTag>;
}
/**
 * 
 * @export
 * @interface SessionViewedListOutput
 */
export interface SessionViewedListOutput {
    /**
     * 
     * @type {Array<SessionViewedOutput>}
     * @memberof SessionViewedListOutput
     */
    'viewed_sessions': Array<SessionViewedOutput>;
}
/**
 * 
 * @export
 * @interface SessionViewedOutput
 */
export interface SessionViewedOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionViewedOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionViewedOutput
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionViewedOutput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SessionVoteAnalyticsInput
 */
export interface SessionVoteAnalyticsInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteAnalyticsInput
     */
    'event_id': string;
    /**
     * Start date for analytics range (YYYY-MM-DD)
     * @type {string}
     * @memberof SessionVoteAnalyticsInput
     */
    'start_date': string;
    /**
     * End date for analytics range (YYYY-MM-DD)
     * @type {string}
     * @memberof SessionVoteAnalyticsInput
     */
    'end_date': string;
}
/**
 * 
 * @export
 * @interface SessionVoteAnalyticsOutput
 */
export interface SessionVoteAnalyticsOutput {
    /**
     * Daily vote counts for the requested date range
     * @type {Array<SessionVoteDailyCount>}
     * @memberof SessionVoteAnalyticsOutput
     */
    'daily_counts': Array<SessionVoteDailyCount>;
    /**
     * Total votes across the entire date range
     * @type {number}
     * @memberof SessionVoteAnalyticsOutput
     */
    'total_votes': number;
    /**
     * Number of days in the requested range
     * @type {number}
     * @memberof SessionVoteAnalyticsOutput
     */
    'date_range_days': number;
}
/**
 * 
 * @export
 * @interface SessionVoteCountOutput
 */
export interface SessionVoteCountOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteCountOutput
     */
    'session_id': string;
    /**
     * 
     * @type {number}
     * @memberof SessionVoteCountOutput
     */
    'vote_count': number;
}
/**
 * 
 * @export
 * @interface SessionVoteDailyCount
 */
export interface SessionVoteDailyCount {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof SessionVoteDailyCount
     */
    'date': string;
    /**
     * Number of votes on this date
     * @type {number}
     * @memberof SessionVoteDailyCount
     */
    'vote_count': number;
}
/**
 * 
 * @export
 * @interface SessionVoteInput
 */
export interface SessionVoteInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SessionVoteOutput
 */
export interface SessionVoteOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteOutput
     */
    'session_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionVoteOutput
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionVoteOutput
     */
    'is_active': boolean;
}
/**
 * 
 * @export
 * @interface SessionVotesOutput
 */
export interface SessionVotesOutput {
    /**
     * 
     * @type {Array<SessionVoteOutput>}
     * @memberof SessionVotesOutput
     */
    'votes': Array<SessionVoteOutput>;
}
/**
 * 
 * @export
 * @interface SessionsByEventOutput
 */
export interface SessionsByEventOutput {
    /**
     * 
     * @type {Array<SessionOutput>}
     * @memberof SessionsByEventOutput
     */
    'sessions': Array<SessionOutput>;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SessionsByEventOutput
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof SessionsByEventOutput
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface SessionsByViewTypeOutput
 */
export interface SessionsByViewTypeOutput {
    /**
     * 
     * @type {Array<SessionOutput>}
     * @memberof SessionsByViewTypeOutput
     */
    'sessions': Array<SessionOutput>;
    /**
     * 
     * @type {string}
     * @memberof SessionsByViewTypeOutput
     */
    'view_type': string;
    /**
     * 
     * @type {number}
     * @memberof SessionsByViewTypeOutput
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface SessionsOutput
 */
export interface SessionsOutput {
    /**
     * 
     * @type {Array<SessionOutput>}
     * @memberof SessionsOutput
     */
    'sessions': Array<SessionOutput>;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Tag
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'name': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Tag
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tag
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface TagOutput
 */
export interface TagOutput {
    /**
     * 
     * @type {Tag}
     * @memberof TagOutput
     */
    'tag': Tag;
}
/**
 * 
 * @export
 * @interface TagsOutput
 */
export interface TagsOutput {
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TagsOutput
     */
    'tags': Array<Tag>;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const TemporalRelation = {
    Future: 'future',
    Past: 'past'
} as const;

export type TemporalRelation = typeof TemporalRelation[keyof typeof TemporalRelation];


/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Ticket
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Ticket
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Ticket
     */
    'event_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     */
    'is_checked_in'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Ticket
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'token'?: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'created_date'?: string;
}
/**
 * 
 * @export
 * @interface TicketCheckoutData
 */
export interface TicketCheckoutData {
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutData
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutData
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutData
     */
    'email': string;
}
/**
 * Response model for ticket export endpoint (supports multi-event).
 * @export
 * @interface TicketExportResponse
 */
export interface TicketExportResponse {
    /**
     * 
     * @type {string}
     * @memberof TicketExportResponse
     */
    'file_url': string;
    /**
     * 
     * @type {string}
     * @memberof TicketExportResponse
     */
    'created_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketExportResponse
     */
    'event_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TicketExportResponse
     */
    'total_events': number;
    /**
     * 
     * @type {number}
     * @memberof TicketExportResponse
     */
    'total_tickets': number;
}
/**
 * Output model for ticket receipt
 * @export
 * @interface TicketReceiptOutput
 */
export interface TicketReceiptOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'email': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'ticket_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof TicketReceiptOutput
     */
    'original_price': number;
    /**
     * 
     * @type {number}
     * @memberof TicketReceiptOutput
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'payment_intent_id'?: string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof TicketReceiptOutput
     */
    'status': TicketReceiptStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'promo_code_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketReceiptOutput
     */
    'promo_code'?: string;
}


/**
 * Status enum for ticket receipt payment states
 * @export
 * @enum {string}
 */

export const TicketReceiptStatus = {
    Pending: 'pending',
    Paid: 'paid',
    PaymentDenied: 'payment_denied',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    PartiallyRefunded: 'partially_refunded',
    RefundPending: 'refund_pending',
    RefundFailed: 'refund_failed',
    Failed: 'failed'
} as const;

export type TicketReceiptStatus = typeof TicketReceiptStatus[keyof typeof TicketReceiptStatus];


/**
 * 
 * @export
 * @interface TicketTransferOutput
 */
export interface TicketTransferOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTransferOutput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTransferOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTransferOutput
     */
    'recipient_email': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTransferOutput
     */
    'recipient_user_id': string;
}
/**
 * 
 * @export
 * @interface TicketType
 */
export interface TicketType {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketType
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketType
     */
    'description': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketType
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof TicketType
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof TicketType
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketType
     */
    'max_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof TicketType
     */
    'sale_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketType
     */
    'sale_end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketType
     */
    'is_hidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketType
     */
    'is_waitlistable'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketType
     */
    'form_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketType
     */
    'is_gwyc_type'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketType
     */
    'suggested_gwyc_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketType
     */
    'max_gwyc_amount'?: number;
}
/**
 * Response model for ticket type operations
 * @export
 * @interface TicketTypeOutput
 */
export interface TicketTypeOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'description': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeOutput
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTypeOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeOutput
     */
    'max_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'sale_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'sale_end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTypeOutput
     */
    'is_hidden': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTypeOutput
     */
    'is_waitlistable': boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTypeOutput
     */
    'form_id'?: string;
}
/**
 * 
 * @export
 * @interface TicketTypeSummaryOutput
 */
export interface TicketTypeSummaryOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TicketTypeSummaryOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeSummaryOutput
     */
    'sold_count': number;
}
/**
 * 
 * @export
 * @interface TransferTicketInput
 */
export interface TransferTicketInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TransferTicketInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TransferTicketInput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TransferTicketInput
     */
    'ticket_id': string;
    /**
     * 
     * @type {TicketCheckoutData}
     * @memberof TransferTicketInput
     */
    'receiver_ticket': TicketCheckoutData;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof TransferTicketInput
     */
    'community_id': string;
}
/**
 * Ticket without attendee info - will generate a promo code for later redemption.  Used when purchaser buys tickets for friends but doesn\'t have their info yet. Each unassigned ticket generates a single-use 100% discount promo code.
 * @export
 * @interface UnassignedTicketInput
 */
export interface UnassignedTicketInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UnassignedTicketInput
     */
    'ticket_type_id': string;
    /**
     * Number of unassigned tickets of this type
     * @type {number}
     * @memberof UnassignedTicketInput
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCategoryInput
 */
export interface UpdateCategoryInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryInput
     */
    'name'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateCategoryInput
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryInput
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEventCommunityInput
 */
export interface UpdateEventCommunityInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateEventCommunityInput
     */
    'new_community_id': string;
}
/**
 * 
 * @export
 * @interface UpdateEventInput
 */
export interface UpdateEventInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateEventInput
     */
    'user_id'?: string;
    /**
     * 
     * @type {ExperienceType}
     * @memberof UpdateEventInput
     */
    'experience_type'?: ExperienceType;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventInput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventInput
     */
    'scheduled_end_date'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateEventInput
     */
    'event_location_id'?: string;
    /**
     * 
     * @type {PermissionType}
     * @memberof UpdateEventInput
     */
    'permission_type'?: PermissionType;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventInput
     */
    'ticketing_platform_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEventInput
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdateEventLocationInput
 */
export interface UpdateEventLocationInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventLocationInput
     */
    'wayfinding_instructions'?: string;
}
/**
 * Input for updating a group promo (all fields optional for partial updates)
 * @export
 * @interface UpdateGroupPromoInput
 */
export interface UpdateGroupPromoInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupPromoInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupPromoInput
     */
    'description'?: string;
}
/**
 * Input for updating payout schedule.
 * @export
 * @interface UpdatePayoutScheduleInput
 */
export interface UpdatePayoutScheduleInput {
    /**
     * \'daily\', \'weekly\', or \'monthly\'
     * @type {string}
     * @memberof UpdatePayoutScheduleInput
     */
    'interval': string;
    /**
     * Day of week for weekly payouts
     * @type {string}
     * @memberof UpdatePayoutScheduleInput
     */
    'weekly_anchor'?: string;
    /**
     * Day of month for monthly
     * @type {number}
     * @memberof UpdatePayoutScheduleInput
     */
    'monthly_anchor'?: number;
}
/**
 * Input for updating platform fee percentage.
 * @export
 * @interface UpdatePlatformFeeInput
 */
export interface UpdatePlatformFeeInput {
    /**
     * Platform fee percentage (0-100)
     * @type {number}
     * @memberof UpdatePlatformFeeInput
     */
    'platform_fee_percent': number;
}
/**
 * Input for updating a promo. Event cannot be changed once set, so event_id is omitted. All fields are optional for partial update semantics.
 * @export
 * @interface UpdatePromoInput
 */
export interface UpdatePromoInput {
    /**
     * 
     * @type {string}
     * @memberof UpdatePromoInput
     */
    'name'?: string;
    /**
     * 
     * @type {DiscountType}
     * @memberof UpdatePromoInput
     */
    'discount_type'?: DiscountType;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromoInput
     */
    'discount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePromoInput
     */
    'is_stackable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromoInput
     */
    'max_uses'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePromoInput
     */
    'ticket_type_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromoInput
     */
    'discount_code'?: string;
}


/**
 * 
 * @export
 * @interface UpdateSessionAttendeeRoleInput
 */
export interface UpdateSessionAttendeeRoleInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateSessionAttendeeRoleInput
     */
    'attendee_id': string;
    /**
     * 
     * @type {SessionAttendeeRole}
     * @memberof UpdateSessionAttendeeRoleInput
     */
    'role': SessionAttendeeRole;
}


/**
 * 
 * @export
 * @interface UpdateSessionCategoriesInput
 */
export interface UpdateSessionCategoriesInput {
    /**
     * List of category IDs that should be linked to this session (will remove any not in this list)
     * @type {Array<string>}
     * @memberof UpdateSessionCategoriesInput
     */
    'category_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateSessionInput
 */
export interface UpdateSessionInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionInput
     */
    'topic_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionInput
     */
    'topic_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionInput
     */
    'end_date'?: string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof UpdateSessionInput
     */
    'status'?: SessionStatus;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateSessionInput
     */
    'location_id'?: string;
}


/**
 * 
 * @export
 * @interface UpdateSessionLocationInput
 */
export interface UpdateSessionLocationInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'parking_instructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionLocationInput
     */
    'wayfinding_instructions'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSessionTagsInput
 */
export interface UpdateSessionTagsInput {
    /**
     * List of tag IDs that should be linked to this session (will remove any not in this list)
     * @type {Array<string>}
     * @memberof UpdateSessionTagsInput
     */
    'tag_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTagInput
 */
export interface UpdateTagInput {
    /**
     * Updated name of the tag
     * @type {string}
     * @memberof UpdateTagInput
     */
    'name'?: string;
    /**
     * Updated description of the tag
     * @type {string}
     * @memberof UpdateTagInput
     */
    'description'?: string;
}
/**
 * Input for updating ticket type
 * @export
 * @interface UpdateTicketInput
 */
export interface UpdateTicketInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketInput
     */
    'ticket_type_id': string;
}
/**
 * Response model for ticket type update
 * @export
 * @interface UpdateTicketOutput
 */
export interface UpdateTicketOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketOutput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketOutput
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface UpdateTicketQuantityInput
 */
export interface UpdateTicketQuantityInput {
    /**
     * New quantity for the ticket, must be greater than 0
     * @type {number}
     * @memberof UpdateTicketQuantityInput
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface UpdateTicketQuantityOutput
 */
export interface UpdateTicketQuantityOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketQuantityOutput
     */
    'ticket_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketQuantityOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketQuantityOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketQuantityOutput
     */
    'ticket_type_id': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketQuantityOutput
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface UpdateTicketReceiptInput
 */
export interface UpdateTicketReceiptInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptInput
     */
    'ticket_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptInput
     */
    'ticket_type_id'?: string;
}
/**
 * Response model for ticket receipt update
 * @export
 * @interface UpdateTicketReceiptOutput
 */
export interface UpdateTicketReceiptOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptOutput
     */
    'receipt_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptOutput
     */
    'ticket_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptOutput
     */
    'ticket_type_id'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTicketReceiptStatusInput
 */
export interface UpdateTicketReceiptStatusInput {
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof UpdateTicketReceiptStatusInput
     */
    'status': TicketReceiptStatus;
}


/**
 * Response model for ticket receipt status update
 * @export
 * @interface UpdateTicketReceiptStatusOutput
 */
export interface UpdateTicketReceiptStatusOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketReceiptStatusOutput
     */
    'receipt_id': string;
    /**
     * 
     * @type {TicketReceiptStatus}
     * @memberof UpdateTicketReceiptStatusOutput
     */
    'status': TicketReceiptStatus;
}


/**
 * 
 * @export
 * @interface UpdateTicketTypeInput
 */
export interface UpdateTicketTypeInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketTypeInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketTypeInput
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketTypeInput
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketTypeInput
     */
    'max_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketTypeInput
     */
    'sale_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketTypeInput
     */
    'sale_end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTicketTypeInput
     */
    'is_hidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTicketTypeInput
     */
    'is_waitlistable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTicketTypeInput
     */
    'is_active'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateTicketTypeInput
     */
    'form_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTicketTypeInput
     */
    'is_gwyc_type'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketTypeInput
     */
    'suggested_gwyc_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketTypeInput
     */
    'max_gwyc_amount'?: number;
}
/**
 * 
 * @export
 * @interface UserOnStage
 */
export interface UserOnStage {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UserOnStage
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserOnStage
     */
    'is_host': boolean;
}
/**
 * Output model for UserPromo records
 * @export
 * @interface UserPromoOutput
 */
export interface UserPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UserPromoOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UserPromoOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UserPromoOutput
     */
    'promo_id': string;
}
/**
 * 
 * @export
 * @interface UsersAtSameEventOutput
 */
export interface UsersAtSameEventOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UsersAtSameEventOutput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface ValidateMultiDiscountCodeInput
 */
export interface ValidateMultiDiscountCodeInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateMultiDiscountCodeInput
     */
    'ticket_type_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ViewType = {
    Viewed: 'viewed',
    NotViewed: 'not_viewed'
} as const;

export type ViewType = typeof ViewType[keyof typeof ViewType];


/**
 * Output model for GroupPromo records with receipt data included
 * @export
 * @interface WonkaPromosOutputsGroupPromoOutput
 */
export interface WonkaPromosOutputsGroupPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'description'?: string;
    /**
     * 
     * @type {Array<PromoWithReceipts>}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'promos'?: Array<PromoWithReceipts>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'editors'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WonkaPromosOutputsGroupPromoOutput
     */
    'user_promos'?: Array<string>;
}
/**
 * Group promo output for unassigned tickets.  Contains all the promo codes generated for unassigned tickets. The purchaser becomes the GroupPromoEditor and can share these codes.
 * @export
 * @interface WonkaTicketsCheckoutOutputsGroupPromoOutput
 */
export interface WonkaTicketsCheckoutOutputsGroupPromoOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof WonkaTicketsCheckoutOutputsGroupPromoOutput
     */
    'group_promo_id': string;
    /**
     * 
     * @type {string}
     * @memberof WonkaTicketsCheckoutOutputsGroupPromoOutput
     */
    'slug': string;
    /**
     * 
     * @type {Array<GeneratedPromoCodeOutput>}
     * @memberof WonkaTicketsCheckoutOutputsGroupPromoOutput
     */
    'promo_codes': Array<GeneratedPromoCodeOutput>;
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all events for multiple communities by their community IDs.  Returns all events belonging to any of the provided community IDs. This endpoint is publicly accessible.
         * @summary Bulk Get Events By Community Ids
         * @param {BulkGetEventsByCommunitiesInput} bulkGetEventsByCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost: async (bulkGetEventsByCommunitiesInput: BulkGetEventsByCommunitiesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetEventsByCommunitiesInput' is not null or undefined
            assertParamExists('bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost', 'bulkGetEventsByCommunitiesInput', bulkGetEventsByCommunitiesInput)
            const localVarPath = `/events/communities/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetEventsByCommunitiesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get multiple events by their IDs with optional filtering by experience type.  If experience_type is specified, only events of that type will be returned. Any event IDs that don\'t exist or don\'t match the requested experience_type will be silently ignored.
         * @summary Bulk Get Events By Id
         * @param {BulkGetEventsInput} bulkGetEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetEventsByIdEventsBulkPost: async (bulkGetEventsInput: BulkGetEventsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetEventsInput' is not null or undefined
            assertParamExists('bulkGetEventsByIdEventsBulkPost', 'bulkGetEventsInput', bulkGetEventsInput)
            const localVarPath = `/events/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetEventsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch: async (eventId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch', 'eventId', eventId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch', 'communityId', communityId)
            const localVarPath = `/events/{event_id}/communities/{community_id}/cancel/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Event
         * @param {string} communityId 
         * @param {CreateEventInput} createEventInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventEventsCommunitiesCommunityIdPost: async (communityId: string, createEventInput: CreateEventInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createEventEventsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createEventInput' is not null or undefined
            assertParamExists('createEventEventsCommunitiesCommunityIdPost', 'createEventInput', createEventInput)
            const localVarPath = `/events/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Event Location
         * @param {string} communityId 
         * @param {CreateEventLocationInput} createEventLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventLocationEventsLocationsCommunitiesCommunityIdPost: async (communityId: string, createEventLocationInput: CreateEventLocationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createEventLocationEventsLocationsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createEventLocationInput' is not null or undefined
            assertParamExists('createEventLocationEventsLocationsCommunitiesCommunityIdPost', 'createEventLocationInput', createEventLocationInput)
            const localVarPath = `/events/locations/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventLocationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Event Tags
         * @param {string} communityId 
         * @param {CreateEventTagsInput} createEventTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTagsEventsTagsCommunitiesCommunityIdPost: async (communityId: string, createEventTagsInput: CreateEventTagsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createEventTagsEventsTagsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createEventTagsInput' is not null or undefined
            assertParamExists('createEventTagsEventsTagsCommunitiesCommunityIdPost', 'createEventTagsInput', createEventTagsInput)
            const localVarPath = `/events/tags/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventTagsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event by ID. Community role-based endpoint.  Args:     event_id: The ID of the event to delete     community_id: The community ID from the URL     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     DeleteEventOutput: Response indicating success or failure
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventEventsEventIdCommunitiesCommunityIdDelete: async (eventId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEventEventsEventIdCommunitiesCommunityIdDelete', 'eventId', eventId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteEventEventsEventIdCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/events/{event_id}/communities/{community_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to delete     jwt: The JWT payload containing authentication information     db: Database session  Returns:     DeleteEventLocationOutput: Response indicating success or failure
         * @summary Delete Event Location
         * @param {string} eventLocationId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete: async (eventLocationId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventLocationId' is not null or undefined
            assertParamExists('deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete', 'eventLocationId', eventLocationId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/events/locations/{event_location_id}/communities/{community_id}/`
                .replace(`{${"event_location_id"}}`, encodeURIComponent(String(eventLocationId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventEventsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventEventsIdGet', 'id', id)
            const localVarPath = `/events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Event Location
         * @param {string} eventLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventLocationEventsLocationsEventLocationIdGet: async (eventLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventLocationId' is not null or undefined
            assertParamExists('getEventLocationEventsLocationsEventLocationIdGet', 'eventLocationId', eventLocationId)
            const localVarPath = `/events/locations/{event_location_id}/`
                .replace(`{${"event_location_id"}}`, encodeURIComponent(String(eventLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Event Tags
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTagsEventsEventIdTagsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventTagsEventsEventIdTagsGet', 'eventId', eventId)
            const localVarPath = `/events/{event_id}/tags/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Events By Type
         * @param {ExperienceType} eventType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsByTypeEventsTypeEventTypeGet: async (eventType: ExperienceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('getEventsByTypeEventsTypeEventTypeGet', 'eventType', eventType)
            const localVarPath = `/events/type/{event_type}/`
                .replace(`{${"event_type"}}`, encodeURIComponent(String(eventType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events based on their temporal relation (FUTURE or PAST) with optional filtering. This endpoint is publicly accessible.  Parameters: - temporal_relation: Filter events by FUTURE or PAST - experience_types: Optional list of experience types to filter by - community_id: Optional parameter to filter events by a specific organization - start_date_from: Optional parameter to filter events starting from this date (inclusive) - start_date_to: Optional parameter to filter events starting before this date (inclusive)
         * @summary Get Events Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {Array<ExperienceType>} [experienceTypes] Types of experiences to filter by. PRIVATE_ROOM is not supported for unauthenticated requests.
         * @param {string} [communityId] 
         * @param {string} [startDateFrom] Filter events starting from this date (inclusive)
         * @param {string} [startDateTo] Filter events starting before this date (inclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsTemporalEventsTemporalTemporalRelationGet: async (temporalRelation: TemporalRelation, experienceTypes?: Array<ExperienceType>, communityId?: string, startDateFrom?: string, startDateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'temporalRelation' is not null or undefined
            assertParamExists('getEventsTemporalEventsTemporalTemporalRelationGet', 'temporalRelation', temporalRelation)
            const localVarPath = `/events/temporal/{temporal_relation}/`
                .replace(`{${"temporal_relation"}}`, encodeURIComponent(String(temporalRelation)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (experienceTypes) {
                localVarQueryParameter['experience_types'] = experienceTypes;
            }

            if (communityId !== undefined) {
                localVarQueryParameter['community_id'] = communityId;
            }

            if (startDateFrom !== undefined) {
                localVarQueryParameter['start_date_from'] = (startDateFrom as any instanceof Date) ?
                    (startDateFrom as any).toISOString() :
                    startDateFrom;
            }

            if (startDateTo !== undefined) {
                localVarQueryParameter['start_date_to'] = (startDateTo as any instanceof Date) ?
                    (startDateTo as any).toISOString() :
                    startDateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Future User Events
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFutureUserEventsEventsFutureUserUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFutureUserEventsEventsFutureUserUserIdGet', 'userId', userId)
            const localVarPath = `/events/future/user/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Next Event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextEventEventsNextGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/events/next/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Event Locations
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventLocationsEventsLocationsCommunitiesCommunityIdGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listEventLocationsEventsLocationsCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/events/locations/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsEventsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the community_id for an event and its associated event location. This endpoint updates both the event and event_location tables.  Args:     event_id: The ID of the event to update     community_id: The current community ID from the URL (for validation)     update_data: The new community_id to set     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     Event: The updated event object
         * @summary Update Event Community
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {UpdateEventCommunityInput} updateEventCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch: async (eventId: string, communityId: string, updateEventCommunityInput: UpdateEventCommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch', 'eventId', eventId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch', 'communityId', communityId)
            // verify required parameter 'updateEventCommunityInput' is not null or undefined
            assertParamExists('updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch', 'updateEventCommunityInput', updateEventCommunityInput)
            const localVarPath = `/events/{event_id}/communities/{community_id}/update-community/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventCommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event.  Args:     request: The HTTP request object     event_id: The ID of the event to update     community_id: The community ID from the URL     event_input: The input data for updating the event     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event
         * @summary Update Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {UpdateEventInput} updateEventInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventEventsEventIdCommunitiesCommunityIdPut: async (eventId: string, communityId: string, updateEventInput: UpdateEventInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEventEventsEventIdCommunitiesCommunityIdPut', 'eventId', eventId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateEventEventsEventIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateEventInput' is not null or undefined
            assertParamExists('updateEventEventsEventIdCommunitiesCommunityIdPut', 'updateEventInput', updateEventInput)
            const localVarPath = `/events/{event_id}/communities/{community_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to update     location_input: The input data for updating the event location     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event location
         * @summary Update Event Location
         * @param {string} eventLocationId 
         * @param {string} communityId 
         * @param {UpdateEventLocationInput} updateEventLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut: async (eventLocationId: string, communityId: string, updateEventLocationInput: UpdateEventLocationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventLocationId' is not null or undefined
            assertParamExists('updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut', 'eventLocationId', eventLocationId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateEventLocationInput' is not null or undefined
            assertParamExists('updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut', 'updateEventLocationInput', updateEventLocationInput)
            const localVarPath = `/events/locations/{event_location_id}/communities/{community_id}/`
                .replace(`{${"event_location_id"}}`, encodeURIComponent(String(eventLocationId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventLocationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all events for multiple communities by their community IDs.  Returns all events belonging to any of the provided community IDs. This endpoint is publicly accessible.
         * @summary Bulk Get Events By Community Ids
         * @param {BulkGetEventsByCommunitiesInput} bulkGetEventsByCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(bulkGetEventsByCommunitiesInput: BulkGetEventsByCommunitiesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(bulkGetEventsByCommunitiesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get multiple events by their IDs with optional filtering by experience type.  If experience_type is specified, only events of that type will be returned. Any event IDs that don\'t exist or don\'t match the requested experience_type will be silently ignored.
         * @summary Bulk Get Events By Id
         * @param {BulkGetEventsInput} bulkGetEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetEventsByIdEventsBulkPost(bulkGetEventsInput: BulkGetEventsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetEventsByIdEventsBulkPost(bulkGetEventsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.bulkGetEventsByIdEventsBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(eventId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(eventId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Event
         * @param {string} communityId 
         * @param {CreateEventInput} createEventInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventEventsCommunitiesCommunityIdPost(communityId: string, createEventInput: CreateEventInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventEventsCommunitiesCommunityIdPost(communityId, createEventInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.createEventEventsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Event Location
         * @param {string} communityId 
         * @param {CreateEventLocationInput} createEventLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventLocationEventsLocationsCommunitiesCommunityIdPost(communityId: string, createEventLocationInput: CreateEventLocationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventLocationEventsLocationsCommunitiesCommunityIdPost(communityId, createEventLocationInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.createEventLocationEventsLocationsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Event Tags
         * @param {string} communityId 
         * @param {CreateEventTagsInput} createEventTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventTagsEventsTagsCommunitiesCommunityIdPost(communityId: string, createEventTagsInput: CreateEventTagsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventTagsEventsTagsCommunitiesCommunityIdPost(communityId, createEventTagsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.createEventTagsEventsTagsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete an event by ID. Community role-based endpoint.  Args:     event_id: The ID of the event to delete     community_id: The community ID from the URL     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     DeleteEventOutput: Response indicating success or failure
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventEventsEventIdCommunitiesCommunityIdDelete(eventId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteEventOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventEventsEventIdCommunitiesCommunityIdDelete(eventId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEventEventsEventIdCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to delete     jwt: The JWT payload containing authentication information     db: Database session  Returns:     DeleteEventLocationOutput: Response indicating success or failure
         * @summary Delete Event Location
         * @param {string} eventLocationId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(eventLocationId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteEventLocationOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(eventLocationId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventEventsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventEventsIdGet(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventEventsIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Event Location
         * @param {string} eventLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventLocationEventsLocationsEventLocationIdGet(eventLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventLocationEventsLocationsEventLocationIdGet(eventLocationId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventLocationEventsLocationsEventLocationIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Event Tags
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTagsEventsEventIdTagsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTagsEventsEventIdTagsGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventTagsEventsEventIdTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Events By Type
         * @param {ExperienceType} eventType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsByTypeEventsTypeEventTypeGet(eventType: ExperienceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsByTypeEventsTypeEventTypeGet(eventType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventsByTypeEventsTypeEventTypeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get events based on their temporal relation (FUTURE or PAST) with optional filtering. This endpoint is publicly accessible.  Parameters: - temporal_relation: Filter events by FUTURE or PAST - experience_types: Optional list of experience types to filter by - community_id: Optional parameter to filter events by a specific organization - start_date_from: Optional parameter to filter events starting from this date (inclusive) - start_date_to: Optional parameter to filter events starting before this date (inclusive)
         * @summary Get Events Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {Array<ExperienceType>} [experienceTypes] Types of experiences to filter by. PRIVATE_ROOM is not supported for unauthenticated requests.
         * @param {string} [communityId] 
         * @param {string} [startDateFrom] Filter events starting from this date (inclusive)
         * @param {string} [startDateTo] Filter events starting before this date (inclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsTemporalEventsTemporalTemporalRelationGet(temporalRelation: TemporalRelation, experienceTypes?: Array<ExperienceType>, communityId?: string, startDateFrom?: string, startDateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsTemporalEventsTemporalTemporalRelationGet(temporalRelation, experienceTypes, communityId, startDateFrom, startDateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventsTemporalEventsTemporalTemporalRelationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Future User Events
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFutureUserEventsEventsFutureUserUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFutureUserEventsEventsFutureUserUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getFutureUserEventsEventsFutureUserUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Next Event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextEventEventsNextGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextEventEventsNextGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getNextEventEventsNextGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Event Locations
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventLocationsEventsLocationsCommunitiesCommunityIdGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventLocationsEventsLocationsCommunitiesCommunityIdGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.listEventLocationsEventsLocationsCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventsEventsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventsEventsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.listEventsEventsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update the community_id for an event and its associated event location. This endpoint updates both the event and event_location tables.  Args:     event_id: The ID of the event to update     community_id: The current community ID from the URL (for validation)     update_data: The new community_id to set     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     Event: The updated event object
         * @summary Update Event Community
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {UpdateEventCommunityInput} updateEventCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(eventId: string, communityId: string, updateEventCommunityInput: UpdateEventCommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(eventId, communityId, updateEventCommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update an event.  Args:     request: The HTTP request object     event_id: The ID of the event to update     community_id: The community ID from the URL     event_input: The input data for updating the event     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event
         * @summary Update Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {UpdateEventInput} updateEventInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventEventsEventIdCommunitiesCommunityIdPut(eventId: string, communityId: string, updateEventInput: UpdateEventInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventEventsEventIdCommunitiesCommunityIdPut(eventId, communityId, updateEventInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEventEventsEventIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to update     location_input: The input data for updating the event location     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event location
         * @summary Update Event Location
         * @param {string} eventLocationId 
         * @param {string} communityId 
         * @param {UpdateEventLocationInput} updateEventLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(eventLocationId: string, communityId: string, updateEventLocationInput: UpdateEventLocationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(eventLocationId, communityId, updateEventLocationInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Get all events for multiple communities by their community IDs.  Returns all events belonging to any of the provided community IDs. This endpoint is publicly accessible.
         * @summary Bulk Get Events By Community Ids
         * @param {EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(requestParameters: EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(requestParameters.bulkGetEventsByCommunitiesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get multiple events by their IDs with optional filtering by experience type.  If experience_type is specified, only events of that type will be returned. Any event IDs that don\'t exist or don\'t match the requested experience_type will be silently ignored.
         * @summary Bulk Get Events By Id
         * @param {EventsApiBulkGetEventsByIdEventsBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetEventsByIdEventsBulkPost(requestParameters: EventsApiBulkGetEventsByIdEventsBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.bulkGetEventsByIdEventsBulkPost(requestParameters.bulkGetEventsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Event
         * @param {EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(requestParameters: EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(requestParameters.eventId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Event
         * @param {EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventEventsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.createEventEventsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Event Location
         * @param {EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventLocationEventsLocationsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventLocation> {
            return localVarFp.createEventLocationEventsLocationsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventLocationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Event Tags
         * @param {EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTagsEventsTagsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTag>> {
            return localVarFp.createEventTagsEventsTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventTagsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event by ID. Community role-based endpoint.  Args:     event_id: The ID of the event to delete     community_id: The community ID from the URL     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     DeleteEventOutput: Response indicating success or failure
         * @summary Delete Event
         * @param {EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventEventsEventIdCommunitiesCommunityIdDelete(requestParameters: EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteEventOutput> {
            return localVarFp.deleteEventEventsEventIdCommunitiesCommunityIdDelete(requestParameters.eventId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to delete     jwt: The JWT payload containing authentication information     db: Database session  Returns:     DeleteEventLocationOutput: Response indicating success or failure
         * @summary Delete Event Location
         * @param {EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(requestParameters: EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteEventLocationOutput> {
            return localVarFp.deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(requestParameters.eventLocationId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Event
         * @param {EventsApiGetEventEventsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventEventsIdGet(requestParameters: EventsApiGetEventEventsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.getEventEventsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Event Location
         * @param {EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventLocationEventsLocationsEventLocationIdGet(requestParameters: EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventLocation> {
            return localVarFp.getEventLocationEventsLocationsEventLocationIdGet(requestParameters.eventLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Event Tags
         * @param {EventsApiGetEventTagsEventsEventIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTagsEventsEventIdTagsGet(requestParameters: EventsApiGetEventTagsEventsEventIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTag>> {
            return localVarFp.getEventTagsEventsEventIdTagsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Events By Type
         * @param {EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsByTypeEventsTypeEventTypeGet(requestParameters: EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.getEventsByTypeEventsTypeEventTypeGet(requestParameters.eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events based on their temporal relation (FUTURE or PAST) with optional filtering. This endpoint is publicly accessible.  Parameters: - temporal_relation: Filter events by FUTURE or PAST - experience_types: Optional list of experience types to filter by - community_id: Optional parameter to filter events by a specific organization - start_date_from: Optional parameter to filter events starting from this date (inclusive) - start_date_to: Optional parameter to filter events starting before this date (inclusive)
         * @summary Get Events Temporal
         * @param {EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsTemporalEventsTemporalTemporalRelationGet(requestParameters: EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.getEventsTemporalEventsTemporalTemporalRelationGet(requestParameters.temporalRelation, requestParameters.experienceTypes, requestParameters.communityId, requestParameters.startDateFrom, requestParameters.startDateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Future User Events
         * @param {EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFutureUserEventsEventsFutureUserUserIdGet(requestParameters: EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.getFutureUserEventsEventsFutureUserUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Next Event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextEventEventsNextGet(options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.getNextEventEventsNextGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Event Locations
         * @param {EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventLocationsEventsLocationsCommunitiesCommunityIdGet(requestParameters: EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventLocation>> {
            return localVarFp.listEventLocationsEventsLocationsCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsEventsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.listEventsEventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Update the community_id for an event and its associated event location. This endpoint updates both the event and event_location tables.  Args:     event_id: The ID of the event to update     community_id: The current community ID from the URL (for validation)     update_data: The new community_id to set     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     Event: The updated event object
         * @summary Update Event Community
         * @param {EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(requestParameters: EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(requestParameters.eventId, requestParameters.communityId, requestParameters.updateEventCommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event.  Args:     request: The HTTP request object     event_id: The ID of the event to update     community_id: The community ID from the URL     event_input: The input data for updating the event     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event
         * @summary Update Event
         * @param {EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventEventsEventIdCommunitiesCommunityIdPut(requestParameters: EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Event> {
            return localVarFp.updateEventEventsEventIdCommunitiesCommunityIdPut(requestParameters.eventId, requestParameters.communityId, requestParameters.updateEventInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to update     location_input: The input data for updating the event location     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event location
         * @summary Update Event Location
         * @param {EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(requestParameters: EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventLocation> {
            return localVarFp.updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(requestParameters.eventLocationId, requestParameters.communityId, requestParameters.updateEventLocationInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost operation in EventsApi.
 * @export
 * @interface EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest
 */
export interface EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest {
    /**
     * 
     * @type {BulkGetEventsByCommunitiesInput}
     * @memberof EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPost
     */
    readonly bulkGetEventsByCommunitiesInput: BulkGetEventsByCommunitiesInput
}

/**
 * Request parameters for bulkGetEventsByIdEventsBulkPost operation in EventsApi.
 * @export
 * @interface EventsApiBulkGetEventsByIdEventsBulkPostRequest
 */
export interface EventsApiBulkGetEventsByIdEventsBulkPostRequest {
    /**
     * 
     * @type {BulkGetEventsInput}
     * @memberof EventsApiBulkGetEventsByIdEventsBulkPost
     */
    readonly bulkGetEventsInput: BulkGetEventsInput
}

/**
 * Request parameters for cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch operation in EventsApi.
 * @export
 * @interface EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest
 */
export interface EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatch
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatch
     */
    readonly communityId: string
}

/**
 * Request parameters for createEventEventsCommunitiesCommunityIdPost operation in EventsApi.
 * @export
 * @interface EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest
 */
export interface EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiCreateEventEventsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateEventInput}
     * @memberof EventsApiCreateEventEventsCommunitiesCommunityIdPost
     */
    readonly createEventInput: CreateEventInput
}

/**
 * Request parameters for createEventLocationEventsLocationsCommunitiesCommunityIdPost operation in EventsApi.
 * @export
 * @interface EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest
 */
export interface EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateEventLocationInput}
     * @memberof EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPost
     */
    readonly createEventLocationInput: CreateEventLocationInput
}

/**
 * Request parameters for createEventTagsEventsTagsCommunitiesCommunityIdPost operation in EventsApi.
 * @export
 * @interface EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest
 */
export interface EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateEventTagsInput}
     * @memberof EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPost
     */
    readonly createEventTagsInput: CreateEventTagsInput
}

/**
 * Request parameters for deleteEventEventsEventIdCommunitiesCommunityIdDelete operation in EventsApi.
 * @export
 * @interface EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest
 */
export interface EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDelete
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete operation in EventsApi.
 * @export
 * @interface EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest
 */
export interface EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete
     */
    readonly eventLocationId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for getEventEventsIdGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventEventsIdGetRequest
 */
export interface EventsApiGetEventEventsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventEventsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for getEventLocationEventsLocationsEventLocationIdGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest
 */
export interface EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventLocationEventsLocationsEventLocationIdGet
     */
    readonly eventLocationId: string
}

/**
 * Request parameters for getEventTagsEventsEventIdTagsGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventTagsEventsEventIdTagsGetRequest
 */
export interface EventsApiGetEventTagsEventsEventIdTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventTagsEventsEventIdTagsGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getEventsByTypeEventsTypeEventTypeGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest
 */
export interface EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest {
    /**
     * 
     * @type {ExperienceType}
     * @memberof EventsApiGetEventsByTypeEventsTypeEventTypeGet
     */
    readonly eventType: ExperienceType
}

/**
 * Request parameters for getEventsTemporalEventsTemporalTemporalRelationGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest
 */
export interface EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest {
    /**
     * 
     * @type {TemporalRelation}
     * @memberof EventsApiGetEventsTemporalEventsTemporalTemporalRelationGet
     */
    readonly temporalRelation: TemporalRelation

    /**
     * Types of experiences to filter by. PRIVATE_ROOM is not supported for unauthenticated requests.
     * @type {Array<ExperienceType>}
     * @memberof EventsApiGetEventsTemporalEventsTemporalTemporalRelationGet
     */
    readonly experienceTypes?: Array<ExperienceType>

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventsTemporalEventsTemporalTemporalRelationGet
     */
    readonly communityId?: string

    /**
     * Filter events starting from this date (inclusive)
     * @type {string}
     * @memberof EventsApiGetEventsTemporalEventsTemporalTemporalRelationGet
     */
    readonly startDateFrom?: string

    /**
     * Filter events starting before this date (inclusive)
     * @type {string}
     * @memberof EventsApiGetEventsTemporalEventsTemporalTemporalRelationGet
     */
    readonly startDateTo?: string
}

/**
 * Request parameters for getFutureUserEventsEventsFutureUserUserIdGet operation in EventsApi.
 * @export
 * @interface EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest
 */
export interface EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetFutureUserEventsEventsFutureUserUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for listEventLocationsEventsLocationsCommunitiesCommunityIdGet operation in EventsApi.
 * @export
 * @interface EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest
 */
export interface EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch operation in EventsApi.
 * @export
 * @interface EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest
 */
export interface EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateEventCommunityInput}
     * @memberof EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch
     */
    readonly updateEventCommunityInput: UpdateEventCommunityInput
}

/**
 * Request parameters for updateEventEventsEventIdCommunitiesCommunityIdPut operation in EventsApi.
 * @export
 * @interface EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest
 */
export interface EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPut
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateEventInput}
     * @memberof EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPut
     */
    readonly updateEventInput: UpdateEventInput
}

/**
 * Request parameters for updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut operation in EventsApi.
 * @export
 * @interface EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest
 */
export interface EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut
     */
    readonly eventLocationId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateEventLocationInput}
     * @memberof EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut
     */
    readonly updateEventLocationInput: UpdateEventLocationInput
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Get all events for multiple communities by their community IDs.  Returns all events belonging to any of the provided community IDs. This endpoint is publicly accessible.
     * @summary Bulk Get Events By Community Ids
     * @param {EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(requestParameters: EventsApiBulkGetEventsByCommunityIdsEventsCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).bulkGetEventsByCommunityIdsEventsCommunitiesBulkPost(requestParameters.bulkGetEventsByCommunitiesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get multiple events by their IDs with optional filtering by experience type.  If experience_type is specified, only events of that type will be returned. Any event IDs that don\'t exist or don\'t match the requested experience_type will be silently ignored.
     * @summary Bulk Get Events By Id
     * @param {EventsApiBulkGetEventsByIdEventsBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public bulkGetEventsByIdEventsBulkPost(requestParameters: EventsApiBulkGetEventsByIdEventsBulkPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).bulkGetEventsByIdEventsBulkPost(requestParameters.bulkGetEventsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Event
     * @param {EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(requestParameters: EventsApiCancelEventEventsEventIdCommunitiesCommunityIdCancelPatchRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).cancelEventEventsEventIdCommunitiesCommunityIdCancelPatch(requestParameters.eventId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Event
     * @param {EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventEventsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventEventsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventEventsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Event Location
     * @param {EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventLocationEventsLocationsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventLocationEventsLocationsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventLocationEventsLocationsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventLocationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Event Tags
     * @param {EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventTagsEventsTagsCommunitiesCommunityIdPost(requestParameters: EventsApiCreateEventTagsEventsTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventTagsEventsTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createEventTagsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event by ID. Community role-based endpoint.  Args:     event_id: The ID of the event to delete     community_id: The community ID from the URL     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     DeleteEventOutput: Response indicating success or failure
     * @summary Delete Event
     * @param {EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventEventsEventIdCommunitiesCommunityIdDelete(requestParameters: EventsApiDeleteEventEventsEventIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventEventsEventIdCommunitiesCommunityIdDelete(requestParameters.eventId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to delete     jwt: The JWT payload containing authentication information     db: Database session  Returns:     DeleteEventLocationOutput: Response indicating success or failure
     * @summary Delete Event Location
     * @param {EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(requestParameters: EventsApiDeleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdDelete(requestParameters.eventLocationId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Event
     * @param {EventsApiGetEventEventsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventEventsIdGet(requestParameters: EventsApiGetEventEventsIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventEventsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Event Location
     * @param {EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventLocationEventsLocationsEventLocationIdGet(requestParameters: EventsApiGetEventLocationEventsLocationsEventLocationIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventLocationEventsLocationsEventLocationIdGet(requestParameters.eventLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Event Tags
     * @param {EventsApiGetEventTagsEventsEventIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventTagsEventsEventIdTagsGet(requestParameters: EventsApiGetEventTagsEventsEventIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventTagsEventsEventIdTagsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Events By Type
     * @param {EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsByTypeEventsTypeEventTypeGet(requestParameters: EventsApiGetEventsByTypeEventsTypeEventTypeGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventsByTypeEventsTypeEventTypeGet(requestParameters.eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events based on their temporal relation (FUTURE or PAST) with optional filtering. This endpoint is publicly accessible.  Parameters: - temporal_relation: Filter events by FUTURE or PAST - experience_types: Optional list of experience types to filter by - community_id: Optional parameter to filter events by a specific organization - start_date_from: Optional parameter to filter events starting from this date (inclusive) - start_date_to: Optional parameter to filter events starting before this date (inclusive)
     * @summary Get Events Temporal
     * @param {EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsTemporalEventsTemporalTemporalRelationGet(requestParameters: EventsApiGetEventsTemporalEventsTemporalTemporalRelationGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventsTemporalEventsTemporalTemporalRelationGet(requestParameters.temporalRelation, requestParameters.experienceTypes, requestParameters.communityId, requestParameters.startDateFrom, requestParameters.startDateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Future User Events
     * @param {EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getFutureUserEventsEventsFutureUserUserIdGet(requestParameters: EventsApiGetFutureUserEventsEventsFutureUserUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getFutureUserEventsEventsFutureUserUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Next Event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getNextEventEventsNextGet(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getNextEventEventsNextGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Event Locations
     * @param {EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public listEventLocationsEventsLocationsCommunitiesCommunityIdGet(requestParameters: EventsApiListEventLocationsEventsLocationsCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).listEventLocationsEventsLocationsCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public listEventsEventsGet(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).listEventsEventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the community_id for an event and its associated event location. This endpoint updates both the event and event_location tables.  Args:     event_id: The ID of the event to update     community_id: The current community ID from the URL (for validation)     update_data: The new community_id to set     current_user: The authenticated user\'s JWT with community role validation     db: Database session      Returns:     Event: The updated event object
     * @summary Update Event Community
     * @param {EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(requestParameters: EventsApiUpdateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatchRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventCommunityEventsEventIdCommunitiesCommunityIdUpdateCommunityPatch(requestParameters.eventId, requestParameters.communityId, requestParameters.updateEventCommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event.  Args:     request: The HTTP request object     event_id: The ID of the event to update     community_id: The community ID from the URL     event_input: The input data for updating the event     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event
     * @summary Update Event
     * @param {EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventEventsEventIdCommunitiesCommunityIdPut(requestParameters: EventsApiUpdateEventEventsEventIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventEventsEventIdCommunitiesCommunityIdPut(requestParameters.eventId, requestParameters.communityId, requestParameters.updateEventInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event location by ID. Admin-only endpoint.  Args:     request: The HTTP request object     event_location_id: The ID of the event location to update     location_input: The input data for updating the event location     jwt: The JWT payload containing authentication information     db: Database session  Returns:     The updated event location
     * @summary Update Event Location
     * @param {EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(requestParameters: EventsApiUpdateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventLocationEventsLocationsEventLocationIdCommunitiesCommunityIdPut(requestParameters.eventLocationId, requestParameters.communityId, requestParameters.updateEventLocationInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GramsApi - axios parameter creator
 * @export
 */
export const GramsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new gram social share.
         * @summary Create Gram Social Share
         * @param {CreateGramSocialShareInput} createGramSocialShareInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramSocialShareGramsSocialSharesPost: async (createGramSocialShareInput: CreateGramSocialShareInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGramSocialShareInput' is not null or undefined
            assertParamExists('createGramSocialShareGramsSocialSharesPost', 'createGramSocialShareInput', createGramSocialShareInput)
            const localVarPath = `/grams/social-shares/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGramSocialShareInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a gram using user\'s profile photo and a specific template, then store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Specific Template
         * @param {CreateGramWithSpecificTemplateInput} createGramWithSpecificTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramWithSpecificTemplateGramsGenerateWithTemplatePost: async (createGramWithSpecificTemplateInput: CreateGramWithSpecificTemplateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGramWithSpecificTemplateInput' is not null or undefined
            assertParamExists('createGramWithSpecificTemplateGramsGenerateWithTemplatePost', 'createGramWithSpecificTemplateInput', createGramWithSpecificTemplateInput)
            const localVarPath = `/grams/generate-with-template/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGramWithSpecificTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a gram using user\'s profile photo and store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Storage
         * @param {CreateGramWithStorageInput} createGramWithStorageInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramWithStorageGramsGeneratePost: async (createGramWithStorageInput: CreateGramWithStorageInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGramWithStorageInput' is not null or undefined
            assertParamExists('createGramWithStorageGramsGeneratePost', 'createGramWithStorageInput', createGramWithStorageInput)
            const localVarPath = `/grams/generate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGramWithStorageInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a gram social share (sets is_active to False).
         * @summary Delete Gram Social Share
         * @param {string} socialShareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGramSocialShareGramsSocialSharesSocialShareIdDelete: async (socialShareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialShareId' is not null or undefined
            assertParamExists('deleteGramSocialShareGramsSocialSharesSocialShareIdDelete', 'socialShareId', socialShareId)
            const localVarPath = `/grams/social-shares/{social_share_id}/`
                .replace(`{${"social_share_id"}}`, encodeURIComponent(String(socialShareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a temporary presigned URL for downloading the gram file from S3.
         * @summary Get Gram File Url
         * @param {string} gramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramFileUrlGramsGramIdUrlGet: async (gramId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gramId' is not null or undefined
            assertParamExists('getGramFileUrlGramsGramIdUrlGet', 'gramId', gramId)
            const localVarPath = `/grams/{gram_id}/url/`
                .replace(`{${"gram_id"}}`, encodeURIComponent(String(gramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get gram social share by slug with associated storage data.
         * @summary Get Gram Social Share By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet', 'slug', slug)
            const localVarPath = `/grams/social-shares/slugs/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get gram social share by user and session.
         * @summary Get Gram Social Share By User And Session
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet: async (sessionId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet', 'sessionId', sessionId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet', 'userId', userId)
            const localVarPath = `/grams/social-shares/session/{session_id}/users/{user_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get gram social share by ID. Users can only access social shares for their own grams, admins can access any.
         * @summary Get Gram Social Share
         * @param {string} socialShareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareGramsSocialSharesSocialShareIdGet: async (socialShareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialShareId' is not null or undefined
            assertParamExists('getGramSocialShareGramsSocialSharesSocialShareIdGet', 'socialShareId', socialShareId)
            const localVarPath = `/grams/social-shares/{social_share_id}/`
                .replace(`{${"social_share_id"}}`, encodeURIComponent(String(socialShareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all gram social shares for an event.
         * @summary Get Gram Social Shares By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialSharesByEventGramsSocialSharesEventEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getGramSocialSharesByEventGramsSocialSharesEventEventIdGet', 'eventId', eventId)
            const localVarPath = `/grams/social-shares/event/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all gram social shares for a session.
         * @summary Get Gram Social Shares By Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/grams/social-shares/session/{session_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get gram storage information by user_id and event_id.
         * @summary Get Gram Storage By User And Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet: async (userId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet', 'userId', userId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/grams/users/{user_id}/events/{event_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get gram storage information by ID.
         * @summary Get Gram Storage
         * @param {string} gramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramStorageGramsGramIdGet: async (gramId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gramId' is not null or undefined
            assertParamExists('getGramStorageGramsGramIdGet', 'gramId', gramId)
            const localVarPath = `/grams/{gram_id}/`
                .replace(`{${"gram_id"}}`, encodeURIComponent(String(gramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all gram storage records for a specific user.
         * @summary Get User Grams
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGramsGramsUsersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserGramsGramsUsersUserIdGet', 'userId', userId)
            const localVarPath = `/grams/users/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GramsApi - functional programming interface
 * @export
 */
export const GramsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GramsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new gram social share.
         * @summary Create Gram Social Share
         * @param {CreateGramSocialShareInput} createGramSocialShareInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGramSocialShareGramsSocialSharesPost(createGramSocialShareInput: CreateGramSocialShareInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramSocialShareOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGramSocialShareGramsSocialSharesPost(createGramSocialShareInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.createGramSocialShareGramsSocialSharesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a gram using user\'s profile photo and a specific template, then store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Specific Template
         * @param {CreateGramWithSpecificTemplateInput} createGramWithSpecificTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGramWithSpecificTemplateGramsGenerateWithTemplatePost(createGramWithSpecificTemplateInput: CreateGramWithSpecificTemplateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramCreationAcknowledgmentOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGramWithSpecificTemplateGramsGenerateWithTemplatePost(createGramWithSpecificTemplateInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.createGramWithSpecificTemplateGramsGenerateWithTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a gram using user\'s profile photo and store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Storage
         * @param {CreateGramWithStorageInput} createGramWithStorageInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGramWithStorageGramsGeneratePost(createGramWithStorageInput: CreateGramWithStorageInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramCreationAcknowledgmentOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGramWithStorageGramsGeneratePost(createGramWithStorageInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.createGramWithStorageGramsGeneratePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Soft delete a gram social share (sets is_active to False).
         * @summary Delete Gram Social Share
         * @param {string} socialShareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(socialShareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(socialShareId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.deleteGramSocialShareGramsSocialSharesSocialShareIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a temporary presigned URL for downloading the gram file from S3.
         * @summary Get Gram File Url
         * @param {string} gramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramFileUrlGramsGramIdUrlGet(gramId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramStorageUrlOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramFileUrlGramsGramIdUrlGet(gramId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramFileUrlGramsGramIdUrlGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get gram social share by slug with associated storage data.
         * @summary Get Gram Social Share By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramSocialShareWithStorageOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(slug, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get gram social share by user and session.
         * @summary Get Gram Social Share By User And Session
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(sessionId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramSocialShareOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(sessionId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get gram social share by ID. Users can only access social shares for their own grams, admins can access any.
         * @summary Get Gram Social Share
         * @param {string} socialShareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramSocialShareGramsSocialSharesSocialShareIdGet(socialShareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramSocialShareOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramSocialShareGramsSocialSharesSocialShareIdGet(socialShareId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramSocialShareGramsSocialSharesSocialShareIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all gram social shares for an event.
         * @summary Get Gram Social Shares By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GramSocialShareOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramSocialSharesByEventGramsSocialSharesEventEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all gram social shares for a session.
         * @summary Get Gram Social Shares By Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GramSocialShareOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get gram storage information by user_id and event_id.
         * @summary Get Gram Storage By User And Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(userId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramStorageOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(userId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get gram storage information by ID.
         * @summary Get Gram Storage
         * @param {string} gramId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGramStorageGramsGramIdGet(gramId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GramStorageOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGramStorageGramsGramIdGet(gramId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getGramStorageGramsGramIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all gram storage records for a specific user.
         * @summary Get User Grams
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGramsGramsUsersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GramStorageOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGramsGramsUsersUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GramsApi.getUserGramsGramsUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GramsApi - factory interface
 * @export
 */
export const GramsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GramsApiFp(configuration)
    return {
        /**
         * Create a new gram social share.
         * @summary Create Gram Social Share
         * @param {GramsApiCreateGramSocialShareGramsSocialSharesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramSocialShareGramsSocialSharesPost(requestParameters: GramsApiCreateGramSocialShareGramsSocialSharesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramSocialShareOutput> {
            return localVarFp.createGramSocialShareGramsSocialSharesPost(requestParameters.createGramSocialShareInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a gram using user\'s profile photo and a specific template, then store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Specific Template
         * @param {GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramWithSpecificTemplateGramsGenerateWithTemplatePost(requestParameters: GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramCreationAcknowledgmentOutput> {
            return localVarFp.createGramWithSpecificTemplateGramsGenerateWithTemplatePost(requestParameters.createGramWithSpecificTemplateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a gram using user\'s profile photo and store it to AWS S3. Processing is handled asynchronously in the background.
         * @summary Create Gram With Storage
         * @param {GramsApiCreateGramWithStorageGramsGeneratePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGramWithStorageGramsGeneratePost(requestParameters: GramsApiCreateGramWithStorageGramsGeneratePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramCreationAcknowledgmentOutput> {
            return localVarFp.createGramWithStorageGramsGeneratePost(requestParameters.createGramWithStorageInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a gram social share (sets is_active to False).
         * @summary Delete Gram Social Share
         * @param {GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(requestParameters: GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(requestParameters.socialShareId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a temporary presigned URL for downloading the gram file from S3.
         * @summary Get Gram File Url
         * @param {GramsApiGetGramFileUrlGramsGramIdUrlGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramFileUrlGramsGramIdUrlGet(requestParameters: GramsApiGetGramFileUrlGramsGramIdUrlGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramStorageUrlOutput> {
            return localVarFp.getGramFileUrlGramsGramIdUrlGet(requestParameters.gramId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get gram social share by slug with associated storage data.
         * @summary Get Gram Social Share By Slug
         * @param {GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(requestParameters: GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramSocialShareWithStorageOutput> {
            return localVarFp.getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get gram social share by user and session.
         * @summary Get Gram Social Share By User And Session
         * @param {GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(requestParameters: GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramSocialShareOutput> {
            return localVarFp.getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get gram social share by ID. Users can only access social shares for their own grams, admins can access any.
         * @summary Get Gram Social Share
         * @param {GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialShareGramsSocialSharesSocialShareIdGet(requestParameters: GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramSocialShareOutput> {
            return localVarFp.getGramSocialShareGramsSocialSharesSocialShareIdGet(requestParameters.socialShareId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all gram social shares for an event.
         * @summary Get Gram Social Shares By Event
         * @param {GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(requestParameters: GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GramSocialShareOutput>> {
            return localVarFp.getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all gram social shares for a session.
         * @summary Get Gram Social Shares By Session
         * @param {GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(requestParameters: GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GramSocialShareOutput>> {
            return localVarFp.getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get gram storage information by user_id and event_id.
         * @summary Get Gram Storage By User And Event
         * @param {GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(requestParameters: GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramStorageOutput> {
            return localVarFp.getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get gram storage information by ID.
         * @summary Get Gram Storage
         * @param {GramsApiGetGramStorageGramsGramIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGramStorageGramsGramIdGet(requestParameters: GramsApiGetGramStorageGramsGramIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GramStorageOutput> {
            return localVarFp.getGramStorageGramsGramIdGet(requestParameters.gramId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all gram storage records for a specific user.
         * @summary Get User Grams
         * @param {GramsApiGetUserGramsGramsUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGramsGramsUsersUserIdGet(requestParameters: GramsApiGetUserGramsGramsUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GramStorageOutput>> {
            return localVarFp.getUserGramsGramsUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createGramSocialShareGramsSocialSharesPost operation in GramsApi.
 * @export
 * @interface GramsApiCreateGramSocialShareGramsSocialSharesPostRequest
 */
export interface GramsApiCreateGramSocialShareGramsSocialSharesPostRequest {
    /**
     * 
     * @type {CreateGramSocialShareInput}
     * @memberof GramsApiCreateGramSocialShareGramsSocialSharesPost
     */
    readonly createGramSocialShareInput: CreateGramSocialShareInput
}

/**
 * Request parameters for createGramWithSpecificTemplateGramsGenerateWithTemplatePost operation in GramsApi.
 * @export
 * @interface GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest
 */
export interface GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest {
    /**
     * 
     * @type {CreateGramWithSpecificTemplateInput}
     * @memberof GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePost
     */
    readonly createGramWithSpecificTemplateInput: CreateGramWithSpecificTemplateInput
}

/**
 * Request parameters for createGramWithStorageGramsGeneratePost operation in GramsApi.
 * @export
 * @interface GramsApiCreateGramWithStorageGramsGeneratePostRequest
 */
export interface GramsApiCreateGramWithStorageGramsGeneratePostRequest {
    /**
     * 
     * @type {CreateGramWithStorageInput}
     * @memberof GramsApiCreateGramWithStorageGramsGeneratePost
     */
    readonly createGramWithStorageInput: CreateGramWithStorageInput
}

/**
 * Request parameters for deleteGramSocialShareGramsSocialSharesSocialShareIdDelete operation in GramsApi.
 * @export
 * @interface GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest
 */
export interface GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDelete
     */
    readonly socialShareId: string
}

/**
 * Request parameters for getGramFileUrlGramsGramIdUrlGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramFileUrlGramsGramIdUrlGetRequest
 */
export interface GramsApiGetGramFileUrlGramsGramIdUrlGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramFileUrlGramsGramIdUrlGet
     */
    readonly gramId: string
}

/**
 * Request parameters for getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest
 */
export interface GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGet
     */
    readonly slug: string
}

/**
 * Request parameters for getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest
 */
export interface GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getGramSocialShareGramsSocialSharesSocialShareIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest
 */
export interface GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGet
     */
    readonly socialShareId: string
}

/**
 * Request parameters for getGramSocialSharesByEventGramsSocialSharesEventEventIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest
 */
export interface GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest
 */
export interface GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest
 */
export interface GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getGramStorageGramsGramIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetGramStorageGramsGramIdGetRequest
 */
export interface GramsApiGetGramStorageGramsGramIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetGramStorageGramsGramIdGet
     */
    readonly gramId: string
}

/**
 * Request parameters for getUserGramsGramsUsersUserIdGet operation in GramsApi.
 * @export
 * @interface GramsApiGetUserGramsGramsUsersUserIdGetRequest
 */
export interface GramsApiGetUserGramsGramsUsersUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GramsApiGetUserGramsGramsUsersUserIdGet
     */
    readonly userId: string
}

/**
 * GramsApi - object-oriented interface
 * @export
 * @class GramsApi
 * @extends {BaseAPI}
 */
export class GramsApi extends BaseAPI {
    /**
     * Create a new gram social share.
     * @summary Create Gram Social Share
     * @param {GramsApiCreateGramSocialShareGramsSocialSharesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public createGramSocialShareGramsSocialSharesPost(requestParameters: GramsApiCreateGramSocialShareGramsSocialSharesPostRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).createGramSocialShareGramsSocialSharesPost(requestParameters.createGramSocialShareInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a gram using user\'s profile photo and a specific template, then store it to AWS S3. Processing is handled asynchronously in the background.
     * @summary Create Gram With Specific Template
     * @param {GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public createGramWithSpecificTemplateGramsGenerateWithTemplatePost(requestParameters: GramsApiCreateGramWithSpecificTemplateGramsGenerateWithTemplatePostRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).createGramWithSpecificTemplateGramsGenerateWithTemplatePost(requestParameters.createGramWithSpecificTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a gram using user\'s profile photo and store it to AWS S3. Processing is handled asynchronously in the background.
     * @summary Create Gram With Storage
     * @param {GramsApiCreateGramWithStorageGramsGeneratePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public createGramWithStorageGramsGeneratePost(requestParameters: GramsApiCreateGramWithStorageGramsGeneratePostRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).createGramWithStorageGramsGeneratePost(requestParameters.createGramWithStorageInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a gram social share (sets is_active to False).
     * @summary Delete Gram Social Share
     * @param {GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(requestParameters: GramsApiDeleteGramSocialShareGramsSocialSharesSocialShareIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).deleteGramSocialShareGramsSocialSharesSocialShareIdDelete(requestParameters.socialShareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a temporary presigned URL for downloading the gram file from S3.
     * @summary Get Gram File Url
     * @param {GramsApiGetGramFileUrlGramsGramIdUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramFileUrlGramsGramIdUrlGet(requestParameters: GramsApiGetGramFileUrlGramsGramIdUrlGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramFileUrlGramsGramIdUrlGet(requestParameters.gramId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get gram social share by slug with associated storage data.
     * @summary Get Gram Social Share By Slug
     * @param {GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(requestParameters: GramsApiGetGramSocialShareBySlugGramsSocialSharesSlugsSlugGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramSocialShareBySlugGramsSocialSharesSlugsSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get gram social share by user and session.
     * @summary Get Gram Social Share By User And Session
     * @param {GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(requestParameters: GramsApiGetGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramSocialShareByUserAndSessionGramsSocialSharesSessionSessionIdUsersUserIdGet(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get gram social share by ID. Users can only access social shares for their own grams, admins can access any.
     * @summary Get Gram Social Share
     * @param {GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramSocialShareGramsSocialSharesSocialShareIdGet(requestParameters: GramsApiGetGramSocialShareGramsSocialSharesSocialShareIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramSocialShareGramsSocialSharesSocialShareIdGet(requestParameters.socialShareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all gram social shares for an event.
     * @summary Get Gram Social Shares By Event
     * @param {GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(requestParameters: GramsApiGetGramSocialSharesByEventGramsSocialSharesEventEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramSocialSharesByEventGramsSocialSharesEventEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all gram social shares for a session.
     * @summary Get Gram Social Shares By Session
     * @param {GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(requestParameters: GramsApiGetGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramSocialSharesBySessionGramsSocialSharesSessionSessionIdGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get gram storage information by user_id and event_id.
     * @summary Get Gram Storage By User And Event
     * @param {GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(requestParameters: GramsApiGetGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramStorageByUserAndEventGramsUsersUserIdEventsEventIdGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get gram storage information by ID.
     * @summary Get Gram Storage
     * @param {GramsApiGetGramStorageGramsGramIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getGramStorageGramsGramIdGet(requestParameters: GramsApiGetGramStorageGramsGramIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getGramStorageGramsGramIdGet(requestParameters.gramId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all gram storage records for a specific user.
     * @summary Get User Grams
     * @param {GramsApiGetUserGramsGramsUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GramsApi
     */
    public getUserGramsGramsUsersUserIdGet(requestParameters: GramsApiGetUserGramsGramsUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return GramsApiFp(this.configuration).getUserGramsGramsUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LedgerApi - axios parameter creator
 * @export
 */
export const LedgerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel a pending payout (admin only).
         * @summary Cancel Payout
         * @param {string} payoutId 
         * @param {CancelPayoutInput} cancelPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost: async (payoutId: string, cancelPayoutInput: CancelPayoutInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payoutId' is not null or undefined
            assertParamExists('cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost', 'payoutId', payoutId)
            // verify required parameter 'cancelPayoutInput' is not null or undefined
            assertParamExists('cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost', 'cancelPayoutInput', cancelPayoutInput)
            const localVarPath = `/ledger/admin/payouts/{payout_id}/cancel/`
                .replace(`{${"payout_id"}}`, encodeURIComponent(String(payoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelPayoutInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payouts for a community.
         * @summary Get Community Payouts
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {PayoutStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet: async (communityId: string, limit?: number, offset?: number, status?: PayoutStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet', 'communityId', communityId)
            const localVarPath = `/ledger/communities/{community_id}/payouts/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get revenue summary for a specific event. Only community owners can access.
         * @summary Get Event Revenue
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRevenueLedgerEventsEventIdRevenueGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventRevenueLedgerEventsEventIdRevenueGet', 'eventId', eventId)
            const localVarPath = `/ledger/events/{event_id}/revenue/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current balance for a community\'s ledger.
         * @summary Get Ledger Balance
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet', 'communityId', communityId)
            const localVarPath = `/ledger/communities/{community_id}/balance/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ledger entries for a community with optional filters.
         * @summary Get Ledger Entries
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {LedgerEntryType} [entryType] 
         * @param {LedgerEntrySource} [source] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet: async (communityId: string, limit?: number, offset?: number, entryType?: LedgerEntryType, source?: LedgerEntrySource, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet', 'communityId', communityId)
            const localVarPath = `/ledger/communities/{community_id}/entries/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (entryType !== undefined) {
                localVarQueryParameter['entry_type'] = entryType;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific payout by ID. Only community owners can access.
         * @summary Get Payout
         * @param {string} payoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutLedgerPayoutsPayoutIdGet: async (payoutId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payoutId' is not null or undefined
            assertParamExists('getPayoutLedgerPayoutsPayoutIdGet', 'payoutId', payoutId)
            const localVarPath = `/ledger/payouts/{payout_id}/`
                .replace(`{${"payout_id"}}`, encodeURIComponent(String(payoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all pending payouts (admin only).
         * @summary Get Pending Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPayoutsLedgerAdminPayoutsPendingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ledger/admin/payouts/pending/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Process a pending payout (admin only).
         * @summary Process Payout
         * @param {string} payoutId 
         * @param {ProcessPayoutInput} processPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayoutLedgerAdminPayoutsPayoutIdProcessPost: async (payoutId: string, processPayoutInput: ProcessPayoutInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payoutId' is not null or undefined
            assertParamExists('processPayoutLedgerAdminPayoutsPayoutIdProcessPost', 'payoutId', payoutId)
            // verify required parameter 'processPayoutInput' is not null or undefined
            assertParamExists('processPayoutLedgerAdminPayoutsPayoutIdProcessPost', 'processPayoutInput', processPayoutInput)
            const localVarPath = `/ledger/admin/payouts/{payout_id}/process/`
                .replace(`{${"payout_id"}}`, encodeURIComponent(String(payoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processPayoutInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record a manual adjustment to a community ledger (admin only).
         * @summary Record Adjustment
         * @param {RecordAdjustmentInput} recordAdjustmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordAdjustmentLedgerAdminAdjustmentsPost: async (recordAdjustmentInput: RecordAdjustmentInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordAdjustmentInput' is not null or undefined
            assertParamExists('recordAdjustmentLedgerAdminAdjustmentsPost', 'recordAdjustmentInput', recordAdjustmentInput)
            const localVarPath = `/ledger/admin/adjustments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordAdjustmentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a payout for a community. Only community owners can request payouts.
         * @summary Request Payout
         * @param {string} communityId 
         * @param {RequestPayoutInput} requestPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPayoutLedgerCommunitiesCommunityIdPayoutsPost: async (communityId: string, requestPayoutInput: RequestPayoutInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('requestPayoutLedgerCommunitiesCommunityIdPayoutsPost', 'communityId', communityId)
            // verify required parameter 'requestPayoutInput' is not null or undefined
            assertParamExists('requestPayoutLedgerCommunitiesCommunityIdPayoutsPost', 'requestPayoutInput', requestPayoutInput)
            const localVarPath = `/ledger/communities/{community_id}/payouts/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPayoutInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LedgerApi - functional programming interface
 * @export
 */
export const LedgerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LedgerApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel a pending payout (admin only).
         * @summary Cancel Payout
         * @param {string} payoutId 
         * @param {CancelPayoutInput} cancelPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(payoutId: string, cancelPayoutInput: CancelPayoutInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(payoutId, cancelPayoutInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get payouts for a community.
         * @summary Get Community Payouts
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {PayoutStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(communityId: string, limit?: number, offset?: number, status?: PayoutStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPayoutsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(communityId, limit, offset, status, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get revenue summary for a specific event. Only community owners can access.
         * @summary Get Event Revenue
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventRevenueLedgerEventsEventIdRevenueGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventRevenueOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventRevenueLedgerEventsEventIdRevenueGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getEventRevenueLedgerEventsEventIdRevenueGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the current balance for a community\'s ledger.
         * @summary Get Ledger Balance
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LedgerBalanceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get ledger entries for a community with optional filters.
         * @summary Get Ledger Entries
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {LedgerEntryType} [entryType] 
         * @param {LedgerEntrySource} [source] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(communityId: string, limit?: number, offset?: number, entryType?: LedgerEntryType, source?: LedgerEntrySource, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLedgerEntriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(communityId, limit, offset, entryType, source, startDate, endDate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a specific payout by ID. Only community owners can access.
         * @summary Get Payout
         * @param {string} payoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutLedgerPayoutsPayoutIdGet(payoutId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutLedgerPayoutsPayoutIdGet(payoutId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getPayoutLedgerPayoutsPayoutIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all pending payouts (admin only).
         * @summary Get Pending Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingPayoutsLedgerAdminPayoutsPendingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayoutOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingPayoutsLedgerAdminPayoutsPendingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.getPendingPayoutsLedgerAdminPayoutsPendingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Process a pending payout (admin only).
         * @summary Process Payout
         * @param {string} payoutId 
         * @param {ProcessPayoutInput} processPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPayoutLedgerAdminPayoutsPayoutIdProcessPost(payoutId: string, processPayoutInput: ProcessPayoutInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPayoutLedgerAdminPayoutsPayoutIdProcessPost(payoutId, processPayoutInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.processPayoutLedgerAdminPayoutsPayoutIdProcessPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Record a manual adjustment to a community ledger (admin only).
         * @summary Record Adjustment
         * @param {RecordAdjustmentInput} recordAdjustmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordAdjustmentLedgerAdminAdjustmentsPost(recordAdjustmentInput: RecordAdjustmentInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LedgerEntryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordAdjustmentLedgerAdminAdjustmentsPost(recordAdjustmentInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.recordAdjustmentLedgerAdminAdjustmentsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Request a payout for a community. Only community owners can request payouts.
         * @summary Request Payout
         * @param {string} communityId 
         * @param {RequestPayoutInput} requestPayoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(communityId: string, requestPayoutInput: RequestPayoutInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(communityId, requestPayoutInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LedgerApi.requestPayoutLedgerCommunitiesCommunityIdPayoutsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LedgerApi - factory interface
 * @export
 */
export const LedgerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LedgerApiFp(configuration)
    return {
        /**
         * Cancel a pending payout (admin only).
         * @summary Cancel Payout
         * @param {LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(requestParameters: LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayoutOutput> {
            return localVarFp.cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(requestParameters.payoutId, requestParameters.cancelPayoutInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get payouts for a community.
         * @summary Get Community Payouts
         * @param {LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(requestParameters: LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPayoutsOutput> {
            return localVarFp.getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get revenue summary for a specific event. Only community owners can access.
         * @summary Get Event Revenue
         * @param {LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRevenueLedgerEventsEventIdRevenueGet(requestParameters: LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventRevenueOutput> {
            return localVarFp.getEventRevenueLedgerEventsEventIdRevenueGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current balance for a community\'s ledger.
         * @summary Get Ledger Balance
         * @param {LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(requestParameters: LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LedgerBalanceOutput> {
            return localVarFp.getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ledger entries for a community with optional filters.
         * @summary Get Ledger Entries
         * @param {LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(requestParameters: LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedLedgerEntriesOutput> {
            return localVarFp.getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, requestParameters.entryType, requestParameters.source, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific payout by ID. Only community owners can access.
         * @summary Get Payout
         * @param {LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutLedgerPayoutsPayoutIdGet(requestParameters: LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayoutOutput> {
            return localVarFp.getPayoutLedgerPayoutsPayoutIdGet(requestParameters.payoutId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all pending payouts (admin only).
         * @summary Get Pending Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPayoutsLedgerAdminPayoutsPendingGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PayoutOutput>> {
            return localVarFp.getPendingPayoutsLedgerAdminPayoutsPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Process a pending payout (admin only).
         * @summary Process Payout
         * @param {LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayoutLedgerAdminPayoutsPayoutIdProcessPost(requestParameters: LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayoutOutput> {
            return localVarFp.processPayoutLedgerAdminPayoutsPayoutIdProcessPost(requestParameters.payoutId, requestParameters.processPayoutInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Record a manual adjustment to a community ledger (admin only).
         * @summary Record Adjustment
         * @param {LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordAdjustmentLedgerAdminAdjustmentsPost(requestParameters: LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LedgerEntryOutput> {
            return localVarFp.recordAdjustmentLedgerAdminAdjustmentsPost(requestParameters.recordAdjustmentInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a payout for a community. Only community owners can request payouts.
         * @summary Request Payout
         * @param {LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(requestParameters: LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayoutOutput> {
            return localVarFp.requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(requestParameters.communityId, requestParameters.requestPayoutInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost operation in LedgerApi.
 * @export
 * @interface LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest
 */
export interface LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPost
     */
    readonly payoutId: string

    /**
     * 
     * @type {CancelPayoutInput}
     * @memberof LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPost
     */
    readonly cancelPayoutInput: CancelPayoutInput
}

/**
 * Request parameters for getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet operation in LedgerApi.
 * @export
 * @interface LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest
 */
export interface LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet
     */
    readonly communityId: string

    /**
     * 
     * @type {number}
     * @memberof LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet
     */
    readonly offset?: number

    /**
     * 
     * @type {PayoutStatus}
     * @memberof LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet
     */
    readonly status?: PayoutStatus
}

/**
 * Request parameters for getEventRevenueLedgerEventsEventIdRevenueGet operation in LedgerApi.
 * @export
 * @interface LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest
 */
export interface LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet operation in LedgerApi.
 * @export
 * @interface LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest
 */
export interface LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet operation in LedgerApi.
 * @export
 * @interface LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest
 */
export interface LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly communityId: string

    /**
     * 
     * @type {number}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly offset?: number

    /**
     * 
     * @type {LedgerEntryType}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly entryType?: LedgerEntryType

    /**
     * 
     * @type {LedgerEntrySource}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly source?: LedgerEntrySource

    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for getPayoutLedgerPayoutsPayoutIdGet operation in LedgerApi.
 * @export
 * @interface LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest
 */
export interface LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiGetPayoutLedgerPayoutsPayoutIdGet
     */
    readonly payoutId: string
}

/**
 * Request parameters for processPayoutLedgerAdminPayoutsPayoutIdProcessPost operation in LedgerApi.
 * @export
 * @interface LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest
 */
export interface LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPost
     */
    readonly payoutId: string

    /**
     * 
     * @type {ProcessPayoutInput}
     * @memberof LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPost
     */
    readonly processPayoutInput: ProcessPayoutInput
}

/**
 * Request parameters for recordAdjustmentLedgerAdminAdjustmentsPost operation in LedgerApi.
 * @export
 * @interface LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest
 */
export interface LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest {
    /**
     * 
     * @type {RecordAdjustmentInput}
     * @memberof LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPost
     */
    readonly recordAdjustmentInput: RecordAdjustmentInput
}

/**
 * Request parameters for requestPayoutLedgerCommunitiesCommunityIdPayoutsPost operation in LedgerApi.
 * @export
 * @interface LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest
 */
export interface LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPost
     */
    readonly communityId: string

    /**
     * 
     * @type {RequestPayoutInput}
     * @memberof LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPost
     */
    readonly requestPayoutInput: RequestPayoutInput
}

/**
 * LedgerApi - object-oriented interface
 * @export
 * @class LedgerApi
 * @extends {BaseAPI}
 */
export class LedgerApi extends BaseAPI {
    /**
     * Cancel a pending payout (admin only).
     * @summary Cancel Payout
     * @param {LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(requestParameters: LedgerApiCancelPayoutLedgerAdminPayoutsPayoutIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).cancelPayoutLedgerAdminPayoutsPayoutIdCancelPost(requestParameters.payoutId, requestParameters.cancelPayoutInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payouts for a community.
     * @summary Get Community Payouts
     * @param {LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(requestParameters: LedgerApiGetCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGetRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getCommunityPayoutsLedgerCommunitiesCommunityIdPayoutsGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get revenue summary for a specific event. Only community owners can access.
     * @summary Get Event Revenue
     * @param {LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getEventRevenueLedgerEventsEventIdRevenueGet(requestParameters: LedgerApiGetEventRevenueLedgerEventsEventIdRevenueGetRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getEventRevenueLedgerEventsEventIdRevenueGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current balance for a community\'s ledger.
     * @summary Get Ledger Balance
     * @param {LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(requestParameters: LedgerApiGetLedgerBalanceLedgerCommunitiesCommunityIdBalanceGetRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getLedgerBalanceLedgerCommunitiesCommunityIdBalanceGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ledger entries for a community with optional filters.
     * @summary Get Ledger Entries
     * @param {LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(requestParameters: LedgerApiGetLedgerEntriesLedgerCommunitiesCommunityIdEntriesGetRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getLedgerEntriesLedgerCommunitiesCommunityIdEntriesGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, requestParameters.entryType, requestParameters.source, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific payout by ID. Only community owners can access.
     * @summary Get Payout
     * @param {LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getPayoutLedgerPayoutsPayoutIdGet(requestParameters: LedgerApiGetPayoutLedgerPayoutsPayoutIdGetRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getPayoutLedgerPayoutsPayoutIdGet(requestParameters.payoutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all pending payouts (admin only).
     * @summary Get Pending Payouts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public getPendingPayoutsLedgerAdminPayoutsPendingGet(options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).getPendingPayoutsLedgerAdminPayoutsPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Process a pending payout (admin only).
     * @summary Process Payout
     * @param {LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public processPayoutLedgerAdminPayoutsPayoutIdProcessPost(requestParameters: LedgerApiProcessPayoutLedgerAdminPayoutsPayoutIdProcessPostRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).processPayoutLedgerAdminPayoutsPayoutIdProcessPost(requestParameters.payoutId, requestParameters.processPayoutInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record a manual adjustment to a community ledger (admin only).
     * @summary Record Adjustment
     * @param {LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public recordAdjustmentLedgerAdminAdjustmentsPost(requestParameters: LedgerApiRecordAdjustmentLedgerAdminAdjustmentsPostRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).recordAdjustmentLedgerAdminAdjustmentsPost(requestParameters.recordAdjustmentInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a payout for a community. Only community owners can request payouts.
     * @summary Request Payout
     * @param {LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerApi
     */
    public requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(requestParameters: LedgerApiRequestPayoutLedgerCommunitiesCommunityIdPayoutsPostRequest, options?: RawAxiosRequestConfig) {
        return LedgerApiFp(this.configuration).requestPayoutLedgerCommunitiesCommunityIdPayoutsPost(requestParameters.communityId, requestParameters.requestPayoutInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromosApi - axios parameter creator
 * @export
 */
export const PromosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a user as an editor for a group promo.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Add Group Promo Editor
         * @param {string} groupPromoId 
         * @param {CreateGroupPromoEditorInput} createGroupPromoEditorInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost: async (groupPromoId: string, createGroupPromoEditorInput: CreateGroupPromoEditorInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost', 'groupPromoId', groupPromoId)
            // verify required parameter 'createGroupPromoEditorInput' is not null or undefined
            assertParamExists('addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost', 'createGroupPromoEditorInput', createGroupPromoEditorInput)
            const localVarPath = `/promos/group-promos/{group_promo_id}/editors/`
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupPromoEditorInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk list group promos across multiple communities.  Returns only group promos where the requesting user is an editor.
         * @summary Bulk List Group Promos By Communities
         * @param {BulkListGroupPromosInput} bulkListGroupPromosInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost: async (bulkListGroupPromosInput: BulkListGroupPromosInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkListGroupPromosInput' is not null or undefined
            assertParamExists('bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost', 'bulkListGroupPromosInput', bulkListGroupPromosInput)
            const localVarPath = `/promos/group-promos/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkListGroupPromosInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new group promo (requires OWNER or EDITOR role)
         * @summary Create Group Promo
         * @param {string} communityId 
         * @param {CreateGroupPromoInput} createGroupPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost: async (communityId: string, createGroupPromoInput: CreateGroupPromoInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost', 'communityId', communityId)
            // verify required parameter 'createGroupPromoInput' is not null or undefined
            assertParamExists('createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost', 'createGroupPromoInput', createGroupPromoInput)
            const localVarPath = `/promos/communities/{community_id}/group-promos/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupPromoInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Promo
         * @param {string} communityId 
         * @param {CreatePromoInput} createPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoPromosCommunitiesCommunityIdPost: async (communityId: string, createPromoInput: CreatePromoInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createPromoPromosCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createPromoInput' is not null or undefined
            assertParamExists('createPromoPromosCommunitiesCommunityIdPost', 'createPromoInput', createPromoInput)
            const localVarPath = `/promos/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPromoInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user promo relationship
         * @summary Create User Promo
         * @param {string} communityId 
         * @param {CreateUserPromoInput} createUserPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPromoPromosCommunitiesCommunityIdUserPromosPost: async (communityId: string, createUserPromoInput: CreateUserPromoInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createUserPromoPromosCommunitiesCommunityIdUserPromosPost', 'communityId', communityId)
            // verify required parameter 'createUserPromoInput' is not null or undefined
            assertParamExists('createUserPromoPromosCommunitiesCommunityIdUserPromosPost', 'createUserPromoInput', createUserPromoInput)
            const localVarPath = `/promos/communities/{community_id}/user-promos/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserPromoInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an editor from a group promo by user and group IDs.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor By User And Group
         * @param {string} groupPromoId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete: async (groupPromoId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete', 'groupPromoId', groupPromoId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete', 'userId', userId)
            const localVarPath = `/promos/group-promos/{group_promo_id}/editors/{user_id}/`
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an editor from a group promo by editor ID.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor
         * @param {string} editorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete: async (editorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editorId' is not null or undefined
            assertParamExists('deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete', 'editorId', editorId)
            const localVarPath = `/promos/group-promo-editors/{editor_id}/`
                .replace(`{${"editor_id"}}`, encodeURIComponent(String(editorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a group promo (requires OWNER or EDITOR role)
         * @summary Delete Group Promo
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoPromosGroupPromosGroupPromoIdDelete: async (groupPromoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('deleteGroupPromoPromosGroupPromosGroupPromoIdDelete', 'groupPromoId', groupPromoId)
            const localVarPath = `/promos/group-promos/{group_promo_id}/`
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a promo by setting is_active=False. Validates that the promo belongs to the specified community.
         * @summary Delete Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromoPromosPromoIdCommunitiesCommunityIdDelete: async (promoId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('deletePromoPromosPromoIdCommunitiesCommunityIdDelete', 'promoId', promoId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deletePromoPromosPromoIdCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/promos/{promo_id}/communities/{community_id}/`
                .replace(`{${"promo_id"}}`, encodeURIComponent(String(promoId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user promo by user and promo IDs
         * @summary Delete User Promo By User And Promo
         * @param {string} userId 
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete: async (userId: string, promoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete', 'userId', userId)
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete', 'promoId', promoId)
            const localVarPath = `/promos/users/{user_id}/promos/{promo_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"promo_id"}}`, encodeURIComponent(String(promoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user promo by ID
         * @summary Delete User Promo
         * @param {string} communityId 
         * @param {string} userPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete: async (communityId: string, userPromoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete', 'communityId', communityId)
            // verify required parameter 'userPromoId' is not null or undefined
            assertParamExists('deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete', 'userPromoId', userPromoId)
            const localVarPath = `/promos/communities/{community_id}/user-promos/{user_promo_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"user_promo_id"}}`, encodeURIComponent(String(userPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a group promo by slug (PUBLIC ACCESS - no authentication required)
         * @summary Get Group Promo By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPromoBySlugPromosGroupPromosSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getGroupPromoBySlugPromosGroupPromosSlugGet', 'slug', slug)
            const localVarPath = `/promos/group-promos/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single group promo by ID (requires OWNER or EDITOR role)
         * @summary Get Group Promo
         * @param {string} communityId 
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet: async (communityId: string, groupPromoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet', 'communityId', communityId)
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet', 'groupPromoId', groupPromoId)
            const localVarPath = `/promos/communities/{community_id}/group-promos/{group_promo_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoPromosPromoIdCommunitiesCommunityIdGet: async (promoId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('getPromoPromosPromoIdCommunitiesCommunityIdGet', 'promoId', promoId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getPromoPromosPromoIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/promos/{promo_id}/communities/{community_id}/`
                .replace(`{${"promo_id"}}`, encodeURIComponent(String(promoId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Promos By Community
         * @param {string} communityId 
         * @param {boolean} [isSystemGenerated] Filter by system generated promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByCommunityPromosCommunitiesCommunityIdGet: async (communityId: string, isSystemGenerated?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getPromosByCommunityPromosCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/promos/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (isSystemGenerated !== undefined) {
                localVarQueryParameter['is_system_generated'] = isSystemGenerated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Promos By Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {boolean} [isSystemGenerated] Filter by system generated promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet: async (eventId: string, communityId: string, isSystemGenerated?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet', 'eventId', eventId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/promos/events/{event_id}/communities/{community_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (isSystemGenerated !== undefined) {
                localVarQueryParameter['is_system_generated'] = isSystemGenerated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosPromosGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/promos/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user promo by ID
         * @summary Get User Promo
         * @param {string} communityId 
         * @param {string} userPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet: async (communityId: string, userPromoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet', 'communityId', communityId)
            // verify required parameter 'userPromoId' is not null or undefined
            assertParamExists('getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet', 'userPromoId', userPromoId)
            const localVarPath = `/promos/communities/{community_id}/user-promos/{user_promo_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"user_promo_id"}}`, encodeURIComponent(String(userPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all user promos for a specific promo
         * @summary Get User Promos By Promo
         * @param {string} communityId 
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet: async (communityId: string, promoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet', 'communityId', communityId)
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet', 'promoId', promoId)
            const localVarPath = `/promos/communities/{community_id}/promo-users/{promo_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"promo_id"}}`, encodeURIComponent(String(promoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all user promos for a specific user
         * @summary Get User Promos By User
         * @param {string} communityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet: async (communityId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet', 'communityId', communityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet', 'userId', userId)
            const localVarPath = `/promos/communities/{community_id}/users/{user_id}/promos/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all editors for a group promo.  Authorization: User must be OWNER/EDITOR of the community,  OR be in GroupPromoEditor, OR have UserPromo relationship to a promo in the group.
         * @summary List Group Promo Editors
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet: async (groupPromoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet', 'groupPromoId', groupPromoId)
            const localVarPath = `/promos/group-promos/{group_promo_id}/editors/`
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all group promos for a community (requires OWNER or EDITOR role)
         * @summary List Group Promos By Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet', 'communityId', communityId)
            const localVarPath = `/promos/communities/{community_id}/group-promos/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List group promos the requesting user is an editor of for a specific community.  Returns only group promos where the user has been added as a GroupPromoEditor. This is useful for users who need to find their group promos without knowing the slug.
         * @summary List My Group Promos
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet', 'communityId', communityId)
            const localVarPath = `/promos/communities/{community_id}/my-group-promos/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a group promo (requires OWNER or EDITOR role)
         * @summary Update Group Promo
         * @param {string} communityId 
         * @param {string} groupPromoId 
         * @param {UpdateGroupPromoInput} updateGroupPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch: async (communityId: string, groupPromoId: string, updateGroupPromoInput: UpdateGroupPromoInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch', 'communityId', communityId)
            // verify required parameter 'groupPromoId' is not null or undefined
            assertParamExists('updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch', 'groupPromoId', groupPromoId)
            // verify required parameter 'updateGroupPromoInput' is not null or undefined
            assertParamExists('updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch', 'updateGroupPromoInput', updateGroupPromoInput)
            const localVarPath = `/promos/communities/{community_id}/group-promos/{group_promo_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"group_promo_id"}}`, encodeURIComponent(String(groupPromoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupPromoInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {UpdatePromoInput} updatePromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoPromosPromoIdCommunitiesCommunityIdPut: async (promoId: string, communityId: string, updatePromoInput: UpdatePromoInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('updatePromoPromosPromoIdCommunitiesCommunityIdPut', 'promoId', promoId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updatePromoPromosPromoIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updatePromoInput' is not null or undefined
            assertParamExists('updatePromoPromosPromoIdCommunitiesCommunityIdPut', 'updatePromoInput', updatePromoInput)
            const localVarPath = `/promos/{promo_id}/communities/{community_id}/`
                .replace(`{${"promo_id"}}`, encodeURIComponent(String(promoId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePromoInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a discount code against multiple ticket types.  Args:     request: The HTTP request     ticket_type_ids: List of ticket type IDs to validate against     discount_code: The discount code to validate     current_user: The authenticated user     db: Database session      Returns:     Promo object if found and valid
         * @summary Validate Discount Code For Multiple Ticket Types
         * @param {string} discountCode 
         * @param {ValidateMultiDiscountCodeInput} validateMultiDiscountCodeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost: async (discountCode: string, validateMultiDiscountCodeInput: ValidateMultiDiscountCodeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discountCode' is not null or undefined
            assertParamExists('validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost', 'discountCode', discountCode)
            // verify required parameter 'validateMultiDiscountCodeInput' is not null or undefined
            assertParamExists('validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost', 'validateMultiDiscountCodeInput', validateMultiDiscountCodeInput)
            const localVarPath = `/promos/validate/{discount_code}/`
                .replace(`{${"discount_code"}}`, encodeURIComponent(String(discountCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateMultiDiscountCodeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Discount Code For Ticket Type
         * @param {string} ticketTypeId 
         * @param {string} discountCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet: async (ticketTypeId: string, discountCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketTypeId' is not null or undefined
            assertParamExists('validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet', 'ticketTypeId', ticketTypeId)
            // verify required parameter 'discountCode' is not null or undefined
            assertParamExists('validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet', 'discountCode', discountCode)
            const localVarPath = `/promos/tickets/type/{ticket_type_id}/validate/{discount_code}/`
                .replace(`{${"ticket_type_id"}}`, encodeURIComponent(String(ticketTypeId)))
                .replace(`{${"discount_code"}}`, encodeURIComponent(String(discountCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromosApi - functional programming interface
 * @export
 */
export const PromosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromosApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a user as an editor for a group promo.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Add Group Promo Editor
         * @param {string} groupPromoId 
         * @param {CreateGroupPromoEditorInput} createGroupPromoEditorInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(groupPromoId: string, createGroupPromoEditorInput: CreateGroupPromoEditorInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupPromoEditorOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(groupPromoId, createGroupPromoEditorInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Bulk list group promos across multiple communities.  Returns only group promos where the requesting user is an editor.
         * @summary Bulk List Group Promos By Communities
         * @param {BulkListGroupPromosInput} bulkListGroupPromosInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(bulkListGroupPromosInput: BulkListGroupPromosInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupPromoMetadataOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(bulkListGroupPromosInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new group promo (requires OWNER or EDITOR role)
         * @summary Create Group Promo
         * @param {string} communityId 
         * @param {CreateGroupPromoInput} createGroupPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(communityId: string, createGroupPromoInput: CreateGroupPromoInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WonkaPromosOutputsGroupPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(communityId, createGroupPromoInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Promo
         * @param {string} communityId 
         * @param {CreatePromoInput} createPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoPromosCommunitiesCommunityIdPost(communityId: string, createPromoInput: CreatePromoInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Promo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoPromosCommunitiesCommunityIdPost(communityId, createPromoInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.createPromoPromosCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new user promo relationship
         * @summary Create User Promo
         * @param {string} communityId 
         * @param {CreateUserPromoInput} createUserPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserPromoPromosCommunitiesCommunityIdUserPromosPost(communityId: string, createUserPromoInput: CreateUserPromoInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserPromoPromosCommunitiesCommunityIdUserPromosPost(communityId, createUserPromoInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.createUserPromoPromosCommunitiesCommunityIdUserPromosPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove an editor from a group promo by user and group IDs.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor By User And Group
         * @param {string} groupPromoId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(groupPromoId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteGroupPromoEditorByUserAndGroupOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(groupPromoId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove an editor from a group promo by editor ID.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor
         * @param {string} editorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(editorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteGroupPromoEditorOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(editorId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Soft delete a group promo (requires OWNER or EDITOR role)
         * @summary Delete Group Promo
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(groupPromoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteGroupPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(groupPromoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deleteGroupPromoPromosGroupPromosGroupPromoIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Soft delete a promo by setting is_active=False. Validates that the promo belongs to the specified community.
         * @summary Delete Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromoPromosPromoIdCommunitiesCommunityIdDelete(promoId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletePromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromoPromosPromoIdCommunitiesCommunityIdDelete(promoId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deletePromoPromosPromoIdCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a user promo by user and promo IDs
         * @summary Delete User Promo By User And Promo
         * @param {string} userId 
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(userId: string, promoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserPromoByUserAndPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(userId, promoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a user promo by ID
         * @summary Delete User Promo
         * @param {string} communityId 
         * @param {string} userPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(communityId: string, userPromoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(communityId, userPromoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a group promo by slug (PUBLIC ACCESS - no authentication required)
         * @summary Get Group Promo By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupPromoBySlugPromosGroupPromosSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WonkaPromosOutputsGroupPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupPromoBySlugPromosGroupPromosSlugGet(slug, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getGroupPromoBySlugPromosGroupPromosSlugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a single group promo by ID (requires OWNER or EDITOR role)
         * @summary Get Group Promo
         * @param {string} communityId 
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(communityId: string, groupPromoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WonkaPromosOutputsGroupPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(communityId, groupPromoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoPromosPromoIdCommunitiesCommunityIdGet(promoId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Promo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoPromosPromoIdCommunitiesCommunityIdGet(promoId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getPromoPromosPromoIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Promos By Community
         * @param {string} communityId 
         * @param {boolean} [isSystemGenerated] Filter by system generated promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromosByCommunityPromosCommunitiesCommunityIdGet(communityId: string, isSystemGenerated?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Promo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromosByCommunityPromosCommunitiesCommunityIdGet(communityId, isSystemGenerated, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getPromosByCommunityPromosCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Promos By Event
         * @param {string} eventId 
         * @param {string} communityId 
         * @param {boolean} [isSystemGenerated] Filter by system generated promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(eventId: string, communityId: string, isSystemGenerated?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Promo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(eventId, communityId, isSystemGenerated, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromosPromosGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Promo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromosPromosGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getPromosPromosGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a user promo by ID
         * @summary Get User Promo
         * @param {string} communityId 
         * @param {string} userPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(communityId: string, userPromoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(communityId, userPromoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all user promos for a specific promo
         * @summary Get User Promos By Promo
         * @param {string} communityId 
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(communityId: string, promoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPromoOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(communityId, promoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all user promos for a specific user
         * @summary Get User Promos By User
         * @param {string} communityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(communityId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPromoOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(communityId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all editors for a group promo.  Authorization: User must be OWNER/EDITOR of the community,  OR be in GroupPromoEditor, OR have UserPromo relationship to a promo in the group.
         * @summary List Group Promo Editors
         * @param {string} groupPromoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(groupPromoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupPromoEditorOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(groupPromoId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all group promos for a community (requires OWNER or EDITOR role)
         * @summary List Group Promos By Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WonkaPromosOutputsGroupPromoOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List group promos the requesting user is an editor of for a specific community.  Returns only group promos where the user has been added as a GroupPromoEditor. This is useful for users who need to find their group promos without knowing the slug.
         * @summary List My Group Promos
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WonkaPromosOutputsGroupPromoOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a group promo (requires OWNER or EDITOR role)
         * @summary Update Group Promo
         * @param {string} communityId 
         * @param {string} groupPromoId 
         * @param {UpdateGroupPromoInput} updateGroupPromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(communityId: string, groupPromoId: string, updateGroupPromoInput: UpdateGroupPromoInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WonkaPromosOutputsGroupPromoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(communityId, groupPromoId, updateGroupPromoInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Promo
         * @param {string} promoId 
         * @param {string} communityId 
         * @param {UpdatePromoInput} updatePromoInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromoPromosPromoIdCommunitiesCommunityIdPut(promoId: string, communityId: string, updatePromoInput: UpdatePromoInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Promo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromoPromosPromoIdCommunitiesCommunityIdPut(promoId, communityId, updatePromoInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.updatePromoPromosPromoIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Validate a discount code against multiple ticket types.  Args:     request: The HTTP request     ticket_type_ids: List of ticket type IDs to validate against     discount_code: The discount code to validate     current_user: The authenticated user     db: Database session      Returns:     Promo object if found and valid
         * @summary Validate Discount Code For Multiple Ticket Types
         * @param {string} discountCode 
         * @param {ValidateMultiDiscountCodeInput} validateMultiDiscountCodeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(discountCode: string, validateMultiDiscountCodeInput: ValidateMultiDiscountCodeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Promo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(discountCode, validateMultiDiscountCodeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Discount Code For Ticket Type
         * @param {string} ticketTypeId 
         * @param {string} discountCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(ticketTypeId: string, discountCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Promo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(ticketTypeId, discountCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PromosApi.validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PromosApi - factory interface
 * @export
 */
export const PromosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromosApiFp(configuration)
    return {
        /**
         * Add a user as an editor for a group promo.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Add Group Promo Editor
         * @param {PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(requestParameters: PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupPromoEditorOutput> {
            return localVarFp.addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(requestParameters.groupPromoId, requestParameters.createGroupPromoEditorInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk list group promos across multiple communities.  Returns only group promos where the requesting user is an editor.
         * @summary Bulk List Group Promos By Communities
         * @param {PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(requestParameters: PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupPromoMetadataOutput>> {
            return localVarFp.bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(requestParameters.bulkListGroupPromosInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new group promo (requires OWNER or EDITOR role)
         * @summary Create Group Promo
         * @param {PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(requestParameters: PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WonkaPromosOutputsGroupPromoOutput> {
            return localVarFp.createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(requestParameters.communityId, requestParameters.createGroupPromoInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Promo
         * @param {PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoPromosCommunitiesCommunityIdPost(requestParameters: PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Promo> {
            return localVarFp.createPromoPromosCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createPromoInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user promo relationship
         * @summary Create User Promo
         * @param {PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPromoPromosCommunitiesCommunityIdUserPromosPost(requestParameters: PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserPromoOutput> {
            return localVarFp.createUserPromoPromosCommunitiesCommunityIdUserPromosPost(requestParameters.communityId, requestParameters.createUserPromoInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove an editor from a group promo by user and group IDs.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor By User And Group
         * @param {PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(requestParameters: PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteGroupPromoEditorByUserAndGroupOutput> {
            return localVarFp.deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(requestParameters.groupPromoId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove an editor from a group promo by editor ID.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
         * @summary Delete Group Promo Editor
         * @param {PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(requestParameters: PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteGroupPromoEditorOutput> {
            return localVarFp.deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(requestParameters.editorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a group promo (requires OWNER or EDITOR role)
         * @summary Delete Group Promo
         * @param {PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(requestParameters: PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteGroupPromoOutput> {
            return localVarFp.deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(requestParameters.groupPromoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a promo by setting is_active=False. Validates that the promo belongs to the specified community.
         * @summary Delete Promo
         * @param {PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromoPromosPromoIdCommunitiesCommunityIdDelete(requestParameters: PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeletePromoOutput> {
            return localVarFp.deletePromoPromosPromoIdCommunitiesCommunityIdDelete(requestParameters.promoId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a user promo by user and promo IDs
         * @summary Delete User Promo By User And Promo
         * @param {PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(requestParameters: PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteUserPromoByUserAndPromoOutput> {
            return localVarFp.deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(requestParameters.userId, requestParameters.promoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a user promo by ID
         * @summary Delete User Promo
         * @param {PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(requestParameters: PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteUserPromoOutput> {
            return localVarFp.deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(requestParameters.communityId, requestParameters.userPromoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a group promo by slug (PUBLIC ACCESS - no authentication required)
         * @summary Get Group Promo By Slug
         * @param {PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPromoBySlugPromosGroupPromosSlugGet(requestParameters: PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WonkaPromosOutputsGroupPromoOutput> {
            return localVarFp.getGroupPromoBySlugPromosGroupPromosSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single group promo by ID (requires OWNER or EDITOR role)
         * @summary Get Group Promo
         * @param {PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(requestParameters: PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WonkaPromosOutputsGroupPromoOutput> {
            return localVarFp.getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(requestParameters.communityId, requestParameters.groupPromoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Promo
         * @param {PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoPromosPromoIdCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Promo> {
            return localVarFp.getPromoPromosPromoIdCommunitiesCommunityIdGet(requestParameters.promoId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Promos By Community
         * @param {PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByCommunityPromosCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Promo>> {
            return localVarFp.getPromosByCommunityPromosCommunitiesCommunityIdGet(requestParameters.communityId, requestParameters.isSystemGenerated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Promos By Event
         * @param {PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Promo>> {
            return localVarFp.getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(requestParameters.eventId, requestParameters.communityId, requestParameters.isSystemGenerated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosPromosGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Promo>> {
            return localVarFp.getPromosPromosGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user promo by ID
         * @summary Get User Promo
         * @param {PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(requestParameters: PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserPromoOutput> {
            return localVarFp.getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(requestParameters.communityId, requestParameters.userPromoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all user promos for a specific promo
         * @summary Get User Promos By Promo
         * @param {PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(requestParameters: PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserPromoOutput>> {
            return localVarFp.getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(requestParameters.communityId, requestParameters.promoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all user promos for a specific user
         * @summary Get User Promos By User
         * @param {PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(requestParameters: PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserPromoOutput>> {
            return localVarFp.getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(requestParameters.communityId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all editors for a group promo.  Authorization: User must be OWNER/EDITOR of the community,  OR be in GroupPromoEditor, OR have UserPromo relationship to a promo in the group.
         * @summary List Group Promo Editors
         * @param {PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(requestParameters: PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupPromoEditorOutput>> {
            return localVarFp.listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(requestParameters.groupPromoId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all group promos for a community (requires OWNER or EDITOR role)
         * @summary List Group Promos By Community
         * @param {PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(requestParameters: PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WonkaPromosOutputsGroupPromoOutput>> {
            return localVarFp.listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * List group promos the requesting user is an editor of for a specific community.  Returns only group promos where the user has been added as a GroupPromoEditor. This is useful for users who need to find their group promos without knowing the slug.
         * @summary List My Group Promos
         * @param {PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(requestParameters: PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WonkaPromosOutputsGroupPromoOutput>> {
            return localVarFp.listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a group promo (requires OWNER or EDITOR role)
         * @summary Update Group Promo
         * @param {PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(requestParameters: PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<WonkaPromosOutputsGroupPromoOutput> {
            return localVarFp.updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(requestParameters.communityId, requestParameters.groupPromoId, requestParameters.updateGroupPromoInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Promo
         * @param {PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoPromosPromoIdCommunitiesCommunityIdPut(requestParameters: PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Promo> {
            return localVarFp.updatePromoPromosPromoIdCommunitiesCommunityIdPut(requestParameters.promoId, requestParameters.communityId, requestParameters.updatePromoInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a discount code against multiple ticket types.  Args:     request: The HTTP request     ticket_type_ids: List of ticket type IDs to validate against     discount_code: The discount code to validate     current_user: The authenticated user     db: Database session      Returns:     Promo object if found and valid
         * @summary Validate Discount Code For Multiple Ticket Types
         * @param {PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(requestParameters: PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Promo>> {
            return localVarFp.validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(requestParameters.discountCode, requestParameters.validateMultiDiscountCodeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Discount Code For Ticket Type
         * @param {PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(requestParameters: PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Promo> {
            return localVarFp.validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(requestParameters.ticketTypeId, requestParameters.discountCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost operation in PromosApi.
 * @export
 * @interface PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest
 */
export interface PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost
     */
    readonly groupPromoId: string

    /**
     * 
     * @type {CreateGroupPromoEditorInput}
     * @memberof PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost
     */
    readonly createGroupPromoEditorInput: CreateGroupPromoEditorInput
}

/**
 * Request parameters for bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost operation in PromosApi.
 * @export
 * @interface PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest
 */
export interface PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest {
    /**
     * 
     * @type {BulkListGroupPromosInput}
     * @memberof PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost
     */
    readonly bulkListGroupPromosInput: BulkListGroupPromosInput
}

/**
 * Request parameters for createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost operation in PromosApi.
 * @export
 * @interface PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest
 */
export interface PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateGroupPromoInput}
     * @memberof PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPost
     */
    readonly createGroupPromoInput: CreateGroupPromoInput
}

/**
 * Request parameters for createPromoPromosCommunitiesCommunityIdPost operation in PromosApi.
 * @export
 * @interface PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest
 */
export interface PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiCreatePromoPromosCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreatePromoInput}
     * @memberof PromosApiCreatePromoPromosCommunitiesCommunityIdPost
     */
    readonly createPromoInput: CreatePromoInput
}

/**
 * Request parameters for createUserPromoPromosCommunitiesCommunityIdUserPromosPost operation in PromosApi.
 * @export
 * @interface PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest
 */
export interface PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateUserPromoInput}
     * @memberof PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPost
     */
    readonly createUserPromoInput: CreateUserPromoInput
}

/**
 * Request parameters for deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest
 */
export interface PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete
     */
    readonly groupPromoId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete
     */
    readonly userId: string
}

/**
 * Request parameters for deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest
 */
export interface PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete
     */
    readonly editorId: string
}

/**
 * Request parameters for deleteGroupPromoPromosGroupPromosGroupPromoIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest
 */
export interface PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDelete
     */
    readonly groupPromoId: string
}

/**
 * Request parameters for deletePromoPromosPromoIdCommunitiesCommunityIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest
 */
export interface PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDelete
     */
    readonly promoId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest
 */
export interface PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete
     */
    readonly promoId: string
}

/**
 * Request parameters for deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete operation in PromosApi.
 * @export
 * @interface PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest
 */
export interface PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete
     */
    readonly userPromoId: string
}

/**
 * Request parameters for getGroupPromoBySlugPromosGroupPromosSlugGet operation in PromosApi.
 * @export
 * @interface PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest
 */
export interface PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGet
     */
    readonly slug: string
}

/**
 * Request parameters for getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest
 */
export interface PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet
     */
    readonly groupPromoId: string
}

/**
 * Request parameters for getPromoPromosPromoIdCommunitiesCommunityIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest
 */
export interface PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGet
     */
    readonly promoId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getPromosByCommunityPromosCommunitiesCommunityIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest
 */
export interface PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGet
     */
    readonly communityId: string

    /**
     * Filter by system generated promos
     * @type {boolean}
     * @memberof PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGet
     */
    readonly isSystemGenerated?: boolean
}

/**
 * Request parameters for getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest
 */
export interface PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet
     */
    readonly communityId: string

    /**
     * Filter by system generated promos
     * @type {boolean}
     * @memberof PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet
     */
    readonly isSystemGenerated?: boolean
}

/**
 * Request parameters for getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest
 */
export interface PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet
     */
    readonly userPromoId: string
}

/**
 * Request parameters for getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet operation in PromosApi.
 * @export
 * @interface PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest
 */
export interface PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet
     */
    readonly promoId: string
}

/**
 * Request parameters for getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet operation in PromosApi.
 * @export
 * @interface PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest
 */
export interface PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet
     */
    readonly userId: string
}

/**
 * Request parameters for listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet operation in PromosApi.
 * @export
 * @interface PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest
 */
export interface PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet
     */
    readonly groupPromoId: string
}

/**
 * Request parameters for listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet operation in PromosApi.
 * @export
 * @interface PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest
 */
export interface PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet
     */
    readonly communityId: string
}

/**
 * Request parameters for listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet operation in PromosApi.
 * @export
 * @interface PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest
 */
export interface PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet
     */
    readonly communityId: string
}

/**
 * Request parameters for updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch operation in PromosApi.
 * @export
 * @interface PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest
 */
export interface PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch
     */
    readonly groupPromoId: string

    /**
     * 
     * @type {UpdateGroupPromoInput}
     * @memberof PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch
     */
    readonly updateGroupPromoInput: UpdateGroupPromoInput
}

/**
 * Request parameters for updatePromoPromosPromoIdCommunitiesCommunityIdPut operation in PromosApi.
 * @export
 * @interface PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest
 */
export interface PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPut
     */
    readonly promoId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdatePromoInput}
     * @memberof PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPut
     */
    readonly updatePromoInput: UpdatePromoInput
}

/**
 * Request parameters for validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost operation in PromosApi.
 * @export
 * @interface PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest
 */
export interface PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost
     */
    readonly discountCode: string

    /**
     * 
     * @type {ValidateMultiDiscountCodeInput}
     * @memberof PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost
     */
    readonly validateMultiDiscountCodeInput: ValidateMultiDiscountCodeInput
}

/**
 * Request parameters for validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet operation in PromosApi.
 * @export
 * @interface PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest
 */
export interface PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet
     */
    readonly ticketTypeId: string

    /**
     * 
     * @type {string}
     * @memberof PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet
     */
    readonly discountCode: string
}

/**
 * PromosApi - object-oriented interface
 * @export
 * @class PromosApi
 * @extends {BaseAPI}
 */
export class PromosApi extends BaseAPI {
    /**
     * Add a user as an editor for a group promo.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
     * @summary Add Group Promo Editor
     * @param {PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(requestParameters: PromosApiAddGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).addGroupPromoEditorPromosGroupPromosGroupPromoIdEditorsPost(requestParameters.groupPromoId, requestParameters.createGroupPromoEditorInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk list group promos across multiple communities.  Returns only group promos where the requesting user is an editor.
     * @summary Bulk List Group Promos By Communities
     * @param {PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(requestParameters: PromosApiBulkListGroupPromosByCommunitiesPromosGroupPromosBulkPostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).bulkListGroupPromosByCommunitiesPromosGroupPromosBulkPost(requestParameters.bulkListGroupPromosInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new group promo (requires OWNER or EDITOR role)
     * @summary Create Group Promo
     * @param {PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(requestParameters: PromosApiCreateGroupPromoPromosCommunitiesCommunityIdGroupPromosPostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).createGroupPromoPromosCommunitiesCommunityIdGroupPromosPost(requestParameters.communityId, requestParameters.createGroupPromoInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Promo
     * @param {PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public createPromoPromosCommunitiesCommunityIdPost(requestParameters: PromosApiCreatePromoPromosCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).createPromoPromosCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createPromoInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user promo relationship
     * @summary Create User Promo
     * @param {PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public createUserPromoPromosCommunitiesCommunityIdUserPromosPost(requestParameters: PromosApiCreateUserPromoPromosCommunitiesCommunityIdUserPromosPostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).createUserPromoPromosCommunitiesCommunityIdUserPromosPost(requestParameters.communityId, requestParameters.createUserPromoInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove an editor from a group promo by user and group IDs.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
     * @summary Delete Group Promo Editor By User And Group
     * @param {PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(requestParameters: PromosApiDeleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deleteGroupPromoEditorByUserAndGroupPromosGroupPromosGroupPromoIdEditorsUserIdDelete(requestParameters.groupPromoId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove an editor from a group promo by editor ID.  Authorization: User must be OWNER/EDITOR of the community OR be in GroupPromoEditor.
     * @summary Delete Group Promo Editor
     * @param {PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(requestParameters: PromosApiDeleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deleteGroupPromoEditorPromosGroupPromoEditorsEditorIdDelete(requestParameters.editorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a group promo (requires OWNER or EDITOR role)
     * @summary Delete Group Promo
     * @param {PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(requestParameters: PromosApiDeleteGroupPromoPromosGroupPromosGroupPromoIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deleteGroupPromoPromosGroupPromosGroupPromoIdDelete(requestParameters.groupPromoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a promo by setting is_active=False. Validates that the promo belongs to the specified community.
     * @summary Delete Promo
     * @param {PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deletePromoPromosPromoIdCommunitiesCommunityIdDelete(requestParameters: PromosApiDeletePromoPromosPromoIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deletePromoPromosPromoIdCommunitiesCommunityIdDelete(requestParameters.promoId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a user promo by user and promo IDs
     * @summary Delete User Promo By User And Promo
     * @param {PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(requestParameters: PromosApiDeleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deleteUserPromoByUserAndPromoPromosUsersUserIdPromosPromoIdDelete(requestParameters.userId, requestParameters.promoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a user promo by ID
     * @summary Delete User Promo
     * @param {PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(requestParameters: PromosApiDeleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).deleteUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdDelete(requestParameters.communityId, requestParameters.userPromoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a group promo by slug (PUBLIC ACCESS - no authentication required)
     * @summary Get Group Promo By Slug
     * @param {PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getGroupPromoBySlugPromosGroupPromosSlugGet(requestParameters: PromosApiGetGroupPromoBySlugPromosGroupPromosSlugGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getGroupPromoBySlugPromosGroupPromosSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single group promo by ID (requires OWNER or EDITOR role)
     * @summary Get Group Promo
     * @param {PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(requestParameters: PromosApiGetGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdGet(requestParameters.communityId, requestParameters.groupPromoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Promo
     * @param {PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getPromoPromosPromoIdCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromoPromosPromoIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getPromoPromosPromoIdCommunitiesCommunityIdGet(requestParameters.promoId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Promos By Community
     * @param {PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getPromosByCommunityPromosCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromosByCommunityPromosCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getPromosByCommunityPromosCommunitiesCommunityIdGet(requestParameters.communityId, requestParameters.isSystemGenerated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Promos By Event
     * @param {PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(requestParameters: PromosApiGetPromosByEventPromosEventsEventIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getPromosByEventPromosEventsEventIdCommunitiesCommunityIdGet(requestParameters.eventId, requestParameters.communityId, requestParameters.isSystemGenerated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Promos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getPromosPromosGet(options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getPromosPromosGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user promo by ID
     * @summary Get User Promo
     * @param {PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(requestParameters: PromosApiGetUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getUserPromoPromosCommunitiesCommunityIdUserPromosUserPromoIdGet(requestParameters.communityId, requestParameters.userPromoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all user promos for a specific promo
     * @summary Get User Promos By Promo
     * @param {PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(requestParameters: PromosApiGetUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getUserPromosByPromoPromosCommunitiesCommunityIdPromoUsersPromoIdGet(requestParameters.communityId, requestParameters.promoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all user promos for a specific user
     * @summary Get User Promos By User
     * @param {PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(requestParameters: PromosApiGetUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).getUserPromosByUserPromosCommunitiesCommunityIdUsersUserIdPromosGet(requestParameters.communityId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all editors for a group promo.  Authorization: User must be OWNER/EDITOR of the community,  OR be in GroupPromoEditor, OR have UserPromo relationship to a promo in the group.
     * @summary List Group Promo Editors
     * @param {PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(requestParameters: PromosApiListGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).listGroupPromoEditorsPromosGroupPromosGroupPromoIdEditorsGet(requestParameters.groupPromoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all group promos for a community (requires OWNER or EDITOR role)
     * @summary List Group Promos By Community
     * @param {PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(requestParameters: PromosApiListGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).listGroupPromosByCommunityPromosCommunitiesCommunityIdGroupPromosGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List group promos the requesting user is an editor of for a specific community.  Returns only group promos where the user has been added as a GroupPromoEditor. This is useful for users who need to find their group promos without knowing the slug.
     * @summary List My Group Promos
     * @param {PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(requestParameters: PromosApiListMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).listMyGroupPromosPromosCommunitiesCommunityIdMyGroupPromosGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a group promo (requires OWNER or EDITOR role)
     * @summary Update Group Promo
     * @param {PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(requestParameters: PromosApiUpdateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatchRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).updateGroupPromoPromosCommunitiesCommunityIdGroupPromosGroupPromoIdPatch(requestParameters.communityId, requestParameters.groupPromoId, requestParameters.updateGroupPromoInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Promo
     * @param {PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public updatePromoPromosPromoIdCommunitiesCommunityIdPut(requestParameters: PromosApiUpdatePromoPromosPromoIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).updatePromoPromosPromoIdCommunitiesCommunityIdPut(requestParameters.promoId, requestParameters.communityId, requestParameters.updatePromoInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a discount code against multiple ticket types.  Args:     request: The HTTP request     ticket_type_ids: List of ticket type IDs to validate against     discount_code: The discount code to validate     current_user: The authenticated user     db: Database session      Returns:     Promo object if found and valid
     * @summary Validate Discount Code For Multiple Ticket Types
     * @param {PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(requestParameters: PromosApiValidateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePostRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).validateDiscountCodeForMultipleTicketTypesPromosValidateDiscountCodePost(requestParameters.discountCode, requestParameters.validateMultiDiscountCodeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Discount Code For Ticket Type
     * @param {PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromosApi
     */
    public validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(requestParameters: PromosApiValidateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGetRequest, options?: RawAxiosRequestConfig) {
        return PromosApiFp(this.configuration).validateDiscountCodeForTicketTypePromosTicketsTypeTicketTypeIdValidateDiscountCodeGet(requestParameters.ticketTypeId, requestParameters.discountCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoomsApi - axios parameter creator
 * @export
 */
export const RoomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept Next Raised Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/accept-raised-hand/next/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept User Raised Hand
         * @param {string} roomId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost: async (roomId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost', 'roomId', roomId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost', 'userId', userId)
            const localVarPath = `/rooms/{room_id}/accept-raised-hand/user/{user_id}/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Get Room By Event Ids
         * @param {Array<string>} eventIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetRoomByEventIdsRoomsBulkGet: async (eventIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventIds' is not null or undefined
            assertParamExists('bulkGetRoomByEventIdsRoomsBulkGet', 'eventIds', eventIds)
            const localVarPath = `/rooms/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (eventIds) {
                localVarQueryParameter['event_ids'] = eventIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Close Active Rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeActiveRoomsRoomsCloseActivePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rooms/close-active/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Room
         * @param {CreateRoomInput} createRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomRoomsPost: async (createRoomInput: CreateRoomInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomInput' is not null or undefined
            assertParamExists('createRoomRoomsPost', 'createRoomInput', createRoomInput)
            const localVarPath = `/rooms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Video Room
         * @param {CreateVideoRoomInput} createVideoRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRoomRoomsVideoRoomPost: async (createVideoRoomInput: CreateVideoRoomInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVideoRoomInput' is not null or undefined
            assertParamExists('createVideoRoomRoomsVideoRoomPost', 'createVideoRoomInput', createVideoRoomInput)
            const localVarPath = `/rooms/video-room/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVideoRoomInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Attendee Count
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeCountRoomsRoomIdAttendeesCountGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getAttendeeCountRoomsRoomIdAttendeesCountGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/attendees/count/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Next Public Room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPublicRoomRoomsNextGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rooms/next/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Public Rooms Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {Array<PublicExperienceInput>} experienceTypes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRoomsTemporalRoomsPublicTemporalGet: async (temporalRelation: TemporalRelation, experienceTypes: Array<PublicExperienceInput>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'temporalRelation' is not null or undefined
            assertParamExists('getPublicRoomsTemporalRoomsPublicTemporalGet', 'temporalRelation', temporalRelation)
            // verify required parameter 'experienceTypes' is not null or undefined
            assertParamExists('getPublicRoomsTemporalRoomsPublicTemporalGet', 'experienceTypes', experienceTypes)
            const localVarPath = `/rooms/public/temporal/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (temporalRelation !== undefined) {
                localVarQueryParameter['temporal_relation'] = temporalRelation;
            }

            if (experienceTypes) {
                localVarQueryParameter['experience_types'] = experienceTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Raised Hand List
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaisedHandListRoomsRoomIdRaisedHandsGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRaisedHandListRoomsRoomIdRaisedHandsGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/raised-hands/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Room By Experience Type
         * @param {ExperienceType} experienceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet: async (experienceType: ExperienceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experienceType' is not null or undefined
            assertParamExists('getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet', 'experienceType', experienceType)
            const localVarPath = `/rooms/experience-type/{experience_type}/`
                .replace(`{${"experience_type"}}`, encodeURIComponent(String(experienceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Room
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomRoomsRoomIdGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomRoomsRoomIdGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Room Stats
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomStatsRoomsRoomIdStatsGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomStatsRoomsRoomIdStatsGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/stats/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users On Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOnStageRoomsRoomIdAttendeesOnStageGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getUsersOnStageRoomsRoomIdAttendeesOnStageGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/attendees-on-stage/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinStageRoomsRoomIdJoinStagePost: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('joinStageRoomsRoomIdJoinStagePost', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/join-stage/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join Video Room
         * @param {JoinRoomInput} joinRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVideoRoomRoomsJoinPost: async (joinRoomInput: JoinRoomInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'joinRoomInput' is not null or undefined
            assertParamExists('joinVideoRoomRoomsJoinPost', 'joinRoomInput', joinRoomInput)
            const localVarPath = `/rooms/join/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(joinRoomInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave Room
         * @param {LeaveRoomInput} leaveRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRoomRoomsLeavePost: async (leaveRoomInput: LeaveRoomInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leaveRoomInput' is not null or undefined
            assertParamExists('leaveRoomRoomsLeavePost', 'leaveRoomInput', leaveRoomInput)
            const localVarPath = `/rooms/leave/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leaveRoomInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveStageRoomsRoomIdLeaveStagePost: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('leaveStageRoomsRoomIdLeaveStagePost', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/leave-stage/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Room Attendees
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoomAttendeesRoomsRoomIdAttendeesGet: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('listRoomAttendeesRoomsRoomIdAttendeesGet', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/attendees/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Rooms By Event Id
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoomsByEventIdRoomsEventsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('listRoomsByEventIdRoomsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/rooms/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lower Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lowerHandRoomsRoomIdLowerHandPost: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('lowerHandRoomsRoomIdLowerHandPost', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/lower-hand/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Raise Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseHandRoomsRoomIdRaiseHandPost: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('raiseHandRoomsRoomIdRaiseHandPost', 'roomId', roomId)
            const localVarPath = `/rooms/{room_id}/raise-hand/`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomsApi - functional programming interface
 * @export
 */
export const RoomsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept Next Raised Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Accept User Raised Hand
         * @param {string} roomId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(roomId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(roomId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Get Room By Event Ids
         * @param {Array<string>} eventIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetRoomByEventIdsRoomsBulkGet(eventIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Room>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetRoomByEventIdsRoomsBulkGet(eventIds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.bulkGetRoomByEventIdsRoomsBulkGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Close Active Rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeActiveRoomsRoomsCloseActivePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeActiveRoomsRoomsCloseActivePost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.closeActiveRoomsRoomsCloseActivePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Room
         * @param {CreateRoomInput} createRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomRoomsPost(createRoomInput: CreateRoomInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRoomOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomRoomsPost(createRoomInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.createRoomRoomsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Video Room
         * @param {CreateVideoRoomInput} createVideoRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVideoRoomRoomsVideoRoomPost(createVideoRoomInput: CreateVideoRoomInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRoomOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVideoRoomRoomsVideoRoomPost(createVideoRoomInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.createVideoRoomRoomsVideoRoomPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Attendee Count
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeeCountRoomsRoomIdAttendeesCountGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttendeeCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeeCountRoomsRoomIdAttendeesCountGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getAttendeeCountRoomsRoomIdAttendeesCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Next Public Room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextPublicRoomRoomsNextGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextPublicRoomRoomsNextGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getNextPublicRoomRoomsNextGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Public Rooms Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {Array<PublicExperienceInput>} experienceTypes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicRoomsTemporalRoomsPublicTemporalGet(temporalRelation: TemporalRelation, experienceTypes: Array<PublicExperienceInput>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Room>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicRoomsTemporalRoomsPublicTemporalGet(temporalRelation, experienceTypes, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getPublicRoomsTemporalRoomsPublicTemporalGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Raised Hand List
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRaisedHandListRoomsRoomIdRaisedHandsGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RaisedHand>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRaisedHandListRoomsRoomIdRaisedHandsGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getRaisedHandListRoomsRoomIdRaisedHandsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Room By Experience Type
         * @param {ExperienceType} experienceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(experienceType: ExperienceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Room>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(experienceType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Room
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomRoomsRoomIdGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomRoomsRoomIdGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getRoomRoomsRoomIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Room Stats
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomStatsRoomsRoomIdStatsGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomStatsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomStatsRoomsRoomIdStatsGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getRoomStatsRoomsRoomIdStatsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users On Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersOnStageRoomsRoomIdAttendeesOnStageGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserOnStage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersOnStageRoomsRoomIdAttendeesOnStageGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.getUsersOnStageRoomsRoomIdAttendeesOnStageGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Join Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinStageRoomsRoomIdJoinStagePost(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinStageRoomsRoomIdJoinStagePost(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.joinStageRoomsRoomIdJoinStagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Join Video Room
         * @param {JoinRoomInput} joinRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinVideoRoomRoomsJoinPost(joinRoomInput: JoinRoomInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinRoomOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinVideoRoomRoomsJoinPost(joinRoomInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.joinVideoRoomRoomsJoinPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Leave Room
         * @param {LeaveRoomInput} leaveRoomInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveRoomRoomsLeavePost(leaveRoomInput: LeaveRoomInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveRoomRoomsLeavePost(leaveRoomInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.leaveRoomRoomsLeavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Leave Stage
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveStageRoomsRoomIdLeaveStagePost(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveStageRoomsRoomIdLeaveStagePost(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.leaveStageRoomsRoomIdLeaveStagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Room Attendees
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoomAttendeesRoomsRoomIdAttendeesGet(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomAttendee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoomAttendeesRoomsRoomIdAttendeesGet(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.listRoomAttendeesRoomsRoomIdAttendeesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Rooms By Event Id
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoomsByEventIdRoomsEventsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Room>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoomsByEventIdRoomsEventsEventIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.listRoomsByEventIdRoomsEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Lower Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lowerHandRoomsRoomIdLowerHandPost(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lowerHandRoomsRoomIdLowerHandPost(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.lowerHandRoomsRoomIdLowerHandPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Raise Hand
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async raiseHandRoomsRoomIdRaiseHandPost(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.raiseHandRoomsRoomIdRaiseHandPost(roomId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoomsApi.raiseHandRoomsRoomIdRaiseHandPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RoomsApi - factory interface
 * @export
 */
export const RoomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept Next Raised Hand
         * @param {RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(requestParameters: RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept User Raised Hand
         * @param {RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(requestParameters: RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(requestParameters.roomId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Get Room By Event Ids
         * @param {RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetRoomByEventIdsRoomsBulkGet(requestParameters: RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Room>> {
            return localVarFp.bulkGetRoomByEventIdsRoomsBulkGet(requestParameters.eventIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Close Active Rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeActiveRoomsRoomsCloseActivePost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.closeActiveRoomsRoomsCloseActivePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Room
         * @param {RoomsApiCreateRoomRoomsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomRoomsPost(requestParameters: RoomsApiCreateRoomRoomsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateRoomOutput> {
            return localVarFp.createRoomRoomsPost(requestParameters.createRoomInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Video Room
         * @param {RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRoomRoomsVideoRoomPost(requestParameters: RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateRoomOutput> {
            return localVarFp.createVideoRoomRoomsVideoRoomPost(requestParameters.createVideoRoomInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Attendee Count
         * @param {RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeCountRoomsRoomIdAttendeesCountGet(requestParameters: RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttendeeCountOutput> {
            return localVarFp.getAttendeeCountRoomsRoomIdAttendeesCountGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Next Public Room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPublicRoomRoomsNextGet(options?: RawAxiosRequestConfig): AxiosPromise<Room> {
            return localVarFp.getNextPublicRoomRoomsNextGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Public Rooms Temporal
         * @param {RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRoomsTemporalRoomsPublicTemporalGet(requestParameters: RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Room>> {
            return localVarFp.getPublicRoomsTemporalRoomsPublicTemporalGet(requestParameters.temporalRelation, requestParameters.experienceTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Raised Hand List
         * @param {RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaisedHandListRoomsRoomIdRaisedHandsGet(requestParameters: RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RaisedHand>> {
            return localVarFp.getRaisedHandListRoomsRoomIdRaisedHandsGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Room By Experience Type
         * @param {RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(requestParameters: RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Room>> {
            return localVarFp.getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(requestParameters.experienceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Room
         * @param {RoomsApiGetRoomRoomsRoomIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomRoomsRoomIdGet(requestParameters: RoomsApiGetRoomRoomsRoomIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Room> {
            return localVarFp.getRoomRoomsRoomIdGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Room Stats
         * @param {RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomStatsRoomsRoomIdStatsGet(requestParameters: RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoomStatsOutput> {
            return localVarFp.getRoomStatsRoomsRoomIdStatsGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users On Stage
         * @param {RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOnStageRoomsRoomIdAttendeesOnStageGet(requestParameters: RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserOnStage>> {
            return localVarFp.getUsersOnStageRoomsRoomIdAttendeesOnStageGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join Stage
         * @param {RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinStageRoomsRoomIdJoinStagePost(requestParameters: RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.joinStageRoomsRoomIdJoinStagePost(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join Video Room
         * @param {RoomsApiJoinVideoRoomRoomsJoinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVideoRoomRoomsJoinPost(requestParameters: RoomsApiJoinVideoRoomRoomsJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JoinRoomOutput> {
            return localVarFp.joinVideoRoomRoomsJoinPost(requestParameters.joinRoomInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave Room
         * @param {RoomsApiLeaveRoomRoomsLeavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRoomRoomsLeavePost(requestParameters: RoomsApiLeaveRoomRoomsLeavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.leaveRoomRoomsLeavePost(requestParameters.leaveRoomInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave Stage
         * @param {RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveStageRoomsRoomIdLeaveStagePost(requestParameters: RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.leaveStageRoomsRoomIdLeaveStagePost(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Room Attendees
         * @param {RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoomAttendeesRoomsRoomIdAttendeesGet(requestParameters: RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoomAttendee>> {
            return localVarFp.listRoomAttendeesRoomsRoomIdAttendeesGet(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Rooms By Event Id
         * @param {RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoomsByEventIdRoomsEventsEventIdGet(requestParameters: RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Room>> {
            return localVarFp.listRoomsByEventIdRoomsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lower Hand
         * @param {RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lowerHandRoomsRoomIdLowerHandPost(requestParameters: RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.lowerHandRoomsRoomIdLowerHandPost(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Raise Hand
         * @param {RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseHandRoomsRoomIdRaiseHandPost(requestParameters: RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.raiseHandRoomsRoomIdRaiseHandPost(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost operation in RoomsApi.
 * @export
 * @interface RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest
 */
export interface RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost
     */
    readonly roomId: string
}

/**
 * Request parameters for acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost operation in RoomsApi.
 * @export
 * @interface RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest
 */
export interface RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost
     */
    readonly roomId: string

    /**
     * 
     * @type {string}
     * @memberof RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost
     */
    readonly userId: string
}

/**
 * Request parameters for bulkGetRoomByEventIdsRoomsBulkGet operation in RoomsApi.
 * @export
 * @interface RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest
 */
export interface RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RoomsApiBulkGetRoomByEventIdsRoomsBulkGet
     */
    readonly eventIds: Array<string>
}

/**
 * Request parameters for createRoomRoomsPost operation in RoomsApi.
 * @export
 * @interface RoomsApiCreateRoomRoomsPostRequest
 */
export interface RoomsApiCreateRoomRoomsPostRequest {
    /**
     * 
     * @type {CreateRoomInput}
     * @memberof RoomsApiCreateRoomRoomsPost
     */
    readonly createRoomInput: CreateRoomInput
}

/**
 * Request parameters for createVideoRoomRoomsVideoRoomPost operation in RoomsApi.
 * @export
 * @interface RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest
 */
export interface RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest {
    /**
     * 
     * @type {CreateVideoRoomInput}
     * @memberof RoomsApiCreateVideoRoomRoomsVideoRoomPost
     */
    readonly createVideoRoomInput: CreateVideoRoomInput
}

/**
 * Request parameters for getAttendeeCountRoomsRoomIdAttendeesCountGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest
 */
export interface RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGet
     */
    readonly roomId: string
}

/**
 * Request parameters for getPublicRoomsTemporalRoomsPublicTemporalGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest
 */
export interface RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest {
    /**
     * 
     * @type {TemporalRelation}
     * @memberof RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGet
     */
    readonly temporalRelation: TemporalRelation

    /**
     * 
     * @type {Array<PublicExperienceInput>}
     * @memberof RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGet
     */
    readonly experienceTypes: Array<PublicExperienceInput>
}

/**
 * Request parameters for getRaisedHandListRoomsRoomIdRaisedHandsGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest
 */
export interface RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGet
     */
    readonly roomId: string
}

/**
 * Request parameters for getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest
 */
export interface RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest {
    /**
     * 
     * @type {ExperienceType}
     * @memberof RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet
     */
    readonly experienceType: ExperienceType
}

/**
 * Request parameters for getRoomRoomsRoomIdGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetRoomRoomsRoomIdGetRequest
 */
export interface RoomsApiGetRoomRoomsRoomIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiGetRoomRoomsRoomIdGet
     */
    readonly roomId: string
}

/**
 * Request parameters for getRoomStatsRoomsRoomIdStatsGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest
 */
export interface RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiGetRoomStatsRoomsRoomIdStatsGet
     */
    readonly roomId: string
}

/**
 * Request parameters for getUsersOnStageRoomsRoomIdAttendeesOnStageGet operation in RoomsApi.
 * @export
 * @interface RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest
 */
export interface RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGet
     */
    readonly roomId: string
}

/**
 * Request parameters for joinStageRoomsRoomIdJoinStagePost operation in RoomsApi.
 * @export
 * @interface RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest
 */
export interface RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiJoinStageRoomsRoomIdJoinStagePost
     */
    readonly roomId: string
}

/**
 * Request parameters for joinVideoRoomRoomsJoinPost operation in RoomsApi.
 * @export
 * @interface RoomsApiJoinVideoRoomRoomsJoinPostRequest
 */
export interface RoomsApiJoinVideoRoomRoomsJoinPostRequest {
    /**
     * 
     * @type {JoinRoomInput}
     * @memberof RoomsApiJoinVideoRoomRoomsJoinPost
     */
    readonly joinRoomInput: JoinRoomInput
}

/**
 * Request parameters for leaveRoomRoomsLeavePost operation in RoomsApi.
 * @export
 * @interface RoomsApiLeaveRoomRoomsLeavePostRequest
 */
export interface RoomsApiLeaveRoomRoomsLeavePostRequest {
    /**
     * 
     * @type {LeaveRoomInput}
     * @memberof RoomsApiLeaveRoomRoomsLeavePost
     */
    readonly leaveRoomInput: LeaveRoomInput
}

/**
 * Request parameters for leaveStageRoomsRoomIdLeaveStagePost operation in RoomsApi.
 * @export
 * @interface RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest
 */
export interface RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiLeaveStageRoomsRoomIdLeaveStagePost
     */
    readonly roomId: string
}

/**
 * Request parameters for listRoomAttendeesRoomsRoomIdAttendeesGet operation in RoomsApi.
 * @export
 * @interface RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest
 */
export interface RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGet
     */
    readonly roomId: string
}

/**
 * Request parameters for listRoomsByEventIdRoomsEventsEventIdGet operation in RoomsApi.
 * @export
 * @interface RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest
 */
export interface RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiListRoomsByEventIdRoomsEventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for lowerHandRoomsRoomIdLowerHandPost operation in RoomsApi.
 * @export
 * @interface RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest
 */
export interface RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiLowerHandRoomsRoomIdLowerHandPost
     */
    readonly roomId: string
}

/**
 * Request parameters for raiseHandRoomsRoomIdRaiseHandPost operation in RoomsApi.
 * @export
 * @interface RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest
 */
export interface RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomsApiRaiseHandRoomsRoomIdRaiseHandPost
     */
    readonly roomId: string
}

/**
 * RoomsApi - object-oriented interface
 * @export
 * @class RoomsApi
 * @extends {BaseAPI}
 */
export class RoomsApi extends BaseAPI {
    /**
     * 
     * @summary Accept Next Raised Hand
     * @param {RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(requestParameters: RoomsApiAcceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).acceptNextRaisedHandRoomsRoomIdAcceptRaisedHandNextPost(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept User Raised Hand
     * @param {RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(requestParameters: RoomsApiAcceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).acceptUserRaisedHandRoomsRoomIdAcceptRaisedHandUserUserIdPost(requestParameters.roomId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Get Room By Event Ids
     * @param {RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public bulkGetRoomByEventIdsRoomsBulkGet(requestParameters: RoomsApiBulkGetRoomByEventIdsRoomsBulkGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).bulkGetRoomByEventIdsRoomsBulkGet(requestParameters.eventIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Close Active Rooms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public closeActiveRoomsRoomsCloseActivePost(options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).closeActiveRoomsRoomsCloseActivePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Room
     * @param {RoomsApiCreateRoomRoomsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public createRoomRoomsPost(requestParameters: RoomsApiCreateRoomRoomsPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).createRoomRoomsPost(requestParameters.createRoomInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Video Room
     * @param {RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public createVideoRoomRoomsVideoRoomPost(requestParameters: RoomsApiCreateVideoRoomRoomsVideoRoomPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).createVideoRoomRoomsVideoRoomPost(requestParameters.createVideoRoomInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Attendee Count
     * @param {RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getAttendeeCountRoomsRoomIdAttendeesCountGet(requestParameters: RoomsApiGetAttendeeCountRoomsRoomIdAttendeesCountGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getAttendeeCountRoomsRoomIdAttendeesCountGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Next Public Room
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getNextPublicRoomRoomsNextGet(options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getNextPublicRoomRoomsNextGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Public Rooms Temporal
     * @param {RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getPublicRoomsTemporalRoomsPublicTemporalGet(requestParameters: RoomsApiGetPublicRoomsTemporalRoomsPublicTemporalGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getPublicRoomsTemporalRoomsPublicTemporalGet(requestParameters.temporalRelation, requestParameters.experienceTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Raised Hand List
     * @param {RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getRaisedHandListRoomsRoomIdRaisedHandsGet(requestParameters: RoomsApiGetRaisedHandListRoomsRoomIdRaisedHandsGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRaisedHandListRoomsRoomIdRaisedHandsGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Room By Experience Type
     * @param {RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(requestParameters: RoomsApiGetRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomByExperienceTypeRoomsExperienceTypeExperienceTypeGet(requestParameters.experienceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Room
     * @param {RoomsApiGetRoomRoomsRoomIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getRoomRoomsRoomIdGet(requestParameters: RoomsApiGetRoomRoomsRoomIdGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomRoomsRoomIdGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Room Stats
     * @param {RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getRoomStatsRoomsRoomIdStatsGet(requestParameters: RoomsApiGetRoomStatsRoomsRoomIdStatsGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomStatsRoomsRoomIdStatsGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users On Stage
     * @param {RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getUsersOnStageRoomsRoomIdAttendeesOnStageGet(requestParameters: RoomsApiGetUsersOnStageRoomsRoomIdAttendeesOnStageGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getUsersOnStageRoomsRoomIdAttendeesOnStageGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join Stage
     * @param {RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public joinStageRoomsRoomIdJoinStagePost(requestParameters: RoomsApiJoinStageRoomsRoomIdJoinStagePostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).joinStageRoomsRoomIdJoinStagePost(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join Video Room
     * @param {RoomsApiJoinVideoRoomRoomsJoinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public joinVideoRoomRoomsJoinPost(requestParameters: RoomsApiJoinVideoRoomRoomsJoinPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).joinVideoRoomRoomsJoinPost(requestParameters.joinRoomInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave Room
     * @param {RoomsApiLeaveRoomRoomsLeavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public leaveRoomRoomsLeavePost(requestParameters: RoomsApiLeaveRoomRoomsLeavePostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).leaveRoomRoomsLeavePost(requestParameters.leaveRoomInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave Stage
     * @param {RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public leaveStageRoomsRoomIdLeaveStagePost(requestParameters: RoomsApiLeaveStageRoomsRoomIdLeaveStagePostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).leaveStageRoomsRoomIdLeaveStagePost(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Room Attendees
     * @param {RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public listRoomAttendeesRoomsRoomIdAttendeesGet(requestParameters: RoomsApiListRoomAttendeesRoomsRoomIdAttendeesGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).listRoomAttendeesRoomsRoomIdAttendeesGet(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Rooms By Event Id
     * @param {RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public listRoomsByEventIdRoomsEventsEventIdGet(requestParameters: RoomsApiListRoomsByEventIdRoomsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).listRoomsByEventIdRoomsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lower Hand
     * @param {RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public lowerHandRoomsRoomIdLowerHandPost(requestParameters: RoomsApiLowerHandRoomsRoomIdLowerHandPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).lowerHandRoomsRoomIdLowerHandPost(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Raise Hand
     * @param {RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public raiseHandRoomsRoomIdRaiseHandPost(requestParameters: RoomsApiRaiseHandRoomsRoomIdRaiseHandPostRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).raiseHandRoomsRoomIdRaiseHandPost(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk Get Session Attendee Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost: async (bulkSessionIdsInput: BulkSessionIdsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSessionIdsInput' is not null or undefined
            assertParamExists('bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost', 'bulkSessionIdsInput', bulkSessionIdsInput)
            const localVarPath = `/sessions/attendees/count/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSessionIdsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get session tags, categories, and attendees for multiple sessions.
         * @summary Bulk Get Session Data
         * @param {BulkSessionDataInput} bulkSessionDataInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionDataSessionsBulkDataPost: async (bulkSessionDataInput: BulkSessionDataInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSessionDataInput' is not null or undefined
            assertParamExists('bulkGetSessionDataSessionsBulkDataPost', 'bulkSessionDataInput', bulkSessionDataInput)
            const localVarPath = `/sessions/bulk-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSessionDataInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Get Session Favorite Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost: async (bulkSessionIdsInput: BulkSessionIdsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSessionIdsInput' is not null or undefined
            assertParamExists('bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost', 'bulkSessionIdsInput', bulkSessionIdsInput)
            const localVarPath = `/sessions/favorites/count/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSessionIdsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get session locations for multiple event IDs. Public endpoint.
         * @summary Bulk Get Session Locations
         * @param {BulkGetSessionLocationsInput} bulkGetSessionLocationsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionLocationsSessionsLocationsBulkPost: async (bulkGetSessionLocationsInput: BulkGetSessionLocationsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetSessionLocationsInput' is not null or undefined
            assertParamExists('bulkGetSessionLocationsSessionsLocationsBulkPost', 'bulkGetSessionLocationsInput', bulkGetSessionLocationsInput)
            const localVarPath = `/sessions/locations/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetSessionLocationsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Get Session Vote Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionVoteCountsSessionsVotesCountBulkPost: async (bulkSessionIdsInput: BulkSessionIdsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSessionIdsInput' is not null or undefined
            assertParamExists('bulkGetSessionVoteCountsSessionsVotesCountBulkPost', 'bulkSessionIdsInput', bulkSessionIdsInput)
            const localVarPath = `/sessions/votes/count/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSessionIdsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk mark sessions as not viewed by a user (removes viewing status).
         * @summary Bulk Mark Sessions Not Viewed
         * @param {string} userId 
         * @param {BulkMarkSessionsNotViewedInput} bulkMarkSessionsNotViewedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete: async (userId: string, bulkMarkSessionsNotViewedInput: BulkMarkSessionsNotViewedInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete', 'userId', userId)
            // verify required parameter 'bulkMarkSessionsNotViewedInput' is not null or undefined
            assertParamExists('bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete', 'bulkMarkSessionsNotViewedInput', bulkMarkSessionsNotViewedInput)
            const localVarPath = `/sessions/users/{user_id}/viewed/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkMarkSessionsNotViewedInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk mark sessions as viewed by a user.
         * @summary Bulk Mark Sessions Viewed
         * @param {string} userId 
         * @param {BulkMarkSessionsViewedInput} bulkMarkSessionsViewedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkSessionsViewedSessionsUsersUserIdViewedPost: async (userId: string, bulkMarkSessionsViewedInput: BulkMarkSessionsViewedInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('bulkMarkSessionsViewedSessionsUsersUserIdViewedPost', 'userId', userId)
            // verify required parameter 'bulkMarkSessionsViewedInput' is not null or undefined
            assertParamExists('bulkMarkSessionsViewedSessionsUsersUserIdViewedPost', 'bulkMarkSessionsViewedInput', bulkMarkSessionsViewedInput)
            const localVarPath = `/sessions/users/{user_id}/viewed/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkMarkSessionsViewedInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a session status from \'scheduled\' to \'confirmed\'. Only session speakers or users with ADMIN scope can confirm sessions.
         * @summary Confirm Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSessionSessionsSessionIdConfirmPatch: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('confirmSessionSessionsSessionIdConfirmPatch', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/confirm/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Category
         * @param {string} communityId 
         * @param {CreateCategoryInput} createCategoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategorySessionsCategoriesCommunitiesCommunityIdPost: async (communityId: string, createCategoryInput: CreateCategoryInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createCategorySessionsCategoriesCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createCategoryInput' is not null or undefined
            assertParamExists('createCategorySessionsCategoriesCommunitiesCommunityIdPost', 'createCategoryInput', createCategoryInput)
            const localVarPath = `/sessions/categories/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Session Categories
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {CreateSessionCategoriesInput} createSessionCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost: async (sessionId: string, communityId: string, createSessionCategoriesInput: CreateSessionCategoriesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost', 'sessionId', sessionId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost', 'communityId', communityId)
            // verify required parameter 'createSessionCategoriesInput' is not null or undefined
            assertParamExists('createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost', 'createSessionCategoriesInput', createSessionCategoriesInput)
            const localVarPath = `/sessions/{session_id}/communities/{community_id}/categories/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionCategoriesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a session location. Only community owners and editors can create.
         * @summary Create Session Location
         * @param {string} eventId 
         * @param {CreateSessionLocationInput} createSessionLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionLocationSessionsLocationsEventsEventIdPost: async (eventId: string, createSessionLocationInput: CreateSessionLocationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('createSessionLocationSessionsLocationsEventsEventIdPost', 'eventId', eventId)
            // verify required parameter 'createSessionLocationInput' is not null or undefined
            assertParamExists('createSessionLocationSessionsLocationsEventsEventIdPost', 'createSessionLocationInput', createSessionLocationInput)
            const localVarPath = `/sessions/locations/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionLocationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Session
         * @param {string} communityId 
         * @param {CreateSessionInput} createSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionSessionsCommunitiesCommunityIdPost: async (communityId: string, createSessionInput: CreateSessionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createSessionSessionsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createSessionInput' is not null or undefined
            assertParamExists('createSessionSessionsCommunitiesCommunityIdPost', 'createSessionInput', createSessionInput)
            const localVarPath = `/sessions/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link existing tags to sessions (create SessionTag associations)
         * @summary Create Session Tags
         * @param {string} communityId 
         * @param {CreateSessionTagsInput} createSessionTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost: async (communityId: string, createSessionTagsInput: CreateSessionTagsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createSessionTagsInput' is not null or undefined
            assertParamExists('createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost', 'createSessionTagsInput', createSessionTagsInput)
            const localVarPath = `/sessions/session-tags/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionTagsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new reusable tag within an event
         * @summary Create Tag
         * @param {string} communityId 
         * @param {CreateTagInput} createTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagSessionsTagsCommunitiesCommunityIdPost: async (communityId: string, createTagInput: CreateTagInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createTagSessionsTagsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createTagInput' is not null or undefined
            assertParamExists('createTagSessionsTagsCommunitiesCommunityIdPost', 'createTagInput', createTagInput)
            const localVarPath = `/sessions/tags/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Category
         * @param {string} categoryId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete: async (categoryId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete', 'categoryId', categoryId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/sessions/categories/{category_id}/communities/{community_id}/`
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Session Category
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete: async (sessionId: string, communityId: string, categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete', 'sessionId', sessionId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete', 'communityId', communityId)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete', 'categoryId', categoryId)
            const localVarPath = `/sessions/{session_id}/communities/{community_id}/categories/{category_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a session location. Only community owners and editors can delete.
         * @summary Delete Session Location
         * @param {string} sessionLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionLocationSessionsLocationsSessionLocationIdDelete: async (sessionLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionLocationId' is not null or undefined
            assertParamExists('deleteSessionLocationSessionsLocationsSessionLocationIdDelete', 'sessionLocationId', sessionLocationId)
            const localVarPath = `/sessions/locations/{session_location_id}/`
                .replace(`{${"session_location_id"}}`, encodeURIComponent(String(sessionLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Session Tag
         * @param {string} sessionId 
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionTagSessionsSessionIdTagsTagIdDelete: async (sessionId: string, tagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteSessionTagSessionsSessionIdTagsTagIdDelete', 'sessionId', sessionId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteSessionTagSessionsSessionIdTagsTagIdDelete', 'tagId', tagId)
            const localVarPath = `/sessions/{session_id}/tags/{tag_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a tag (soft delete)
         * @summary Delete Tag
         * @param {string} tagId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete: async (tagId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete', 'tagId', tagId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/sessions/tags/{tag_id}/communities/{community_id}/`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Favorite Session
         * @param {string} sessionId 
         * @param {SessionFavoriteInput} sessionFavoriteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteSessionSessionsSessionIdFavoritePost: async (sessionId: string, sessionFavoriteInput: SessionFavoriteInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('favoriteSessionSessionsSessionIdFavoritePost', 'sessionId', sessionId)
            // verify required parameter 'sessionFavoriteInput' is not null or undefined
            assertParamExists('favoriteSessionSessionsSessionIdFavoritePost', 'sessionFavoriteInput', sessionFavoriteInput)
            const localVarPath = `/sessions/{session_id}/favorite/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionFavoriteInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Categories By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesByEventSessionsEventsEventIdCategoriesGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getCategoriesByEventSessionsEventsEventIdCategoriesGet', 'eventId', eventId)
            const localVarPath = `/sessions/events/{event_id}/categories/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all categories for multiple events
         * @summary Get Categories By Events
         * @param {BulkGetCategoriesByEventsInput} bulkGetCategoriesByEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesByEventsSessionsEventsBulkCategoriesPost: async (bulkGetCategoriesByEventsInput: BulkGetCategoriesByEventsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetCategoriesByEventsInput' is not null or undefined
            assertParamExists('getCategoriesByEventsSessionsEventsBulkCategoriesPost', 'bulkGetCategoriesByEventsInput', bulkGetCategoriesByEventsInput)
            const localVarPath = `/sessions/events/bulk/categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetCategoriesByEventsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySessionsCategoriesCategoryIdGet: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getCategorySessionsCategoriesCategoryIdGet', 'categoryId', categoryId)
            const localVarPath = `/sessions/categories/{category_id}/`
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Attendee Count
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAttendeeCountSessionsSessionIdAttendeesCountGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionAttendeeCountSessionsSessionIdAttendeesCountGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/attendees/count/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Attendees
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAttendeesSessionsSessionIdAttendeesGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionAttendeesSessionsSessionIdAttendeesGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/attendees/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Categories
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCategoriesSessionsSessionIdCategoriesGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionCategoriesSessionsSessionIdCategoriesGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/categories/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Favorites
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet: async (sessionId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet', 'sessionId', sessionId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet', 'communityId', communityId)
            const localVarPath = `/sessions/{session_id}/communities/{community_id}/favorites/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a session location by ID. Public endpoint.
         * @summary Get Session Location
         * @param {string} sessionLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionLocationSessionsLocationsSessionLocationIdGet: async (sessionLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionLocationId' is not null or undefined
            assertParamExists('getSessionLocationSessionsLocationsSessionLocationIdGet', 'sessionLocationId', sessionLocationId)
            const localVarPath = `/sessions/locations/{session_location_id}/`
                .replace(`{${"session_location_id"}}`, encodeURIComponent(String(sessionLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all session locations for an event ID. Public endpoint.
         * @summary Get Session Locations By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionLocationsByEventSessionsLocationsEventsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getSessionLocationsByEventSessionsLocationsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/sessions/locations/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionSessionsSessionIdGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionSessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Tags By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTagsByEventSessionsEventsEventIdSessionTagsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getSessionTagsByEventSessionsEventsEventIdSessionTagsGet', 'eventId', eventId)
            const localVarPath = `/sessions/events/{event_id}/session-tags/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Tags
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTagsSessionsSessionIdTagsGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionTagsSessionsSessionIdTagsGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/tags/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get session vote analytics for a date range (max 31 days). Returns daily vote counts grouped by date.
         * @summary Get Session Vote Analytics
         * @param {string} communityId 
         * @param {SessionVoteAnalyticsInput} sessionVoteAnalyticsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost: async (communityId: string, sessionVoteAnalyticsInput: SessionVoteAnalyticsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'sessionVoteAnalyticsInput' is not null or undefined
            assertParamExists('getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost', 'sessionVoteAnalyticsInput', sessionVoteAnalyticsInput)
            const localVarPath = `/sessions/votes/analytics/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionVoteAnalyticsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Vote Counts
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVoteCountsSessionsSessionIdVotesCountGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionVoteCountsSessionsSessionIdVotesCountGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/votes/count/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session Votes
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVotesSessionsSessionIdVotesGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionVotesSessionsSessionIdVotesGet', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/votes/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By Categories
         * @param {GetSessionsByCategoriesInput} getSessionsByCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByCategoriesSessionsSearchByCategoriesPost: async (getSessionsByCategoriesInput: GetSessionsByCategoriesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSessionsByCategoriesInput' is not null or undefined
            assertParamExists('getSessionsByCategoriesSessionsSearchByCategoriesPost', 'getSessionsByCategoriesInput', getSessionsByCategoriesInput)
            const localVarPath = `/sessions/search/by-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSessionsByCategoriesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By Event
         * @param {string} eventId 
         * @param {boolean} [isShuffled] 
         * @param {Array<SessionStatus>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByEventSessionsEventsEventIdGet: async (eventId: string, isShuffled?: boolean, statuses?: Array<SessionStatus>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getSessionsByEventSessionsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/sessions/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (isShuffled !== undefined) {
                localVarQueryParameter['is_shuffled'] = isShuffled;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By Tags Or Categories
         * @param {GetSessionsByTagsOrCategoriesInput} getSessionsByTagsOrCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost: async (getSessionsByTagsOrCategoriesInput: GetSessionsByTagsOrCategoriesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSessionsByTagsOrCategoriesInput' is not null or undefined
            assertParamExists('getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost', 'getSessionsByTagsOrCategoriesInput', getSessionsByTagsOrCategoriesInput)
            const localVarPath = `/sessions/search/by-tags-or-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSessionsByTagsOrCategoriesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By Tags
         * @param {GetSessionsByTagsInput} getSessionsByTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByTagsSessionsSearchByTagsPost: async (getSessionsByTagsInput: GetSessionsByTagsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSessionsByTagsInput' is not null or undefined
            assertParamExists('getSessionsByTagsSessionsSearchByTagsPost', 'getSessionsByTagsInput', getSessionsByTagsInput)
            const localVarPath = `/sessions/search/by-tags/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSessionsByTagsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet: async (userId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet', 'userId', userId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/sessions/users/{user_id}/communities/{community_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sessions by view type (\'Viewed\' or \'Not Viewed\') for a user within an event.
         * @summary Get Sessions By View Type
         * @param {string} userId 
         * @param {GetSessionsByViewTypeInput} getSessionsByViewTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByViewTypeSessionsUsersUserIdSessionsPost: async (userId: string, getSessionsByViewTypeInput: GetSessionsByViewTypeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSessionsByViewTypeSessionsUsersUserIdSessionsPost', 'userId', userId)
            // verify required parameter 'getSessionsByViewTypeInput' is not null or undefined
            assertParamExists('getSessionsByViewTypeSessionsUsersUserIdSessionsPost', 'getSessionsByViewTypeInput', getSessionsByViewTypeInput)
            const localVarPath = `/sessions/users/{user_id}/sessions/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSessionsByViewTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all sessions viewed by a user within a specific event.
         * @summary Get Sessions Viewed By User In Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet: async (userId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet', 'userId', userId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet', 'eventId', eventId)
            const localVarPath = `/sessions/users/{user_id}/events/{event_id}/sessions/viewed/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific tag by ID
         * @summary Get Tag
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagSessionsTagsTagIdGet: async (tagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getTagSessionsTagsTagIdGet', 'tagId', tagId)
            const localVarPath = `/sessions/tags/{tag_id}/`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tags for a specific event
         * @summary Get Tags By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByEventSessionsEventsEventIdTagsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTagsByEventSessionsEventsEventIdTagsGet', 'eventId', eventId)
            const localVarPath = `/sessions/events/{event_id}/tags/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tags for multiple events
         * @summary Get Tags By Events
         * @param {BulkGetTagsByEventsInput} bulkGetTagsByEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByEventsSessionsEventsBulkTagsPost: async (bulkGetTagsByEventsInput: BulkGetTagsByEventsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetTagsByEventsInput' is not null or undefined
            assertParamExists('getTagsByEventsSessionsEventsBulkTagsPost', 'bulkGetTagsByEventsInput', bulkGetTagsByEventsInput)
            const localVarPath = `/sessions/events/bulk/tags/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetTagsByEventsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Favorited Sessions
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet: async (communityId: string, eventId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet', 'communityId', communityId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet', 'eventId', eventId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet', 'userId', userId)
            const localVarPath = `/sessions/communities/{community_id}/events/{event_id}/users/{user_id}/favorites/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sessions a user has favorited filtered by temporal relation.
         * @summary Get User Favorited Sessions Temporal
         * @param {string} userId 
         * @param {TemporalRelation} [temporalRelation] Filter favorites by temporal relation: FUTURE or PAST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet: async (userId: string, temporalRelation?: TemporalRelation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet', 'userId', userId)
            const localVarPath = `/sessions/users/{user_id}/favorites/temporal/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (temporalRelation !== undefined) {
                localVarQueryParameter['temporal_relation'] = temporalRelation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all session views for a specific user.
         * @summary Get User Session Views
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionViewsSessionsUsersUserIdViewedGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserSessionViewsSessionsUsersUserIdViewedGet', 'userId', userId)
            const localVarPath = `/sessions/users/{user_id}/viewed/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all sessions that a specific user has voted on within a specific event.
         * @summary Get User Session Votes
         * @param {string} eventId 
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet: async (eventId: string, userId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet', 'eventId', eventId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet', 'userId', userId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/sessions/votes/events/{event_id}/users/{user_id}/communities/{community_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join Session
         * @param {string} sessionId 
         * @param {JoinSessionInput} joinSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinSessionSessionsSessionIdJoinPost: async (sessionId: string, joinSessionInput: JoinSessionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('joinSessionSessionsSessionIdJoinPost', 'sessionId', sessionId)
            // verify required parameter 'joinSessionInput' is not null or undefined
            assertParamExists('joinSessionSessionsSessionIdJoinPost', 'joinSessionInput', joinSessionInput)
            const localVarPath = `/sessions/{session_id}/join/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(joinSessionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave Session
         * @param {string} sessionId 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveSessionSessionsSessionIdLeavePost: async (sessionId: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('leaveSessionSessionsSessionIdLeavePost', 'sessionId', sessionId)
            const localVarPath = `/sessions/{session_id}/leave/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sessions based on their temporal relation (FUTURE or PAST) from multiple communities.  Request Body: - temporal_relation: Filter sessions by FUTURE or PAST - community_ids: List of community IDs to get sessions from - start_date_from: Optional filter for sessions starting from this date ( inclusive) - start_date_to: Optional filter for sessions starting up to this date ( inclusive)
         * @summary Public Bulk Get Sessions Temporal
         * @param {BulkGetSessionsTemporalInput} bulkGetSessionsTemporalInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBulkGetSessionsTemporalSessionsTemporalPublicPost: async (bulkGetSessionsTemporalInput: BulkGetSessionsTemporalInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetSessionsTemporalInput' is not null or undefined
            assertParamExists('publicBulkGetSessionsTemporalSessionsTemporalPublicPost', 'bulkGetSessionsTemporalInput', bulkGetSessionsTemporalInput)
            const localVarPath = `/sessions/temporal/public/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetSessionsTemporalInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Session Favorite
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete: async (sessionId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete', 'sessionId', sessionId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete', 'userId', userId)
            const localVarPath = `/sessions/{session_id}/favorite/{user_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Session Vote
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSessionVoteSessionsSessionIdVoteUserIdDelete: async (sessionId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('removeSessionVoteSessionsSessionIdVoteUserIdDelete', 'sessionId', sessionId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeSessionVoteSessionsSessionIdVoteUserIdDelete', 'userId', userId)
            const localVarPath = `/sessions/{session_id}/vote/{user_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Attendee Role
         * @param {string} communityId 
         * @param {UpdateSessionAttendeeRoleInput} updateSessionAttendeeRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut: async (communityId: string, updateSessionAttendeeRoleInput: UpdateSessionAttendeeRoleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateSessionAttendeeRoleInput' is not null or undefined
            assertParamExists('updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut', 'updateSessionAttendeeRoleInput', updateSessionAttendeeRoleInput)
            const localVarPath = `/sessions/attendees/role/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionAttendeeRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Category
         * @param {string} categoryId 
         * @param {string} communityId 
         * @param {UpdateCategoryInput} updateCategoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut: async (categoryId: string, communityId: string, updateCategoryInput: UpdateCategoryInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut', 'categoryId', categoryId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateCategoryInput' is not null or undefined
            assertParamExists('updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut', 'updateCategoryInput', updateCategoryInput)
            const localVarPath = `/sessions/categories/{category_id}/communities/{community_id}/`
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update session categories by syncing to match the provided category list (removes any not in list, adds new ones)
         * @summary Update Session Categories
         * @param {string} sessionId 
         * @param {UpdateSessionCategoriesInput} updateSessionCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionCategoriesSessionsSessionIdCategoriesPut: async (sessionId: string, updateSessionCategoriesInput: UpdateSessionCategoriesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateSessionCategoriesSessionsSessionIdCategoriesPut', 'sessionId', sessionId)
            // verify required parameter 'updateSessionCategoriesInput' is not null or undefined
            assertParamExists('updateSessionCategoriesSessionsSessionIdCategoriesPut', 'updateSessionCategoriesInput', updateSessionCategoriesInput)
            const localVarPath = `/sessions/{session_id}/categories/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionCategoriesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a session location. Only community owners and editors can update.
         * @summary Update Session Location
         * @param {string} sessionLocationId 
         * @param {UpdateSessionLocationInput} updateSessionLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionLocationSessionsLocationsSessionLocationIdPut: async (sessionLocationId: string, updateSessionLocationInput: UpdateSessionLocationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionLocationId' is not null or undefined
            assertParamExists('updateSessionLocationSessionsLocationsSessionLocationIdPut', 'sessionLocationId', sessionLocationId)
            // verify required parameter 'updateSessionLocationInput' is not null or undefined
            assertParamExists('updateSessionLocationSessionsLocationsSessionLocationIdPut', 'updateSessionLocationInput', updateSessionLocationInput)
            const localVarPath = `/sessions/locations/{session_location_id}/`
                .replace(`{${"session_location_id"}}`, encodeURIComponent(String(sessionLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionLocationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Session
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {UpdateSessionInput} updateSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionSessionsSessionIdCommunitiesCommunityIdPut: async (sessionId: string, communityId: string, updateSessionInput: UpdateSessionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateSessionSessionsSessionIdCommunitiesCommunityIdPut', 'sessionId', sessionId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateSessionSessionsSessionIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateSessionInput' is not null or undefined
            assertParamExists('updateSessionSessionsSessionIdCommunitiesCommunityIdPut', 'updateSessionInput', updateSessionInput)
            const localVarPath = `/sessions/{session_id}/communities/{community_id}/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update session tags by syncing to match the provided tag list (removes any not in list, adds new ones)
         * @summary Update Session Tags
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {UpdateSessionTagsInput} updateSessionTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut: async (sessionId: string, communityId: string, updateSessionTagsInput: UpdateSessionTagsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut', 'sessionId', sessionId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut', 'communityId', communityId)
            // verify required parameter 'updateSessionTagsInput' is not null or undefined
            assertParamExists('updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut', 'updateSessionTagsInput', updateSessionTagsInput)
            const localVarPath = `/sessions/{session_id}/communities/{community_id}/tags/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionTagsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a tag
         * @summary Update Tag
         * @param {string} tagId 
         * @param {string} communityId 
         * @param {UpdateTagInput} updateTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagSessionsTagsTagIdCommunitiesCommunityIdPut: async (tagId: string, communityId: string, updateTagInput: UpdateTagInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('updateTagSessionsTagsTagIdCommunitiesCommunityIdPut', 'tagId', tagId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateTagSessionsTagsTagIdCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateTagInput' is not null or undefined
            assertParamExists('updateTagSessionsTagsTagIdCommunitiesCommunityIdPut', 'updateTagInput', updateTagInput)
            const localVarPath = `/sessions/tags/{tag_id}/communities/{community_id}/`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vote On Session
         * @param {string} sessionId 
         * @param {SessionVoteInput} sessionVoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteOnSessionSessionsSessionIdVotePost: async (sessionId: string, sessionVoteInput: SessionVoteInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('voteOnSessionSessionsSessionIdVotePost', 'sessionId', sessionId)
            // verify required parameter 'sessionVoteInput' is not null or undefined
            assertParamExists('voteOnSessionSessionsSessionIdVotePost', 'sessionVoteInput', sessionVoteInput)
            const localVarPath = `/sessions/{session_id}/vote/`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionVoteInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk Get Session Attendee Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(bulkSessionIdsInput: BulkSessionIdsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSessionAttendeeCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(bulkSessionIdsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get session tags, categories, and attendees for multiple sessions.
         * @summary Bulk Get Session Data
         * @param {BulkSessionDataInput} bulkSessionDataInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSessionDataSessionsBulkDataPost(bulkSessionDataInput: BulkSessionDataInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSessionDataOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSessionDataSessionsBulkDataPost(bulkSessionDataInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkGetSessionDataSessionsBulkDataPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Get Session Favorite Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(bulkSessionIdsInput: BulkSessionIdsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSessionFavoriteCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(bulkSessionIdsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get session locations for multiple event IDs. Public endpoint.
         * @summary Bulk Get Session Locations
         * @param {BulkGetSessionLocationsInput} bulkGetSessionLocationsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSessionLocationsSessionsLocationsBulkPost(bulkGetSessionLocationsInput: BulkGetSessionLocationsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkGetSessionLocationsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSessionLocationsSessionsLocationsBulkPost(bulkGetSessionLocationsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkGetSessionLocationsSessionsLocationsBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Get Session Vote Counts
         * @param {BulkSessionIdsInput} bulkSessionIdsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSessionVoteCountsSessionsVotesCountBulkPost(bulkSessionIdsInput: BulkSessionIdsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSessionVoteCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSessionVoteCountsSessionsVotesCountBulkPost(bulkSessionIdsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkGetSessionVoteCountsSessionsVotesCountBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Bulk mark sessions as not viewed by a user (removes viewing status).
         * @summary Bulk Mark Sessions Not Viewed
         * @param {string} userId 
         * @param {BulkMarkSessionsNotViewedInput} bulkMarkSessionsNotViewedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(userId: string, bulkMarkSessionsNotViewedInput: BulkMarkSessionsNotViewedInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionViewedListOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(userId, bulkMarkSessionsNotViewedInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Bulk mark sessions as viewed by a user.
         * @summary Bulk Mark Sessions Viewed
         * @param {string} userId 
         * @param {BulkMarkSessionsViewedInput} bulkMarkSessionsViewedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(userId: string, bulkMarkSessionsViewedInput: BulkMarkSessionsViewedInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionViewedListOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(userId, bulkMarkSessionsViewedInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.bulkMarkSessionsViewedSessionsUsersUserIdViewedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Confirm a session status from \'scheduled\' to \'confirmed\'. Only session speakers or users with ADMIN scope can confirm sessions.
         * @summary Confirm Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmSessionSessionsSessionIdConfirmPatch(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmSessionSessionsSessionIdConfirmPatch(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.confirmSessionSessionsSessionIdConfirmPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Category
         * @param {string} communityId 
         * @param {CreateCategoryInput} createCategoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategorySessionsCategoriesCommunitiesCommunityIdPost(communityId: string, createCategoryInput: CreateCategoryInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategorySessionsCategoriesCommunitiesCommunityIdPost(communityId, createCategoryInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createCategorySessionsCategoriesCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Session Categories
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {CreateSessionCategoriesInput} createSessionCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(sessionId: string, communityId: string, createSessionCategoriesInput: CreateSessionCategoriesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCategoriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(sessionId, communityId, createSessionCategoriesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a session location. Only community owners and editors can create.
         * @summary Create Session Location
         * @param {string} eventId 
         * @param {CreateSessionLocationInput} createSessionLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSessionLocationSessionsLocationsEventsEventIdPost(eventId: string, createSessionLocationInput: CreateSessionLocationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSessionLocationSessionsLocationsEventsEventIdPost(eventId, createSessionLocationInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createSessionLocationSessionsLocationsEventsEventIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Session
         * @param {string} communityId 
         * @param {CreateSessionInput} createSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSessionSessionsCommunitiesCommunityIdPost(communityId: string, createSessionInput: CreateSessionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSessionSessionsCommunitiesCommunityIdPost(communityId, createSessionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createSessionSessionsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Link existing tags to sessions (create SessionTag associations)
         * @summary Create Session Tags
         * @param {string} communityId 
         * @param {CreateSessionTagsInput} createSessionTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(communityId: string, createSessionTagsInput: CreateSessionTagsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionTag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(communityId, createSessionTagsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new reusable tag within an event
         * @summary Create Tag
         * @param {string} communityId 
         * @param {CreateTagInput} createTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTagSessionsTagsCommunitiesCommunityIdPost(communityId: string, createTagInput: CreateTagInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTagSessionsTagsCommunitiesCommunityIdPost(communityId, createTagInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.createTagSessionsTagsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Category
         * @param {string} categoryId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(categoryId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(categoryId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Session Category
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(sessionId: string, communityId: string, categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(sessionId, communityId, categoryId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a session location. Only community owners and editors can delete.
         * @summary Delete Session Location
         * @param {string} sessionLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionLocationSessionsLocationsSessionLocationIdDelete(sessionLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSessionLocationOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionLocationSessionsLocationsSessionLocationIdDelete(sessionLocationId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.deleteSessionLocationSessionsLocationsSessionLocationIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Session Tag
         * @param {string} sessionId 
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionTagSessionsSessionIdTagsTagIdDelete(sessionId: string, tagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionTagSessionsSessionIdTagsTagIdDelete(sessionId, tagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.deleteSessionTagSessionsSessionIdTagsTagIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a tag (soft delete)
         * @summary Delete Tag
         * @param {string} tagId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(tagId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(tagId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Favorite Session
         * @param {string} sessionId 
         * @param {SessionFavoriteInput} sessionFavoriteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteSessionSessionsSessionIdFavoritePost(sessionId: string, sessionFavoriteInput: SessionFavoriteInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionFavoriteOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteSessionSessionsSessionIdFavoritePost(sessionId, sessionFavoriteInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.favoriteSessionSessionsSessionIdFavoritePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Categories By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesByEventSessionsEventsEventIdCategoriesGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesByEventSessionsEventsEventIdCategoriesGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getCategoriesByEventSessionsEventsEventIdCategoriesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all categories for multiple events
         * @summary Get Categories By Events
         * @param {BulkGetCategoriesByEventsInput} bulkGetCategoriesByEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesByEventsSessionsEventsBulkCategoriesPost(bulkGetCategoriesByEventsInput: BulkGetCategoriesByEventsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesByEventsSessionsEventsBulkCategoriesPost(bulkGetCategoriesByEventsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getCategoriesByEventsSessionsEventsBulkCategoriesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategorySessionsCategoriesCategoryIdGet(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategorySessionsCategoriesCategoryIdGet(categoryId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getCategorySessionsCategoriesCategoryIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Attendee Count
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAttendeeCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionAttendeeCountSessionsSessionIdAttendeesCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Attendees
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionAttendeesSessionsSessionIdAttendeesGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAttendeesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionAttendeesSessionsSessionIdAttendeesGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionAttendeesSessionsSessionIdAttendeesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Categories
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionCategoriesSessionsSessionIdCategoriesGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCategoriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionCategoriesSessionsSessionIdCategoriesGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionCategoriesSessionsSessionIdCategoriesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Favorites
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(sessionId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionFavoritesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(sessionId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a session location by ID. Public endpoint.
         * @summary Get Session Location
         * @param {string} sessionLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionLocationSessionsLocationsSessionLocationIdGet(sessionLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionLocationSessionsLocationsSessionLocationIdGet(sessionLocationId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionLocationSessionsLocationsSessionLocationIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all session locations for an event ID. Public endpoint.
         * @summary Get Session Locations By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionLocationsByEventSessionsLocationsEventsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionLocationsByEventSessionsLocationsEventsEventIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionLocationsByEventSessionsLocationsEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionSessionsSessionIdGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionSessionsSessionIdGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionSessionsSessionIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Tags By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionTagsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionTagsByEventSessionsEventsEventIdSessionTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Tags
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionTagsSessionsSessionIdTagsGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionTagsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionTagsSessionsSessionIdTagsGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionTagsSessionsSessionIdTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get session vote analytics for a date range (max 31 days). Returns daily vote counts grouped by date.
         * @summary Get Session Vote Analytics
         * @param {string} communityId 
         * @param {SessionVoteAnalyticsInput} sessionVoteAnalyticsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(communityId: string, sessionVoteAnalyticsInput: SessionVoteAnalyticsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionVoteAnalyticsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(communityId, sessionVoteAnalyticsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Vote Counts
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionVoteCountsSessionsSessionIdVotesCountGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionVoteCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionVoteCountsSessionsSessionIdVotesCountGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionVoteCountsSessionsSessionIdVotesCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session Votes
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionVotesSessionsSessionIdVotesGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionVotesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionVotesSessionsSessionIdVotesGet(sessionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionVotesSessionsSessionIdVotesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By Categories
         * @param {GetSessionsByCategoriesInput} getSessionsByCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByCategoriesSessionsSearchByCategoriesPost(getSessionsByCategoriesInput: GetSessionsByCategoriesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByCategoriesSessionsSearchByCategoriesPost(getSessionsByCategoriesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByCategoriesSessionsSearchByCategoriesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By Event
         * @param {string} eventId 
         * @param {boolean} [isShuffled] 
         * @param {Array<SessionStatus>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByEventSessionsEventsEventIdGet(eventId: string, isShuffled?: boolean, statuses?: Array<SessionStatus>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByEventSessionsEventsEventIdGet(eventId, isShuffled, statuses, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByEventSessionsEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By Tags Or Categories
         * @param {GetSessionsByTagsOrCategoriesInput} getSessionsByTagsOrCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(getSessionsByTagsOrCategoriesInput: GetSessionsByTagsOrCategoriesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(getSessionsByTagsOrCategoriesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By Tags
         * @param {GetSessionsByTagsInput} getSessionsByTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByTagsSessionsSearchByTagsPost(getSessionsByTagsInput: GetSessionsByTagsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByTagsSessionsSearchByTagsPost(getSessionsByTagsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByTagsSessionsSearchByTagsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(userId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(userId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get sessions by view type (\'Viewed\' or \'Not Viewed\') for a user within an event.
         * @summary Get Sessions By View Type
         * @param {string} userId 
         * @param {GetSessionsByViewTypeInput} getSessionsByViewTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsByViewTypeSessionsUsersUserIdSessionsPost(userId: string, getSessionsByViewTypeInput: GetSessionsByViewTypeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsByViewTypeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsByViewTypeSessionsUsersUserIdSessionsPost(userId, getSessionsByViewTypeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsByViewTypeSessionsUsersUserIdSessionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all sessions viewed by a user within a specific event.
         * @summary Get Sessions Viewed By User In Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(userId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsByEventOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(userId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a specific tag by ID
         * @summary Get Tag
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagSessionsTagsTagIdGet(tagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagSessionsTagsTagIdGet(tagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getTagSessionsTagsTagIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all tags for a specific event
         * @summary Get Tags By Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagsByEventSessionsEventsEventIdTagsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagsByEventSessionsEventsEventIdTagsGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getTagsByEventSessionsEventsEventIdTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all tags for multiple events
         * @summary Get Tags By Events
         * @param {BulkGetTagsByEventsInput} bulkGetTagsByEventsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagsByEventsSessionsEventsBulkTagsPost(bulkGetTagsByEventsInput: BulkGetTagsByEventsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagsByEventsSessionsEventsBulkTagsPost(bulkGetTagsByEventsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getTagsByEventsSessionsEventsBulkTagsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Favorited Sessions
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(communityId: string, eventId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(communityId, eventId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get sessions a user has favorited filtered by temporal relation.
         * @summary Get User Favorited Sessions Temporal
         * @param {string} userId 
         * @param {TemporalRelation} [temporalRelation] Filter favorites by temporal relation: FUTURE or PAST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(userId: string, temporalRelation?: TemporalRelation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(userId, temporalRelation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all session views for a specific user.
         * @summary Get User Session Views
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSessionViewsSessionsUsersUserIdViewedGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionViewedListOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSessionViewsSessionsUsersUserIdViewedGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getUserSessionViewsSessionsUsersUserIdViewedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all sessions that a specific user has voted on within a specific event.
         * @summary Get User Session Votes
         * @param {string} eventId 
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(eventId: string, userId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(eventId, userId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Join Session
         * @param {string} sessionId 
         * @param {JoinSessionInput} joinSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinSessionSessionsSessionIdJoinPost(sessionId: string, joinSessionInput: JoinSessionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAttendeeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinSessionSessionsSessionIdJoinPost(sessionId, joinSessionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.joinSessionSessionsSessionIdJoinPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Leave Session
         * @param {string} sessionId 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveSessionSessionsSessionIdLeavePost(sessionId: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveSessionSessionsSessionIdLeavePost(sessionId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.leaveSessionSessionsSessionIdLeavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get sessions based on their temporal relation (FUTURE or PAST) from multiple communities.  Request Body: - temporal_relation: Filter sessions by FUTURE or PAST - community_ids: List of community IDs to get sessions from - start_date_from: Optional filter for sessions starting from this date ( inclusive) - start_date_to: Optional filter for sessions starting up to this date ( inclusive)
         * @summary Public Bulk Get Sessions Temporal
         * @param {BulkGetSessionsTemporalInput} bulkGetSessionsTemporalInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBulkGetSessionsTemporalSessionsTemporalPublicPost(bulkGetSessionsTemporalInput: BulkGetSessionsTemporalInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBulkGetSessionsTemporalSessionsTemporalPublicPost(bulkGetSessionsTemporalInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.publicBulkGetSessionsTemporalSessionsTemporalPublicPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Session Favorite
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(sessionId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(sessionId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Session Vote
         * @param {string} sessionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSessionVoteSessionsSessionIdVoteUserIdDelete(sessionId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSessionVoteSessionsSessionIdVoteUserIdDelete(sessionId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.removeSessionVoteSessionsSessionIdVoteUserIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Attendee Role
         * @param {string} communityId 
         * @param {UpdateSessionAttendeeRoleInput} updateSessionAttendeeRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(communityId: string, updateSessionAttendeeRoleInput: UpdateSessionAttendeeRoleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAttendeeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(communityId, updateSessionAttendeeRoleInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Category
         * @param {string} categoryId 
         * @param {string} communityId 
         * @param {UpdateCategoryInput} updateCategoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(categoryId: string, communityId: string, updateCategoryInput: UpdateCategoryInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(categoryId, communityId, updateCategoryInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update session categories by syncing to match the provided category list (removes any not in list, adds new ones)
         * @summary Update Session Categories
         * @param {string} sessionId 
         * @param {UpdateSessionCategoriesInput} updateSessionCategoriesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionCategoriesSessionsSessionIdCategoriesPut(sessionId: string, updateSessionCategoriesInput: UpdateSessionCategoriesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCategoriesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionCategoriesSessionsSessionIdCategoriesPut(sessionId, updateSessionCategoriesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateSessionCategoriesSessionsSessionIdCategoriesPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a session location. Only community owners and editors can update.
         * @summary Update Session Location
         * @param {string} sessionLocationId 
         * @param {UpdateSessionLocationInput} updateSessionLocationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionLocationSessionsLocationsSessionLocationIdPut(sessionLocationId: string, updateSessionLocationInput: UpdateSessionLocationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionLocationSessionsLocationsSessionLocationIdPut(sessionLocationId, updateSessionLocationInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateSessionLocationSessionsLocationsSessionLocationIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Session
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {UpdateSessionInput} updateSessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionSessionsSessionIdCommunitiesCommunityIdPut(sessionId: string, communityId: string, updateSessionInput: UpdateSessionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionSessionsSessionIdCommunitiesCommunityIdPut(sessionId, communityId, updateSessionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateSessionSessionsSessionIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update session tags by syncing to match the provided tag list (removes any not in list, adds new ones)
         * @summary Update Session Tags
         * @param {string} sessionId 
         * @param {string} communityId 
         * @param {UpdateSessionTagsInput} updateSessionTagsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(sessionId: string, communityId: string, updateSessionTagsInput: UpdateSessionTagsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionTagsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(sessionId, communityId, updateSessionTagsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a tag
         * @summary Update Tag
         * @param {string} tagId 
         * @param {string} communityId 
         * @param {UpdateTagInput} updateTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(tagId: string, communityId: string, updateTagInput: UpdateTagInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(tagId, communityId, updateTagInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.updateTagSessionsTagsTagIdCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Vote On Session
         * @param {string} sessionId 
         * @param {SessionVoteInput} sessionVoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteOnSessionSessionsSessionIdVotePost(sessionId: string, sessionVoteInput: SessionVoteInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionVoteOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteOnSessionSessionsSessionIdVotePost(sessionId, sessionVoteInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SessionsApi.voteOnSessionSessionsSessionIdVotePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk Get Session Attendee Counts
         * @param {SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(requestParameters: SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSessionAttendeeCountOutput> {
            return localVarFp.bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get session tags, categories, and attendees for multiple sessions.
         * @summary Bulk Get Session Data
         * @param {SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionDataSessionsBulkDataPost(requestParameters: SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSessionDataOutput> {
            return localVarFp.bulkGetSessionDataSessionsBulkDataPost(requestParameters.bulkSessionDataInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Get Session Favorite Counts
         * @param {SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(requestParameters: SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSessionFavoriteCountOutput> {
            return localVarFp.bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get session locations for multiple event IDs. Public endpoint.
         * @summary Bulk Get Session Locations
         * @param {SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionLocationsSessionsLocationsBulkPost(requestParameters: SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkGetSessionLocationsOutput> {
            return localVarFp.bulkGetSessionLocationsSessionsLocationsBulkPost(requestParameters.bulkGetSessionLocationsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Get Session Vote Counts
         * @param {SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSessionVoteCountsSessionsVotesCountBulkPost(requestParameters: SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSessionVoteCountOutput> {
            return localVarFp.bulkGetSessionVoteCountsSessionsVotesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk mark sessions as not viewed by a user (removes viewing status).
         * @summary Bulk Mark Sessions Not Viewed
         * @param {SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(requestParameters: SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionViewedListOutput> {
            return localVarFp.bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(requestParameters.userId, requestParameters.bulkMarkSessionsNotViewedInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk mark sessions as viewed by a user.
         * @summary Bulk Mark Sessions Viewed
         * @param {SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(requestParameters: SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionViewedListOutput> {
            return localVarFp.bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(requestParameters.userId, requestParameters.bulkMarkSessionsViewedInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a session status from \'scheduled\' to \'confirmed\'. Only session speakers or users with ADMIN scope can confirm sessions.
         * @summary Confirm Session
         * @param {SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSessionSessionsSessionIdConfirmPatch(requestParameters: SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionOutput> {
            return localVarFp.confirmSessionSessionsSessionIdConfirmPatch(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Category
         * @param {SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategorySessionsCategoriesCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryOutput> {
            return localVarFp.createCategorySessionsCategoriesCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createCategoryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Session Categories
         * @param {SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(requestParameters: SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionCategoriesOutput> {
            return localVarFp.createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(requestParameters.sessionId, requestParameters.communityId, requestParameters.createSessionCategoriesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a session location. Only community owners and editors can create.
         * @summary Create Session Location
         * @param {SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionLocationSessionsLocationsEventsEventIdPost(requestParameters: SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionLocation> {
            return localVarFp.createSessionLocationSessionsLocationsEventsEventIdPost(requestParameters.eventId, requestParameters.createSessionLocationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Session
         * @param {SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionSessionsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionOutput> {
            return localVarFp.createSessionSessionsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createSessionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Link existing tags to sessions (create SessionTag associations)
         * @summary Create Session Tags
         * @param {SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SessionTag>> {
            return localVarFp.createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createSessionTagsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new reusable tag within an event
         * @summary Create Tag
         * @param {SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagSessionsTagsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutput> {
            return localVarFp.createTagSessionsTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Category
         * @param {SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(requestParameters: SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(requestParameters.categoryId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Session Category
         * @param {SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(requestParameters: SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(requestParameters.sessionId, requestParameters.communityId, requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a session location. Only community owners and editors can delete.
         * @summary Delete Session Location
         * @param {SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionLocationSessionsLocationsSessionLocationIdDelete(requestParameters: SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSessionLocationOutput> {
            return localVarFp.deleteSessionLocationSessionsLocationsSessionLocationIdDelete(requestParameters.sessionLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Session Tag
         * @param {SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionTagSessionsSessionIdTagsTagIdDelete(requestParameters: SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSessionTagSessionsSessionIdTagsTagIdDelete(requestParameters.sessionId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a tag (soft delete)
         * @summary Delete Tag
         * @param {SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(requestParameters: SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(requestParameters.tagId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Favorite Session
         * @param {SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteSessionSessionsSessionIdFavoritePost(requestParameters: SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionFavoriteOutput> {
            return localVarFp.favoriteSessionSessionsSessionIdFavoritePost(requestParameters.sessionId, requestParameters.sessionFavoriteInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Categories By Event
         * @param {SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesByEventSessionsEventsEventIdCategoriesGet(requestParameters: SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoriesOutput> {
            return localVarFp.getCategoriesByEventSessionsEventsEventIdCategoriesGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all categories for multiple events
         * @summary Get Categories By Events
         * @param {SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesByEventsSessionsEventsBulkCategoriesPost(requestParameters: SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoriesOutput> {
            return localVarFp.getCategoriesByEventsSessionsEventsBulkCategoriesPost(requestParameters.bulkGetCategoriesByEventsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Category
         * @param {SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySessionsCategoriesCategoryIdGet(requestParameters: SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryOutput> {
            return localVarFp.getCategorySessionsCategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Attendee Count
         * @param {SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(requestParameters: SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionAttendeeCountOutput> {
            return localVarFp.getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Attendees
         * @param {SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAttendeesSessionsSessionIdAttendeesGet(requestParameters: SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionAttendeesOutput> {
            return localVarFp.getSessionAttendeesSessionsSessionIdAttendeesGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Categories
         * @param {SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCategoriesSessionsSessionIdCategoriesGet(requestParameters: SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionCategoriesOutput> {
            return localVarFp.getSessionCategoriesSessionsSessionIdCategoriesGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Favorites
         * @param {SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(requestParameters: SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionFavoritesOutput> {
            return localVarFp.getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(requestParameters.sessionId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a session location by ID. Public endpoint.
         * @summary Get Session Location
         * @param {SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionLocationSessionsLocationsSessionLocationIdGet(requestParameters: SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionLocation> {
            return localVarFp.getSessionLocationSessionsLocationsSessionLocationIdGet(requestParameters.sessionLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all session locations for an event ID. Public endpoint.
         * @summary Get Session Locations By Event
         * @param {SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionLocationsByEventSessionsLocationsEventsEventIdGet(requestParameters: SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SessionLocation>> {
            return localVarFp.getSessionLocationsByEventSessionsLocationsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session
         * @param {SessionsApiGetSessionSessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionSessionsSessionIdGet(requestParameters: SessionsApiGetSessionSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionOutput> {
            return localVarFp.getSessionSessionsSessionIdGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Tags By Event
         * @param {SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(requestParameters: SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionTagsOutput> {
            return localVarFp.getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Tags
         * @param {SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTagsSessionsSessionIdTagsGet(requestParameters: SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionTagsOutput> {
            return localVarFp.getSessionTagsSessionsSessionIdTagsGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get session vote analytics for a date range (max 31 days). Returns daily vote counts grouped by date.
         * @summary Get Session Vote Analytics
         * @param {SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(requestParameters: SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionVoteAnalyticsOutput> {
            return localVarFp.getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.sessionVoteAnalyticsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Vote Counts
         * @param {SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVoteCountsSessionsSessionIdVotesCountGet(requestParameters: SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionVoteCountOutput> {
            return localVarFp.getSessionVoteCountsSessionsSessionIdVotesCountGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session Votes
         * @param {SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionVotesSessionsSessionIdVotesGet(requestParameters: SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionVotesOutput> {
            return localVarFp.getSessionVotesSessionsSessionIdVotesGet(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By Categories
         * @param {SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByCategoriesSessionsSearchByCategoriesPost(requestParameters: SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getSessionsByCategoriesSessionsSearchByCategoriesPost(requestParameters.getSessionsByCategoriesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By Event
         * @param {SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByEventSessionsEventsEventIdGet(requestParameters: SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getSessionsByEventSessionsEventsEventIdGet(requestParameters.eventId, requestParameters.isShuffled, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By Tags Or Categories
         * @param {SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(requestParameters: SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(requestParameters.getSessionsByTagsOrCategoriesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By Tags
         * @param {SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByTagsSessionsSearchByTagsPost(requestParameters: SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getSessionsByTagsSessionsSearchByTagsPost(requestParameters.getSessionsByTagsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(requestParameters: SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(requestParameters.userId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sessions by view type (\'Viewed\' or \'Not Viewed\') for a user within an event.
         * @summary Get Sessions By View Type
         * @param {SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsByViewTypeSessionsUsersUserIdSessionsPost(requestParameters: SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsByViewTypeOutput> {
            return localVarFp.getSessionsByViewTypeSessionsUsersUserIdSessionsPost(requestParameters.userId, requestParameters.getSessionsByViewTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all sessions viewed by a user within a specific event.
         * @summary Get Sessions Viewed By User In Event
         * @param {SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(requestParameters: SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsByEventOutput> {
            return localVarFp.getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific tag by ID
         * @summary Get Tag
         * @param {SessionsApiGetTagSessionsTagsTagIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagSessionsTagsTagIdGet(requestParameters: SessionsApiGetTagSessionsTagsTagIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutput> {
            return localVarFp.getTagSessionsTagsTagIdGet(requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tags for a specific event
         * @summary Get Tags By Event
         * @param {SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByEventSessionsEventsEventIdTagsGet(requestParameters: SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagsOutput> {
            return localVarFp.getTagsByEventSessionsEventsEventIdTagsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tags for multiple events
         * @summary Get Tags By Events
         * @param {SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByEventsSessionsEventsBulkTagsPost(requestParameters: SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagsOutput> {
            return localVarFp.getTagsByEventsSessionsEventsBulkTagsPost(requestParameters.bulkGetTagsByEventsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Favorited Sessions
         * @param {SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(requestParameters: SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(requestParameters.communityId, requestParameters.eventId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sessions a user has favorited filtered by temporal relation.
         * @summary Get User Favorited Sessions Temporal
         * @param {SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(requestParameters: SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(requestParameters.userId, requestParameters.temporalRelation, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all session views for a specific user.
         * @summary Get User Session Views
         * @param {SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionViewsSessionsUsersUserIdViewedGet(requestParameters: SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionViewedListOutput> {
            return localVarFp.getUserSessionViewsSessionsUsersUserIdViewedGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all sessions that a specific user has voted on within a specific event.
         * @summary Get User Session Votes
         * @param {SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(requestParameters: SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(requestParameters.eventId, requestParameters.userId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join Session
         * @param {SessionsApiJoinSessionSessionsSessionIdJoinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinSessionSessionsSessionIdJoinPost(requestParameters: SessionsApiJoinSessionSessionsSessionIdJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionAttendeeOutput> {
            return localVarFp.joinSessionSessionsSessionIdJoinPost(requestParameters.sessionId, requestParameters.joinSessionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave Session
         * @param {SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveSessionSessionsSessionIdLeavePost(requestParameters: SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leaveSessionSessionsSessionIdLeavePost(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sessions based on their temporal relation (FUTURE or PAST) from multiple communities.  Request Body: - temporal_relation: Filter sessions by FUTURE or PAST - community_ids: List of community IDs to get sessions from - start_date_from: Optional filter for sessions starting from this date ( inclusive) - start_date_to: Optional filter for sessions starting up to this date ( inclusive)
         * @summary Public Bulk Get Sessions Temporal
         * @param {SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBulkGetSessionsTemporalSessionsTemporalPublicPost(requestParameters: SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionsOutput> {
            return localVarFp.publicBulkGetSessionsTemporalSessionsTemporalPublicPost(requestParameters.bulkGetSessionsTemporalInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Session Favorite
         * @param {SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(requestParameters: SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Session Vote
         * @param {SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSessionVoteSessionsSessionIdVoteUserIdDelete(requestParameters: SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeSessionVoteSessionsSessionIdVoteUserIdDelete(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Attendee Role
         * @param {SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionAttendeeOutput> {
            return localVarFp.updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(requestParameters.communityId, requestParameters.updateSessionAttendeeRoleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Category
         * @param {SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryOutput> {
            return localVarFp.updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(requestParameters.categoryId, requestParameters.communityId, requestParameters.updateCategoryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update session categories by syncing to match the provided category list (removes any not in list, adds new ones)
         * @summary Update Session Categories
         * @param {SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionCategoriesSessionsSessionIdCategoriesPut(requestParameters: SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionCategoriesOutput> {
            return localVarFp.updateSessionCategoriesSessionsSessionIdCategoriesPut(requestParameters.sessionId, requestParameters.updateSessionCategoriesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a session location. Only community owners and editors can update.
         * @summary Update Session Location
         * @param {SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionLocationSessionsLocationsSessionLocationIdPut(requestParameters: SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionLocation> {
            return localVarFp.updateSessionLocationSessionsLocationsSessionLocationIdPut(requestParameters.sessionLocationId, requestParameters.updateSessionLocationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Session
         * @param {SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionSessionsSessionIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionOutput> {
            return localVarFp.updateSessionSessionsSessionIdCommunitiesCommunityIdPut(requestParameters.sessionId, requestParameters.communityId, requestParameters.updateSessionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update session tags by syncing to match the provided tag list (removes any not in list, adds new ones)
         * @summary Update Session Tags
         * @param {SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(requestParameters: SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionTagsOutput> {
            return localVarFp.updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(requestParameters.sessionId, requestParameters.communityId, requestParameters.updateSessionTagsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a tag
         * @summary Update Tag
         * @param {SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutput> {
            return localVarFp.updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(requestParameters.tagId, requestParameters.communityId, requestParameters.updateTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vote On Session
         * @param {SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteOnSessionSessionsSessionIdVotePost(requestParameters: SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionVoteOutput> {
            return localVarFp.voteOnSessionSessionsSessionIdVotePost(requestParameters.sessionId, requestParameters.sessionVoteInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest
 */
export interface SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest {
    /**
     * 
     * @type {BulkSessionIdsInput}
     * @memberof SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost
     */
    readonly bulkSessionIdsInput: BulkSessionIdsInput
}

/**
 * Request parameters for bulkGetSessionDataSessionsBulkDataPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest
 */
export interface SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest {
    /**
     * 
     * @type {BulkSessionDataInput}
     * @memberof SessionsApiBulkGetSessionDataSessionsBulkDataPost
     */
    readonly bulkSessionDataInput: BulkSessionDataInput
}

/**
 * Request parameters for bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest
 */
export interface SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest {
    /**
     * 
     * @type {BulkSessionIdsInput}
     * @memberof SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost
     */
    readonly bulkSessionIdsInput: BulkSessionIdsInput
}

/**
 * Request parameters for bulkGetSessionLocationsSessionsLocationsBulkPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest
 */
export interface SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest {
    /**
     * 
     * @type {BulkGetSessionLocationsInput}
     * @memberof SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPost
     */
    readonly bulkGetSessionLocationsInput: BulkGetSessionLocationsInput
}

/**
 * Request parameters for bulkGetSessionVoteCountsSessionsVotesCountBulkPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest
 */
export interface SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest {
    /**
     * 
     * @type {BulkSessionIdsInput}
     * @memberof SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPost
     */
    readonly bulkSessionIdsInput: BulkSessionIdsInput
}

/**
 * Request parameters for bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest
 */
export interface SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete
     */
    readonly userId: string

    /**
     * 
     * @type {BulkMarkSessionsNotViewedInput}
     * @memberof SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete
     */
    readonly bulkMarkSessionsNotViewedInput: BulkMarkSessionsNotViewedInput
}

/**
 * Request parameters for bulkMarkSessionsViewedSessionsUsersUserIdViewedPost operation in SessionsApi.
 * @export
 * @interface SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest
 */
export interface SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPost
     */
    readonly userId: string

    /**
     * 
     * @type {BulkMarkSessionsViewedInput}
     * @memberof SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPost
     */
    readonly bulkMarkSessionsViewedInput: BulkMarkSessionsViewedInput
}

/**
 * Request parameters for confirmSessionSessionsSessionIdConfirmPatch operation in SessionsApi.
 * @export
 * @interface SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest
 */
export interface SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiConfirmSessionSessionsSessionIdConfirmPatch
     */
    readonly sessionId: string
}

/**
 * Request parameters for createCategorySessionsCategoriesCommunitiesCommunityIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest
 */
export interface SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateCategoryInput}
     * @memberof SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPost
     */
    readonly createCategoryInput: CreateCategoryInput
}

/**
 * Request parameters for createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest
 */
export interface SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateSessionCategoriesInput}
     * @memberof SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost
     */
    readonly createSessionCategoriesInput: CreateSessionCategoriesInput
}

/**
 * Request parameters for createSessionLocationSessionsLocationsEventsEventIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest
 */
export interface SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPost
     */
    readonly eventId: string

    /**
     * 
     * @type {CreateSessionLocationInput}
     * @memberof SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPost
     */
    readonly createSessionLocationInput: CreateSessionLocationInput
}

/**
 * Request parameters for createSessionSessionsCommunitiesCommunityIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest
 */
export interface SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateSessionSessionsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateSessionInput}
     * @memberof SessionsApiCreateSessionSessionsCommunitiesCommunityIdPost
     */
    readonly createSessionInput: CreateSessionInput
}

/**
 * Request parameters for createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest
 */
export interface SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateSessionTagsInput}
     * @memberof SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost
     */
    readonly createSessionTagsInput: CreateSessionTagsInput
}

/**
 * Request parameters for createTagSessionsTagsCommunitiesCommunityIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest
 */
export interface SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateTagInput}
     * @memberof SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPost
     */
    readonly createTagInput: CreateTagInput
}

/**
 * Request parameters for deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest
 */
export interface SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete
     */
    readonly categoryId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest
 */
export interface SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete
     */
    readonly categoryId: string
}

/**
 * Request parameters for deleteSessionLocationSessionsLocationsSessionLocationIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest
 */
export interface SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDelete
     */
    readonly sessionLocationId: string
}

/**
 * Request parameters for deleteSessionTagSessionsSessionIdTagsTagIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest
 */
export interface SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDelete
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDelete
     */
    readonly tagId: string
}

/**
 * Request parameters for deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest
 */
export interface SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for favoriteSessionSessionsSessionIdFavoritePost operation in SessionsApi.
 * @export
 * @interface SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest
 */
export interface SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiFavoriteSessionSessionsSessionIdFavoritePost
     */
    readonly sessionId: string

    /**
     * 
     * @type {SessionFavoriteInput}
     * @memberof SessionsApiFavoriteSessionSessionsSessionIdFavoritePost
     */
    readonly sessionFavoriteInput: SessionFavoriteInput
}

/**
 * Request parameters for getCategoriesByEventSessionsEventsEventIdCategoriesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest
 */
export interface SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getCategoriesByEventsSessionsEventsBulkCategoriesPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest
 */
export interface SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest {
    /**
     * 
     * @type {BulkGetCategoriesByEventsInput}
     * @memberof SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPost
     */
    readonly bulkGetCategoriesByEventsInput: BulkGetCategoriesByEventsInput
}

/**
 * Request parameters for getCategorySessionsCategoriesCategoryIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest
 */
export interface SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetCategorySessionsCategoriesCategoryIdGet
     */
    readonly categoryId: string
}

/**
 * Request parameters for getSessionAttendeeCountSessionsSessionIdAttendeesCountGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest
 */
export interface SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionAttendeesSessionsSessionIdAttendeesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest
 */
export interface SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionCategoriesSessionsSessionIdCategoriesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest
 */
export interface SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest
 */
export interface SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getSessionLocationSessionsLocationsSessionLocationIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest
 */
export interface SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGet
     */
    readonly sessionLocationId: string
}

/**
 * Request parameters for getSessionLocationsByEventSessionsLocationsEventsEventIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest
 */
export interface SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getSessionSessionsSessionIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionSessionsSessionIdGetRequest
 */
export interface SessionsApiGetSessionSessionsSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionSessionsSessionIdGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionTagsByEventSessionsEventsEventIdSessionTagsGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest
 */
export interface SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getSessionTagsSessionsSessionIdTagsGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest
 */
export interface SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionTagsSessionsSessionIdTagsGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest
 */
export interface SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {SessionVoteAnalyticsInput}
     * @memberof SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost
     */
    readonly sessionVoteAnalyticsInput: SessionVoteAnalyticsInput
}

/**
 * Request parameters for getSessionVoteCountsSessionsSessionIdVotesCountGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest
 */
export interface SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionVotesSessionsSessionIdVotesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest
 */
export interface SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionVotesSessionsSessionIdVotesGet
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionsByCategoriesSessionsSearchByCategoriesPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest
 */
export interface SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest {
    /**
     * 
     * @type {GetSessionsByCategoriesInput}
     * @memberof SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPost
     */
    readonly getSessionsByCategoriesInput: GetSessionsByCategoriesInput
}

/**
 * Request parameters for getSessionsByEventSessionsEventsEventIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest
 */
export interface SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsByEventSessionsEventsEventIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {boolean}
     * @memberof SessionsApiGetSessionsByEventSessionsEventsEventIdGet
     */
    readonly isShuffled?: boolean

    /**
     * 
     * @type {Array<SessionStatus>}
     * @memberof SessionsApiGetSessionsByEventSessionsEventsEventIdGet
     */
    readonly statuses?: Array<SessionStatus>
}

/**
 * Request parameters for getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest
 */
export interface SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest {
    /**
     * 
     * @type {GetSessionsByTagsOrCategoriesInput}
     * @memberof SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost
     */
    readonly getSessionsByTagsOrCategoriesInput: GetSessionsByTagsOrCategoriesInput
}

/**
 * Request parameters for getSessionsByTagsSessionsSearchByTagsPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest
 */
export interface SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest {
    /**
     * 
     * @type {GetSessionsByTagsInput}
     * @memberof SessionsApiGetSessionsByTagsSessionsSearchByTagsPost
     */
    readonly getSessionsByTagsInput: GetSessionsByTagsInput
}

/**
 * Request parameters for getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest
 */
export interface SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getSessionsByViewTypeSessionsUsersUserIdSessionsPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest
 */
export interface SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPost
     */
    readonly userId: string

    /**
     * 
     * @type {GetSessionsByViewTypeInput}
     * @memberof SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPost
     */
    readonly getSessionsByViewTypeInput: GetSessionsByViewTypeInput
}

/**
 * Request parameters for getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest
 */
export interface SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTagSessionsTagsTagIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetTagSessionsTagsTagIdGetRequest
 */
export interface SessionsApiGetTagSessionsTagsTagIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetTagSessionsTagsTagIdGet
     */
    readonly tagId: string
}

/**
 * Request parameters for getTagsByEventSessionsEventsEventIdTagsGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest
 */
export interface SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetTagsByEventSessionsEventsEventIdTagsGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTagsByEventsSessionsEventsBulkTagsPost operation in SessionsApi.
 * @export
 * @interface SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest
 */
export interface SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest {
    /**
     * 
     * @type {BulkGetTagsByEventsInput}
     * @memberof SessionsApiGetTagsByEventsSessionsEventsBulkTagsPost
     */
    readonly bulkGetTagsByEventsInput: BulkGetTagsByEventsInput
}

/**
 * Request parameters for getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest
 */
export interface SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet
     */
    readonly userId: string
}

/**
 * Request parameters for getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest
 */
export interface SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet
     */
    readonly userId: string

    /**
     * Filter favorites by temporal relation: FUTURE or PAST.
     * @type {TemporalRelation}
     * @memberof SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet
     */
    readonly temporalRelation?: TemporalRelation
}

/**
 * Request parameters for getUserSessionViewsSessionsUsersUserIdViewedGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest
 */
export interface SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGet
     */
    readonly userId: string
}

/**
 * Request parameters for getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet operation in SessionsApi.
 * @export
 * @interface SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest
 */
export interface SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for joinSessionSessionsSessionIdJoinPost operation in SessionsApi.
 * @export
 * @interface SessionsApiJoinSessionSessionsSessionIdJoinPostRequest
 */
export interface SessionsApiJoinSessionSessionsSessionIdJoinPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiJoinSessionSessionsSessionIdJoinPost
     */
    readonly sessionId: string

    /**
     * 
     * @type {JoinSessionInput}
     * @memberof SessionsApiJoinSessionSessionsSessionIdJoinPost
     */
    readonly joinSessionInput: JoinSessionInput
}

/**
 * Request parameters for leaveSessionSessionsSessionIdLeavePost operation in SessionsApi.
 * @export
 * @interface SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest
 */
export interface SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiLeaveSessionSessionsSessionIdLeavePost
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiLeaveSessionSessionsSessionIdLeavePost
     */
    readonly userId?: string
}

/**
 * Request parameters for publicBulkGetSessionsTemporalSessionsTemporalPublicPost operation in SessionsApi.
 * @export
 * @interface SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest
 */
export interface SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest {
    /**
     * 
     * @type {BulkGetSessionsTemporalInput}
     * @memberof SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPost
     */
    readonly bulkGetSessionsTemporalInput: BulkGetSessionsTemporalInput
}

/**
 * Request parameters for removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest
 */
export interface SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDelete
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDelete
     */
    readonly userId: string
}

/**
 * Request parameters for removeSessionVoteSessionsSessionIdVoteUserIdDelete operation in SessionsApi.
 * @export
 * @interface SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest
 */
export interface SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDelete
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDelete
     */
    readonly userId: string
}

/**
 * Request parameters for updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest
 */
export interface SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateSessionAttendeeRoleInput}
     * @memberof SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut
     */
    readonly updateSessionAttendeeRoleInput: UpdateSessionAttendeeRoleInput
}

/**
 * Request parameters for updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest
 */
export interface SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut
     */
    readonly categoryId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateCategoryInput}
     * @memberof SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut
     */
    readonly updateCategoryInput: UpdateCategoryInput
}

/**
 * Request parameters for updateSessionCategoriesSessionsSessionIdCategoriesPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest
 */
export interface SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPut
     */
    readonly sessionId: string

    /**
     * 
     * @type {UpdateSessionCategoriesInput}
     * @memberof SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPut
     */
    readonly updateSessionCategoriesInput: UpdateSessionCategoriesInput
}

/**
 * Request parameters for updateSessionLocationSessionsLocationsSessionLocationIdPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest
 */
export interface SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPut
     */
    readonly sessionLocationId: string

    /**
     * 
     * @type {UpdateSessionLocationInput}
     * @memberof SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPut
     */
    readonly updateSessionLocationInput: UpdateSessionLocationInput
}

/**
 * Request parameters for updateSessionSessionsSessionIdCommunitiesCommunityIdPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest
 */
export interface SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPut
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateSessionInput}
     * @memberof SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPut
     */
    readonly updateSessionInput: UpdateSessionInput
}

/**
 * Request parameters for updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest
 */
export interface SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateSessionTagsInput}
     * @memberof SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut
     */
    readonly updateSessionTagsInput: UpdateSessionTagsInput
}

/**
 * Request parameters for updateTagSessionsTagsTagIdCommunitiesCommunityIdPut operation in SessionsApi.
 * @export
 * @interface SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest
 */
export interface SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPut
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateTagInput}
     * @memberof SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPut
     */
    readonly updateTagInput: UpdateTagInput
}

/**
 * Request parameters for voteOnSessionSessionsSessionIdVotePost operation in SessionsApi.
 * @export
 * @interface SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest
 */
export interface SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionsApiVoteOnSessionSessionsSessionIdVotePost
     */
    readonly sessionId: string

    /**
     * 
     * @type {SessionVoteInput}
     * @memberof SessionsApiVoteOnSessionSessionsSessionIdVotePost
     */
    readonly sessionVoteInput: SessionVoteInput
}

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     * 
     * @summary Bulk Get Session Attendee Counts
     * @param {SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(requestParameters: SessionsApiBulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkGetSessionAttendeeCountsSessionsAttendeesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get session tags, categories, and attendees for multiple sessions.
     * @summary Bulk Get Session Data
     * @param {SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkGetSessionDataSessionsBulkDataPost(requestParameters: SessionsApiBulkGetSessionDataSessionsBulkDataPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkGetSessionDataSessionsBulkDataPost(requestParameters.bulkSessionDataInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Get Session Favorite Counts
     * @param {SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(requestParameters: SessionsApiBulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkGetSessionFavoriteCountsSessionsFavoritesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get session locations for multiple event IDs. Public endpoint.
     * @summary Bulk Get Session Locations
     * @param {SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkGetSessionLocationsSessionsLocationsBulkPost(requestParameters: SessionsApiBulkGetSessionLocationsSessionsLocationsBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkGetSessionLocationsSessionsLocationsBulkPost(requestParameters.bulkGetSessionLocationsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Get Session Vote Counts
     * @param {SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkGetSessionVoteCountsSessionsVotesCountBulkPost(requestParameters: SessionsApiBulkGetSessionVoteCountsSessionsVotesCountBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkGetSessionVoteCountsSessionsVotesCountBulkPost(requestParameters.bulkSessionIdsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk mark sessions as not viewed by a user (removes viewing status).
     * @summary Bulk Mark Sessions Not Viewed
     * @param {SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(requestParameters: SessionsApiBulkMarkSessionsNotViewedSessionsUsersUserIdViewedDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkMarkSessionsNotViewedSessionsUsersUserIdViewedDelete(requestParameters.userId, requestParameters.bulkMarkSessionsNotViewedInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk mark sessions as viewed by a user.
     * @summary Bulk Mark Sessions Viewed
     * @param {SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(requestParameters: SessionsApiBulkMarkSessionsViewedSessionsUsersUserIdViewedPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).bulkMarkSessionsViewedSessionsUsersUserIdViewedPost(requestParameters.userId, requestParameters.bulkMarkSessionsViewedInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a session status from \'scheduled\' to \'confirmed\'. Only session speakers or users with ADMIN scope can confirm sessions.
     * @summary Confirm Session
     * @param {SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public confirmSessionSessionsSessionIdConfirmPatch(requestParameters: SessionsApiConfirmSessionSessionsSessionIdConfirmPatchRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).confirmSessionSessionsSessionIdConfirmPatch(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Category
     * @param {SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createCategorySessionsCategoriesCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateCategorySessionsCategoriesCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createCategorySessionsCategoriesCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createCategoryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Session Categories
     * @param {SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(requestParameters: SessionsApiCreateSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createSessionCategoriesSessionsSessionIdCommunitiesCommunityIdCategoriesPost(requestParameters.sessionId, requestParameters.communityId, requestParameters.createSessionCategoriesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a session location. Only community owners and editors can create.
     * @summary Create Session Location
     * @param {SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createSessionLocationSessionsLocationsEventsEventIdPost(requestParameters: SessionsApiCreateSessionLocationSessionsLocationsEventsEventIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createSessionLocationSessionsLocationsEventsEventIdPost(requestParameters.eventId, requestParameters.createSessionLocationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Session
     * @param {SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createSessionSessionsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateSessionSessionsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createSessionSessionsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createSessionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Link existing tags to sessions (create SessionTag associations)
     * @summary Create Session Tags
     * @param {SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateSessionTagsSessionsSessionTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createSessionTagsSessionsSessionTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createSessionTagsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new reusable tag within an event
     * @summary Create Tag
     * @param {SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createTagSessionsTagsCommunitiesCommunityIdPost(requestParameters: SessionsApiCreateTagSessionsTagsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).createTagSessionsTagsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Category
     * @param {SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(requestParameters: SessionsApiDeleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).deleteCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdDelete(requestParameters.categoryId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Session Category
     * @param {SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(requestParameters: SessionsApiDeleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).deleteSessionCategorySessionsSessionIdCommunitiesCommunityIdCategoriesCategoryIdDelete(requestParameters.sessionId, requestParameters.communityId, requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a session location. Only community owners and editors can delete.
     * @summary Delete Session Location
     * @param {SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public deleteSessionLocationSessionsLocationsSessionLocationIdDelete(requestParameters: SessionsApiDeleteSessionLocationSessionsLocationsSessionLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).deleteSessionLocationSessionsLocationsSessionLocationIdDelete(requestParameters.sessionLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Session Tag
     * @param {SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public deleteSessionTagSessionsSessionIdTagsTagIdDelete(requestParameters: SessionsApiDeleteSessionTagSessionsSessionIdTagsTagIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).deleteSessionTagSessionsSessionIdTagsTagIdDelete(requestParameters.sessionId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a tag (soft delete)
     * @summary Delete Tag
     * @param {SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(requestParameters: SessionsApiDeleteTagSessionsTagsTagIdCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).deleteTagSessionsTagsTagIdCommunitiesCommunityIdDelete(requestParameters.tagId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Favorite Session
     * @param {SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public favoriteSessionSessionsSessionIdFavoritePost(requestParameters: SessionsApiFavoriteSessionSessionsSessionIdFavoritePostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).favoriteSessionSessionsSessionIdFavoritePost(requestParameters.sessionId, requestParameters.sessionFavoriteInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Categories By Event
     * @param {SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getCategoriesByEventSessionsEventsEventIdCategoriesGet(requestParameters: SessionsApiGetCategoriesByEventSessionsEventsEventIdCategoriesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getCategoriesByEventSessionsEventsEventIdCategoriesGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all categories for multiple events
     * @summary Get Categories By Events
     * @param {SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getCategoriesByEventsSessionsEventsBulkCategoriesPost(requestParameters: SessionsApiGetCategoriesByEventsSessionsEventsBulkCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getCategoriesByEventsSessionsEventsBulkCategoriesPost(requestParameters.bulkGetCategoriesByEventsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Category
     * @param {SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getCategorySessionsCategoriesCategoryIdGet(requestParameters: SessionsApiGetCategorySessionsCategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getCategorySessionsCategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Attendee Count
     * @param {SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(requestParameters: SessionsApiGetSessionAttendeeCountSessionsSessionIdAttendeesCountGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionAttendeeCountSessionsSessionIdAttendeesCountGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Attendees
     * @param {SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionAttendeesSessionsSessionIdAttendeesGet(requestParameters: SessionsApiGetSessionAttendeesSessionsSessionIdAttendeesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionAttendeesSessionsSessionIdAttendeesGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Categories
     * @param {SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionCategoriesSessionsSessionIdCategoriesGet(requestParameters: SessionsApiGetSessionCategoriesSessionsSessionIdCategoriesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionCategoriesSessionsSessionIdCategoriesGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Favorites
     * @param {SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(requestParameters: SessionsApiGetSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionFavoritesSessionsSessionIdCommunitiesCommunityIdFavoritesGet(requestParameters.sessionId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a session location by ID. Public endpoint.
     * @summary Get Session Location
     * @param {SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionLocationSessionsLocationsSessionLocationIdGet(requestParameters: SessionsApiGetSessionLocationSessionsLocationsSessionLocationIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionLocationSessionsLocationsSessionLocationIdGet(requestParameters.sessionLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all session locations for an event ID. Public endpoint.
     * @summary Get Session Locations By Event
     * @param {SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionLocationsByEventSessionsLocationsEventsEventIdGet(requestParameters: SessionsApiGetSessionLocationsByEventSessionsLocationsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionLocationsByEventSessionsLocationsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session
     * @param {SessionsApiGetSessionSessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionSessionsSessionIdGet(requestParameters: SessionsApiGetSessionSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionSessionsSessionIdGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Tags By Event
     * @param {SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(requestParameters: SessionsApiGetSessionTagsByEventSessionsEventsEventIdSessionTagsGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionTagsByEventSessionsEventsEventIdSessionTagsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Tags
     * @param {SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionTagsSessionsSessionIdTagsGet(requestParameters: SessionsApiGetSessionTagsSessionsSessionIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionTagsSessionsSessionIdTagsGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get session vote analytics for a date range (max 31 days). Returns daily vote counts grouped by date.
     * @summary Get Session Vote Analytics
     * @param {SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(requestParameters: SessionsApiGetSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionVoteAnalyticsSessionsVotesAnalyticsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.sessionVoteAnalyticsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Vote Counts
     * @param {SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionVoteCountsSessionsSessionIdVotesCountGet(requestParameters: SessionsApiGetSessionVoteCountsSessionsSessionIdVotesCountGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionVoteCountsSessionsSessionIdVotesCountGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session Votes
     * @param {SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionVotesSessionsSessionIdVotesGet(requestParameters: SessionsApiGetSessionVotesSessionsSessionIdVotesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionVotesSessionsSessionIdVotesGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By Categories
     * @param {SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByCategoriesSessionsSearchByCategoriesPost(requestParameters: SessionsApiGetSessionsByCategoriesSessionsSearchByCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByCategoriesSessionsSearchByCategoriesPost(requestParameters.getSessionsByCategoriesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By Event
     * @param {SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByEventSessionsEventsEventIdGet(requestParameters: SessionsApiGetSessionsByEventSessionsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByEventSessionsEventsEventIdGet(requestParameters.eventId, requestParameters.isShuffled, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By Tags Or Categories
     * @param {SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(requestParameters: SessionsApiGetSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByTagsOrCategoriesSessionsSearchByTagsOrCategoriesPost(requestParameters.getSessionsByTagsOrCategoriesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By Tags
     * @param {SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByTagsSessionsSearchByTagsPost(requestParameters: SessionsApiGetSessionsByTagsSessionsSearchByTagsPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByTagsSessionsSearchByTagsPost(requestParameters.getSessionsByTagsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By User
     * @param {SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(requestParameters: SessionsApiGetSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByUserSessionsUsersUserIdCommunitiesCommunityIdGet(requestParameters.userId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sessions by view type (\'Viewed\' or \'Not Viewed\') for a user within an event.
     * @summary Get Sessions By View Type
     * @param {SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsByViewTypeSessionsUsersUserIdSessionsPost(requestParameters: SessionsApiGetSessionsByViewTypeSessionsUsersUserIdSessionsPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsByViewTypeSessionsUsersUserIdSessionsPost(requestParameters.userId, requestParameters.getSessionsByViewTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all sessions viewed by a user within a specific event.
     * @summary Get Sessions Viewed By User In Event
     * @param {SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(requestParameters: SessionsApiGetSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getSessionsViewedByUserInEventSessionsUsersUserIdEventsEventIdSessionsViewedGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific tag by ID
     * @summary Get Tag
     * @param {SessionsApiGetTagSessionsTagsTagIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getTagSessionsTagsTagIdGet(requestParameters: SessionsApiGetTagSessionsTagsTagIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getTagSessionsTagsTagIdGet(requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tags for a specific event
     * @summary Get Tags By Event
     * @param {SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getTagsByEventSessionsEventsEventIdTagsGet(requestParameters: SessionsApiGetTagsByEventSessionsEventsEventIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getTagsByEventSessionsEventsEventIdTagsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tags for multiple events
     * @summary Get Tags By Events
     * @param {SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getTagsByEventsSessionsEventsBulkTagsPost(requestParameters: SessionsApiGetTagsByEventsSessionsEventsBulkTagsPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getTagsByEventsSessionsEventsBulkTagsPost(requestParameters.bulkGetTagsByEventsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Favorited Sessions
     * @param {SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(requestParameters: SessionsApiGetUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getUserFavoritedSessionsSessionsCommunitiesCommunityIdEventsEventIdUsersUserIdFavoritesGet(requestParameters.communityId, requestParameters.eventId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sessions a user has favorited filtered by temporal relation.
     * @summary Get User Favorited Sessions Temporal
     * @param {SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(requestParameters: SessionsApiGetUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getUserFavoritedSessionsTemporalSessionsUsersUserIdFavoritesTemporalGet(requestParameters.userId, requestParameters.temporalRelation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all session views for a specific user.
     * @summary Get User Session Views
     * @param {SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getUserSessionViewsSessionsUsersUserIdViewedGet(requestParameters: SessionsApiGetUserSessionViewsSessionsUsersUserIdViewedGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getUserSessionViewsSessionsUsersUserIdViewedGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all sessions that a specific user has voted on within a specific event.
     * @summary Get User Session Votes
     * @param {SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(requestParameters: SessionsApiGetUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).getUserSessionVotesSessionsVotesEventsEventIdUsersUserIdCommunitiesCommunityIdGet(requestParameters.eventId, requestParameters.userId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join Session
     * @param {SessionsApiJoinSessionSessionsSessionIdJoinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public joinSessionSessionsSessionIdJoinPost(requestParameters: SessionsApiJoinSessionSessionsSessionIdJoinPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).joinSessionSessionsSessionIdJoinPost(requestParameters.sessionId, requestParameters.joinSessionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave Session
     * @param {SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public leaveSessionSessionsSessionIdLeavePost(requestParameters: SessionsApiLeaveSessionSessionsSessionIdLeavePostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).leaveSessionSessionsSessionIdLeavePost(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sessions based on their temporal relation (FUTURE or PAST) from multiple communities.  Request Body: - temporal_relation: Filter sessions by FUTURE or PAST - community_ids: List of community IDs to get sessions from - start_date_from: Optional filter for sessions starting from this date ( inclusive) - start_date_to: Optional filter for sessions starting up to this date ( inclusive)
     * @summary Public Bulk Get Sessions Temporal
     * @param {SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public publicBulkGetSessionsTemporalSessionsTemporalPublicPost(requestParameters: SessionsApiPublicBulkGetSessionsTemporalSessionsTemporalPublicPostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).publicBulkGetSessionsTemporalSessionsTemporalPublicPost(requestParameters.bulkGetSessionsTemporalInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Session Favorite
     * @param {SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(requestParameters: SessionsApiRemoveSessionFavoriteSessionsSessionIdFavoriteUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).removeSessionFavoriteSessionsSessionIdFavoriteUserIdDelete(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Session Vote
     * @param {SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public removeSessionVoteSessionsSessionIdVoteUserIdDelete(requestParameters: SessionsApiRemoveSessionVoteSessionsSessionIdVoteUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).removeSessionVoteSessionsSessionIdVoteUserIdDelete(requestParameters.sessionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Attendee Role
     * @param {SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateAttendeeRoleSessionsAttendeesRoleCommunitiesCommunityIdPut(requestParameters.communityId, requestParameters.updateSessionAttendeeRoleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Category
     * @param {SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateCategorySessionsCategoriesCategoryIdCommunitiesCommunityIdPut(requestParameters.categoryId, requestParameters.communityId, requestParameters.updateCategoryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update session categories by syncing to match the provided category list (removes any not in list, adds new ones)
     * @summary Update Session Categories
     * @param {SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateSessionCategoriesSessionsSessionIdCategoriesPut(requestParameters: SessionsApiUpdateSessionCategoriesSessionsSessionIdCategoriesPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateSessionCategoriesSessionsSessionIdCategoriesPut(requestParameters.sessionId, requestParameters.updateSessionCategoriesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a session location. Only community owners and editors can update.
     * @summary Update Session Location
     * @param {SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateSessionLocationSessionsLocationsSessionLocationIdPut(requestParameters: SessionsApiUpdateSessionLocationSessionsLocationsSessionLocationIdPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateSessionLocationSessionsLocationsSessionLocationIdPut(requestParameters.sessionLocationId, requestParameters.updateSessionLocationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Session
     * @param {SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateSessionSessionsSessionIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateSessionSessionsSessionIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateSessionSessionsSessionIdCommunitiesCommunityIdPut(requestParameters.sessionId, requestParameters.communityId, requestParameters.updateSessionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update session tags by syncing to match the provided tag list (removes any not in list, adds new ones)
     * @summary Update Session Tags
     * @param {SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(requestParameters: SessionsApiUpdateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateSessionTagsSessionsSessionIdCommunitiesCommunityIdTagsPut(requestParameters.sessionId, requestParameters.communityId, requestParameters.updateSessionTagsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a tag
     * @summary Update Tag
     * @param {SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(requestParameters: SessionsApiUpdateTagSessionsTagsTagIdCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).updateTagSessionsTagsTagIdCommunitiesCommunityIdPut(requestParameters.tagId, requestParameters.communityId, requestParameters.updateTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vote On Session
     * @param {SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public voteOnSessionSessionsSessionIdVotePost(requestParameters: SessionsApiVoteOnSessionSessionsSessionIdVotePostRequest, options?: RawAxiosRequestConfig) {
        return SessionsApiFp(this.configuration).voteOnSessionSessionsSessionIdVotePost(requestParameters.sessionId, requestParameters.sessionVoteInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeConnectApi - axios parameter creator
 * @export
 */
export const StripeConnectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a link for updating bank account information.
         * @summary Create Bank Update Link
         * @param {string} communityId 
         * @param {CreateOnboardingLinkInput} createOnboardingLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost: async (communityId: string, createOnboardingLinkInput: CreateOnboardingLinkInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost', 'communityId', communityId)
            // verify required parameter 'createOnboardingLinkInput' is not null or undefined
            assertParamExists('createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost', 'createOnboardingLinkInput', createOnboardingLinkInput)
            const localVarPath = `/connect/communities/{community_id}/account/bank-update-link/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOnboardingLinkInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe Connect Express account for a community.  This creates the Stripe account and returns the account record. The community owner must then complete onboarding via the onboarding link.
         * @summary Create Connect Account
         * @param {string} communityId 
         * @param {CreateConnectAccountInput} createConnectAccountInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectAccountConnectCommunitiesCommunityIdAccountPost: async (communityId: string, createConnectAccountInput: CreateConnectAccountInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createConnectAccountConnectCommunitiesCommunityIdAccountPost', 'communityId', communityId)
            // verify required parameter 'createConnectAccountInput' is not null or undefined
            assertParamExists('createConnectAccountConnectCommunitiesCommunityIdAccountPost', 'createConnectAccountInput', createConnectAccountInput)
            const localVarPath = `/connect/communities/{community_id}/account/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConnectAccountInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an onboarding link for completing Stripe Connect setup.  The link expires after a short time, so generate it just before redirecting.
         * @summary Create Onboarding Link
         * @param {string} communityId 
         * @param {CreateOnboardingLinkInput} createOnboardingLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost: async (communityId: string, createOnboardingLinkInput: CreateOnboardingLinkInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost', 'communityId', communityId)
            // verify required parameter 'createOnboardingLinkInput' is not null or undefined
            assertParamExists('createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost', 'createOnboardingLinkInput', createOnboardingLinkInput)
            const localVarPath = `/connect/communities/{community_id}/account/onboarding-link/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOnboardingLinkInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable a community\'s Connect account (admin only).
         * @summary Disable Connect Account
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost', 'communityId', communityId)
            const localVarPath = `/connect/communities/{community_id}/account/disable/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the Stripe Connect account for a community.
         * @summary Get Connect Account
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectAccountConnectCommunitiesCommunityIdAccountGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getConnectAccountConnectCommunitiesCommunityIdAccountGet', 'communityId', communityId)
            const localVarPath = `/connect/communities/{community_id}/account/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the Stripe balance for a community\'s Connect account.
         * @summary Get Connect Balance
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectBalanceConnectCommunitiesCommunityIdBalanceGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getConnectBalanceConnectCommunitiesCommunityIdBalanceGet', 'communityId', communityId)
            const localVarPath = `/connect/communities/{community_id}/balance/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List payouts for a community\'s Connect account.
         * @summary List Connect Payouts
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {string} [startingAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet: async (communityId: string, limit?: number, startingAfter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet', 'communityId', communityId)
            const localVarPath = `/connect/communities/{community_id}/payouts/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List transactions for a community\'s Connect account.
         * @summary List Connect Transactions
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {string} [startingAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet: async (communityId: string, limit?: number, startingAfter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet', 'communityId', communityId)
            const localVarPath = `/connect/communities/{community_id}/transactions/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the payout schedule for a community\'s Connect account.
         * @summary Update Payout Schedule
         * @param {string} communityId 
         * @param {UpdatePayoutScheduleInput} updatePayoutScheduleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost: async (communityId: string, updatePayoutScheduleInput: UpdatePayoutScheduleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost', 'communityId', communityId)
            // verify required parameter 'updatePayoutScheduleInput' is not null or undefined
            assertParamExists('updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost', 'updatePayoutScheduleInput', updatePayoutScheduleInput)
            const localVarPath = `/connect/communities/{community_id}/account/payout-schedule/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePayoutScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the platform fee percentage for a community (admin only).
         * @summary Update Platform Fee
         * @param {string} communityId 
         * @param {UpdatePlatformFeeInput} updatePlatformFeeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch: async (communityId: string, updatePlatformFeeInput: UpdatePlatformFeeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch', 'communityId', communityId)
            // verify required parameter 'updatePlatformFeeInput' is not null or undefined
            assertParamExists('updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch', 'updatePlatformFeeInput', updatePlatformFeeInput)
            const localVarPath = `/connect/communities/{community_id}/account/platform-fee/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlatformFeeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeConnectApi - functional programming interface
 * @export
 */
export const StripeConnectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeConnectApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a link for updating bank account information.
         * @summary Create Bank Update Link
         * @param {string} communityId 
         * @param {CreateOnboardingLinkInput} createOnboardingLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(communityId: string, createOnboardingLinkInput: CreateOnboardingLinkInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingLinkOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(communityId, createOnboardingLinkInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a Stripe Connect Express account for a community.  This creates the Stripe account and returns the account record. The community owner must then complete onboarding via the onboarding link.
         * @summary Create Connect Account
         * @param {string} communityId 
         * @param {CreateConnectAccountInput} createConnectAccountInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectAccountConnectCommunitiesCommunityIdAccountPost(communityId: string, createConnectAccountInput: CreateConnectAccountInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectAccountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectAccountConnectCommunitiesCommunityIdAccountPost(communityId, createConnectAccountInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.createConnectAccountConnectCommunitiesCommunityIdAccountPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create an onboarding link for completing Stripe Connect setup.  The link expires after a short time, so generate it just before redirecting.
         * @summary Create Onboarding Link
         * @param {string} communityId 
         * @param {CreateOnboardingLinkInput} createOnboardingLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(communityId: string, createOnboardingLinkInput: CreateOnboardingLinkInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingLinkOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(communityId, createOnboardingLinkInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Disable a community\'s Connect account (admin only).
         * @summary Disable Connect Account
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectAccountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the Stripe Connect account for a community.
         * @summary Get Connect Account
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectAccountConnectCommunitiesCommunityIdAccountGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectAccountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectAccountConnectCommunitiesCommunityIdAccountGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.getConnectAccountConnectCommunitiesCommunityIdAccountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the Stripe balance for a community\'s Connect account.
         * @summary Get Connect Balance
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectBalanceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.getConnectBalanceConnectCommunitiesCommunityIdBalanceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List payouts for a community\'s Connect account.
         * @summary List Connect Payouts
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {string} [startingAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(communityId: string, limit?: number, startingAfter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectPayoutOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(communityId, limit, startingAfter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List transactions for a community\'s Connect account.
         * @summary List Connect Transactions
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {string} [startingAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(communityId: string, limit?: number, startingAfter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectTransactionOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(communityId, limit, startingAfter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update the payout schedule for a community\'s Connect account.
         * @summary Update Payout Schedule
         * @param {string} communityId 
         * @param {UpdatePayoutScheduleInput} updatePayoutScheduleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(communityId: string, updatePayoutScheduleInput: UpdatePayoutScheduleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(communityId, updatePayoutScheduleInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update the platform fee percentage for a community (admin only).
         * @summary Update Platform Fee
         * @param {string} communityId 
         * @param {UpdatePlatformFeeInput} updatePlatformFeeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(communityId: string, updatePlatformFeeInput: UpdatePlatformFeeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectAccountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(communityId, updatePlatformFeeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeConnectApi.updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StripeConnectApi - factory interface
 * @export
 */
export const StripeConnectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeConnectApiFp(configuration)
    return {
        /**
         * Create a link for updating bank account information.
         * @summary Create Bank Update Link
         * @param {StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(requestParameters: StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingLinkOutput> {
            return localVarFp.createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(requestParameters.communityId, requestParameters.createOnboardingLinkInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe Connect Express account for a community.  This creates the Stripe account and returns the account record. The community owner must then complete onboarding via the onboarding link.
         * @summary Create Connect Account
         * @param {StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectAccountConnectCommunitiesCommunityIdAccountPost(requestParameters: StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectAccountOutput> {
            return localVarFp.createConnectAccountConnectCommunitiesCommunityIdAccountPost(requestParameters.communityId, requestParameters.createConnectAccountInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an onboarding link for completing Stripe Connect setup.  The link expires after a short time, so generate it just before redirecting.
         * @summary Create Onboarding Link
         * @param {StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(requestParameters: StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingLinkOutput> {
            return localVarFp.createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(requestParameters.communityId, requestParameters.createOnboardingLinkInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Disable a community\'s Connect account (admin only).
         * @summary Disable Connect Account
         * @param {StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(requestParameters: StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectAccountOutput> {
            return localVarFp.disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the Stripe Connect account for a community.
         * @summary Get Connect Account
         * @param {StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectAccountConnectCommunitiesCommunityIdAccountGet(requestParameters: StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectAccountOutput> {
            return localVarFp.getConnectAccountConnectCommunitiesCommunityIdAccountGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the Stripe balance for a community\'s Connect account.
         * @summary Get Connect Balance
         * @param {StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(requestParameters: StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectBalanceOutput> {
            return localVarFp.getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * List payouts for a community\'s Connect account.
         * @summary List Connect Payouts
         * @param {StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(requestParameters: StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConnectPayoutOutput>> {
            return localVarFp.listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(requestParameters.communityId, requestParameters.limit, requestParameters.startingAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * List transactions for a community\'s Connect account.
         * @summary List Connect Transactions
         * @param {StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(requestParameters: StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConnectTransactionOutput>> {
            return localVarFp.listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(requestParameters.communityId, requestParameters.limit, requestParameters.startingAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the payout schedule for a community\'s Connect account.
         * @summary Update Payout Schedule
         * @param {StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(requestParameters: StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(requestParameters.communityId, requestParameters.updatePayoutScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the platform fee percentage for a community (admin only).
         * @summary Update Platform Fee
         * @param {StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(requestParameters: StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectAccountOutput> {
            return localVarFp.updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(requestParameters.communityId, requestParameters.updatePlatformFeeInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest
 */
export interface StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateOnboardingLinkInput}
     * @memberof StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost
     */
    readonly createOnboardingLinkInput: CreateOnboardingLinkInput
}

/**
 * Request parameters for createConnectAccountConnectCommunitiesCommunityIdAccountPost operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest
 */
export interface StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateConnectAccountInput}
     * @memberof StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPost
     */
    readonly createConnectAccountInput: CreateConnectAccountInput
}

/**
 * Request parameters for createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest
 */
export interface StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateOnboardingLinkInput}
     * @memberof StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost
     */
    readonly createOnboardingLinkInput: CreateOnboardingLinkInput
}

/**
 * Request parameters for disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest
 */
export interface StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost
     */
    readonly communityId: string
}

/**
 * Request parameters for getConnectAccountConnectCommunitiesCommunityIdAccountGet operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest
 */
export interface StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getConnectBalanceConnectCommunitiesCommunityIdBalanceGet operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest
 */
export interface StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGet
     */
    readonly communityId: string
}

/**
 * Request parameters for listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest
 */
export interface StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet
     */
    readonly communityId: string

    /**
     * 
     * @type {number}
     * @memberof StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet
     */
    readonly startingAfter?: string
}

/**
 * Request parameters for listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest
 */
export interface StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet
     */
    readonly communityId: string

    /**
     * 
     * @type {number}
     * @memberof StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet
     */
    readonly startingAfter?: string
}

/**
 * Request parameters for updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest
 */
export interface StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdatePayoutScheduleInput}
     * @memberof StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost
     */
    readonly updatePayoutScheduleInput: UpdatePayoutScheduleInput
}

/**
 * Request parameters for updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch operation in StripeConnectApi.
 * @export
 * @interface StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest
 */
export interface StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdatePlatformFeeInput}
     * @memberof StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch
     */
    readonly updatePlatformFeeInput: UpdatePlatformFeeInput
}

/**
 * StripeConnectApi - object-oriented interface
 * @export
 * @class StripeConnectApi
 * @extends {BaseAPI}
 */
export class StripeConnectApi extends BaseAPI {
    /**
     * Create a link for updating bank account information.
     * @summary Create Bank Update Link
     * @param {StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(requestParameters: StripeConnectApiCreateBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPostRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).createBankUpdateLinkConnectCommunitiesCommunityIdAccountBankUpdateLinkPost(requestParameters.communityId, requestParameters.createOnboardingLinkInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe Connect Express account for a community.  This creates the Stripe account and returns the account record. The community owner must then complete onboarding via the onboarding link.
     * @summary Create Connect Account
     * @param {StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public createConnectAccountConnectCommunitiesCommunityIdAccountPost(requestParameters: StripeConnectApiCreateConnectAccountConnectCommunitiesCommunityIdAccountPostRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).createConnectAccountConnectCommunitiesCommunityIdAccountPost(requestParameters.communityId, requestParameters.createConnectAccountInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an onboarding link for completing Stripe Connect setup.  The link expires after a short time, so generate it just before redirecting.
     * @summary Create Onboarding Link
     * @param {StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(requestParameters: StripeConnectApiCreateOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPostRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).createOnboardingLinkConnectCommunitiesCommunityIdAccountOnboardingLinkPost(requestParameters.communityId, requestParameters.createOnboardingLinkInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disable a community\'s Connect account (admin only).
     * @summary Disable Connect Account
     * @param {StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(requestParameters: StripeConnectApiDisableConnectAccountConnectCommunitiesCommunityIdAccountDisablePostRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).disableConnectAccountConnectCommunitiesCommunityIdAccountDisablePost(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the Stripe Connect account for a community.
     * @summary Get Connect Account
     * @param {StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public getConnectAccountConnectCommunitiesCommunityIdAccountGet(requestParameters: StripeConnectApiGetConnectAccountConnectCommunitiesCommunityIdAccountGetRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).getConnectAccountConnectCommunitiesCommunityIdAccountGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the Stripe balance for a community\'s Connect account.
     * @summary Get Connect Balance
     * @param {StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(requestParameters: StripeConnectApiGetConnectBalanceConnectCommunitiesCommunityIdBalanceGetRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).getConnectBalanceConnectCommunitiesCommunityIdBalanceGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List payouts for a community\'s Connect account.
     * @summary List Connect Payouts
     * @param {StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(requestParameters: StripeConnectApiListConnectPayoutsConnectCommunitiesCommunityIdPayoutsGetRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).listConnectPayoutsConnectCommunitiesCommunityIdPayoutsGet(requestParameters.communityId, requestParameters.limit, requestParameters.startingAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List transactions for a community\'s Connect account.
     * @summary List Connect Transactions
     * @param {StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(requestParameters: StripeConnectApiListConnectTransactionsConnectCommunitiesCommunityIdTransactionsGetRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).listConnectTransactionsConnectCommunitiesCommunityIdTransactionsGet(requestParameters.communityId, requestParameters.limit, requestParameters.startingAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the payout schedule for a community\'s Connect account.
     * @summary Update Payout Schedule
     * @param {StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(requestParameters: StripeConnectApiUpdatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePostRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).updatePayoutScheduleConnectCommunitiesCommunityIdAccountPayoutSchedulePost(requestParameters.communityId, requestParameters.updatePayoutScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the platform fee percentage for a community (admin only).
     * @summary Update Platform Fee
     * @param {StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectApi
     */
    public updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(requestParameters: StripeConnectApiUpdatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatchRequest, options?: RawAxiosRequestConfig) {
        return StripeConnectApiFp(this.configuration).updatePlatformFeeConnectCommunitiesCommunityIdAccountPlatformFeePatch(requestParameters.communityId, requestParameters.updatePlatformFeeInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeWebhooksApi - axios parameter creator
 * @export
 */
export const StripeWebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle Stripe webhook events.  Primary events handled: - payment_intent.succeeded: Triggers ticket fulfillment - payment_intent.payment_failed: Updates checkout status to failed  Webhook signature is verified to prevent spoofing. In test mode (stripe-signature: test_signature), signature verification is bypassed.
         * @summary Stripe Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookStripeWebhookPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/webhook/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeWebhooksApi - functional programming interface
 * @export
 */
export const StripeWebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeWebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle Stripe webhook events.  Primary events handled: - payment_intent.succeeded: Triggers ticket fulfillment - payment_intent.payment_failed: Updates checkout status to failed  Webhook signature is verified to prevent spoofing. In test mode (stripe-signature: test_signature), signature verification is bypassed.
         * @summary Stripe Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeWebhookStripeWebhookPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeWebhookStripeWebhookPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StripeWebhooksApi.stripeWebhookStripeWebhookPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StripeWebhooksApi - factory interface
 * @export
 */
export const StripeWebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeWebhooksApiFp(configuration)
    return {
        /**
         * Handle Stripe webhook events.  Primary events handled: - payment_intent.succeeded: Triggers ticket fulfillment - payment_intent.payment_failed: Updates checkout status to failed  Webhook signature is verified to prevent spoofing. In test mode (stripe-signature: test_signature), signature verification is bypassed.
         * @summary Stripe Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookStripeWebhookPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.stripeWebhookStripeWebhookPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeWebhooksApi - object-oriented interface
 * @export
 * @class StripeWebhooksApi
 * @extends {BaseAPI}
 */
export class StripeWebhooksApi extends BaseAPI {
    /**
     * Handle Stripe webhook events.  Primary events handled: - payment_intent.succeeded: Triggers ticket fulfillment - payment_intent.payment_failed: Updates checkout status to failed  Webhook signature is verified to prevent spoofing. In test mode (stripe-signature: test_signature), signature verification is bypassed.
     * @summary Stripe Webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeWebhooksApi
     */
    public stripeWebhookStripeWebhookPost(options?: RawAxiosRequestConfig) {
        return StripeWebhooksApiFp(this.configuration).stripeWebhookStripeWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SystemApi.healthCheckHealthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Health check endpoint for AWS load balancers and monitoring
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public healthCheckHealthGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketsApi - axios parameter creator
 * @export
 */
export const TicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ticket type IDs grouped by event ID for multiple events. Returns a dictionary mapping event_id to list of ticket_type_ids.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing list of event IDs to fetch ticket types for     jwt: JWT token for authentication and authorization     db: Database session      Returns:     BulkGetTicketTypesByEventIdOutput with event_ticket_types mapping      Raises:     HTTPException: 400 if no events found, 403 if unauthorized
         * @summary Get ticket types for multiple events
         * @param {BulkGetTicketTypesByEventIdInput} bulkGetTicketTypesByEventIdInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost: async (bulkGetTicketTypesByEventIdInput: BulkGetTicketTypesByEventIdInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetTicketTypesByEventIdInput' is not null or undefined
            assertParamExists('bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost', 'bulkGetTicketTypesByEventIdInput', bulkGetTicketTypesByEventIdInput)
            const localVarPath = `/tickets/bulk/ticket-types-by-event-ids/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetTicketTypesByEventIdInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculate the total cost including taxes for a set of tickets.  This endpoint is used by the frontend to display pricing before checkout. It calculates subtotal, tax amount, and total based on ticket type prices and quantities.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing ticket types and quantities     db: Database session      Returns:     CalculateTotalOutput with line items, subtotal, tax, and total      Raises:     HTTPException: 404 if any ticket type not found
         * @summary Calculate checkout total with taxes
         * @param {CalculateTotalInput} calculateTotalInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTotalTicketsCalculateTotalPost: async (calculateTotalInput: CalculateTotalInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateTotalInput' is not null or undefined
            assertParamExists('calculateTotalTicketsCalculateTotalPost', 'calculateTotalInput', calculateTotalInput)
            const localVarPath = `/tickets/calculate-total/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateTotalInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check In User
         * @param {string} eventId 
         * @param {string} userId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInUserTicketsEventsEventIdUsersUserIdCheckInPost: async (eventId: string, userId: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('checkInUserTicketsEventsEventIdUsersUserIdCheckInPost', 'eventId', eventId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkInUserTicketsEventsEventIdUsersUserIdCheckInPost', 'userId', userId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('checkInUserTicketsEventsEventIdUsersUserIdCheckInPost', 'token', token)
            const localVarPath = `/tickets/events/{event_id}/users/{user_id}/check-in/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count tickets for a list of events.  All events must belong to the same community. User must have OWNER  or EDITOR role in that community (or be a global ADMIN).
         * @summary Count Tickets By Events
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTicketsByEventsTicketsEventsCountPost: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('countTicketsByEventsTicketsEventsCountPost', 'requestBody', requestBody)
            const localVarPath = `/tickets/events/count/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a checkout intent for Payment Sheet.  This is the first step in the Payment Sheet flow: 1. Client calls this endpoint with ticket details 2. Server validates tickets, calculates total, creates PaymentIntent 3. Returns credentials for Payment Sheet initialization 4. Client displays Payment Sheet 5. After payment, webhook triggers fulfillment 6. Client polls /checkout/{checkout_id}/status/ for completion  Headers: - Idempotency-Key: Required. Passed to Stripe to prevent duplicate charges.  Returns:     CheckoutIntentOutput with client_secret, ephemeral_key, customer_id
         * @summary Create Checkout Intent
         * @param {string} idempotencyKey Unique key to ensure idempotent checkout. Required for all requests. Passed to Stripe to prevent duplicate charges. Same key with same payload returns cached result without re-processing.
         * @param {CreateCheckoutIntentInput} createCheckoutIntentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutIntentTicketsCheckoutCreateIntentPost: async (idempotencyKey: string, createCheckoutIntentInput: CreateCheckoutIntentInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('createCheckoutIntentTicketsCheckoutCreateIntentPost', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'createCheckoutIntentInput' is not null or undefined
            assertParamExists('createCheckoutIntentTicketsCheckoutCreateIntentPost', 'createCheckoutIntentInput', createCheckoutIntentInput)
            const localVarPath = `/tickets/checkout/create-intent/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCheckoutIntentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Event Ticket Token
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTicketTokenTicketsEventsEventIdTokenPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('createEventTicketTokenTicketsEventsEventIdTokenPost', 'eventId', eventId)
            const localVarPath = `/tickets/events/{event_id}/token/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new ticket receipt
         * @summary Create ticket receipt
         * @param {CreateTicketReceiptInput} createTicketReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketReceiptTicketsReceiptsPost: async (createTicketReceiptInput: CreateTicketReceiptInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTicketReceiptInput' is not null or undefined
            assertParamExists('createTicketReceiptTicketsReceiptsPost', 'createTicketReceiptInput', createTicketReceiptInput)
            const localVarPath = `/tickets/receipts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketReceiptInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Ticket
         * @param {string} communityId 
         * @param {CreateTicketInput} createTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketTicketsCommunitiesCommunityIdPost: async (communityId: string, createTicketInput: CreateTicketInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createTicketTicketsCommunitiesCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createTicketInput' is not null or undefined
            assertParamExists('createTicketTicketsCommunitiesCommunityIdPost', 'createTicketInput', createTicketInput)
            const localVarPath = `/tickets/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Ticket Type
         * @param {string} communityId 
         * @param {CreateTicketTypeInput} createTicketTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketTypeTicketsCommunitiesCommunityIdTypePost: async (communityId: string, createTicketTypeInput: CreateTicketTypeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createTicketTypeTicketsCommunitiesCommunityIdTypePost', 'communityId', communityId)
            // verify required parameter 'createTicketTypeInput' is not null or undefined
            assertParamExists('createTicketTypeTicketsCommunitiesCommunityIdTypePost', 'createTicketTypeInput', createTicketTypeInput)
            const localVarPath = `/tickets/communities/{community_id}/type/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a ticket by setting is_active=False. Only admins can deactivate tickets. This will also decrease the sold count for the ticket type.
         * @summary Deactivate Ticket
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateTicketTicketsTicketIdDeactivatePatch: async (ticketId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('deactivateTicketTicketsTicketIdDeactivatePatch', 'ticketId', ticketId)
            const localVarPath = `/tickets/{ticket_id}/deactivate/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ticket by ID. Admin-only endpoint.  Args:     request: The HTTP request     ticket_id: The ID of the ticket to delete     current_user: The authenticated admin user\'s JWT payload     db: Database session      Returns:     DeleteTicketOutput: Response with ticket_id of the deleted ticket
         * @summary Delete Ticket
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketTicketsTicketIdDelete: async (ticketId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('deleteTicketTicketsTicketIdDelete', 'ticketId', ticketId)
            const localVarPath = `/tickets/{ticket_id}/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a CSV file with all ticket information for given event_ids and uploads it to S3
         * @summary Export tickets for multiple events as CSV
         * @param {BulkExportTicketsInput} bulkExportTicketsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEventTicketsTicketsEventsExportPost: async (bulkExportTicketsInput: BulkExportTicketsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkExportTicketsInput' is not null or undefined
            assertParamExists('exportEventTicketsTicketsEventsExportPost', 'bulkExportTicketsInput', bulkExportTicketsInput)
            const localVarPath = `/tickets/events/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkExportTicketsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of a checkout.  Mobile clients poll this endpoint after Payment Sheet completes to check if fulfillment (ticket creation) has finished.  Status values: - pending: Waiting for payment confirmation - processing: Payment confirmed, creating tickets - completed: Tickets created successfully - failed: Error occurred  Returns:     CheckoutStatusOutput with current status and ticket_ids (if completed)
         * @summary Get Checkout Status
         * @param {string} checkoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet: async (checkoutId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutId' is not null or undefined
            assertParamExists('getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet', 'checkoutId', checkoutId)
            const localVarPath = `/tickets/checkout/{checkout_id}/status/`
                .replace(`{${"checkout_id"}}`, encodeURIComponent(String(checkoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ticket receipts for a specific user
         * @summary Get receipts by user ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptsByUserIdTicketsReceiptsUsersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getReceiptsByUserIdTicketsReceiptsUsersUserIdGet', 'userId', userId)
            const localVarPath = `/tickets/receipts/users/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a ticket by ID - Admin or ticket owner only
         * @summary Get Ticket By Id
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByIdTicketsTicketIdGet: async (ticketId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getTicketByIdTicketsTicketIdGet', 'ticketId', ticketId)
            const localVarPath = `/tickets/{ticket_id}/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ticket By Token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByTokenTicketsTokenTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getTicketByTokenTicketsTokenTokenGet', 'token', token)
            const localVarPath = `/tickets/token/{token}/`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED: Get all ticket receipts for a specific event and user
         * @summary Get receipts by event and user (DEPRECATED)
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet: async (eventId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet', 'eventId', eventId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet', 'userId', userId)
            const localVarPath = `/tickets/receipts/events/{event_id}/users/{user_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific ticket receipt by ID
         * @summary Get ticket receipt by ID
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptTicketsReceiptsReceiptIdGet: async (receiptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('getTicketReceiptTicketsReceiptsReceiptIdGet', 'receiptId', receiptId)
            const localVarPath = `/tickets/receipts/{receipt_id}/`
                .replace(`{${"receipt_id"}}`, encodeURIComponent(String(receiptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED: Use /receipts_v2/events/{event_id}/ instead. Get all ticket receipts for a specific event
         * @summary Get receipts by event (DEPRECATED)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/receipts/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all receipts for a specific event using the new Receipt model
         * @summary Get receipts by event (V2)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/receipts_v2/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ticket receipts missing ticket_id for a specific event - Admin only
         * @summary Get receipts missing ticket_id by event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/receipts/events/{event_id}/missing-ticket-id/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ticket type summaries for a specific event.
         * @summary Get Ticket Summaries By Event
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet: async (communityId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet', 'communityId', communityId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/communities/{community_id}/summaries/event/{event_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ticket type summary for a specific ticket type.
         * @summary Get Ticket Summary By Ticket Type
         * @param {string} communityId 
         * @param {string} ticketTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet: async (communityId: string, ticketTypeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet', 'communityId', communityId)
            // verify required parameter 'ticketTypeId' is not null or undefined
            assertParamExists('getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet', 'ticketTypeId', ticketTypeId)
            const localVarPath = `/tickets/communities/{community_id}/summaries/ticket-type/{ticket_type_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"ticket_type_id"}}`, encodeURIComponent(String(ticketTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ticket
         * @param {string} ticketId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketTicketsTicketIdCommunitiesCommunityIdGet: async (ticketId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getTicketTicketsTicketIdCommunitiesCommunityIdGet', 'ticketId', ticketId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getTicketTicketsTicketIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/tickets/{ticket_id}/communities/{community_id}/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ticket Types
         * @param {string} eventId 
         * @param {boolean} [isOnSale] 
         * @param {boolean} [isHidden] 
         * @param {boolean} [isWaitlistable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketTypesTicketsTypesEventsEventIdGet: async (eventId: string, isOnSale?: boolean, isHidden?: boolean, isWaitlistable?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketTypesTicketsTypesEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/types/events/{event_id}/`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (isOnSale !== undefined) {
                localVarQueryParameter['is_on_sale'] = isOnSale;
            }

            if (isHidden !== undefined) {
                localVarQueryParameter['is_hidden'] = isHidden;
            }

            if (isWaitlistable !== undefined) {
                localVarQueryParameter['is_waitlistable'] = isWaitlistable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tickets By Event Id
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet: async (communityId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet', 'communityId', communityId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/tickets/communities/{community_id}/events/{event_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsTicketsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tickets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Tickets Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {string} userId 
         * @param {Array<ExperienceType>} [experienceTypes] Types of experiences to filter tickets by. Virtual types include SUNRISE, PRIVATE_ROOM, and TOPIC. In-person type is IN_PERSON.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet: async (temporalRelation: TemporalRelation, userId: string, experienceTypes?: Array<ExperienceType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'temporalRelation' is not null or undefined
            assertParamExists('getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet', 'temporalRelation', temporalRelation)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet', 'userId', userId)
            const localVarPath = `/tickets/temporal/{temporal_relation}/users/{user_id}/`
                .replace(`{${"temporal_relation"}}`, encodeURIComponent(String(temporalRelation)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (experienceTypes) {
                localVarQueryParameter['experience_types'] = experienceTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users Attending Same Event
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet', 'userId', userId)
            const localVarPath = `/tickets/{user_id}/users-at-same-event/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users Overlapping Events
         * @param {string} user1Id 
         * @param {string} user2Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOverlappingEventsTicketsUsersOverlappingEventsGet: async (user1Id: string, user2Id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user1Id' is not null or undefined
            assertParamExists('getUsersOverlappingEventsTicketsUsersOverlappingEventsGet', 'user1Id', user1Id)
            // verify required parameter 'user2Id' is not null or undefined
            assertParamExists('getUsersOverlappingEventsTicketsUsersOverlappingEventsGet', 'user2Id', user2Id)
            const localVarPath = `/tickets/users/overlapping-events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)

            if (user1Id !== undefined) {
                localVarQueryParameter['user_1_id'] = user1Id;
            }

            if (user2Id !== undefined) {
                localVarQueryParameter['user_2_id'] = user2Id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ticket receipts - Admin only
         * @summary List all ticket receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketReceiptsTicketsReceiptsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tickets/receipts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refund a receipt by receipt_id with line item validation.  Each line item must include: - ticket_type_id: Must match a line item on the receipt - Either ticket_id OR promo_id to deactivate  The ticket_type_id on each item is validated against: - The receipt line items - The ticket\'s ticket_type_id (if ticket_id provided) - The promo\'s linked ticket types (if promo_id provided)  Community owners and editors (or global admins) can refund receipts.
         * @summary Refund Receipt
         * @param {string} receiptId 
         * @param {string} communityId 
         * @param {RefundReceiptInput} refundReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost: async (receiptId: string, communityId: string, refundReceiptInput: RefundReceiptInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost', 'receiptId', receiptId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost', 'communityId', communityId)
            // verify required parameter 'refundReceiptInput' is not null or undefined
            assertParamExists('refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost', 'refundReceiptInput', refundReceiptInput)
            const localVarPath = `/tickets/receipts/{receipt_id}/communities/{community_id}/refund/`
                .replace(`{${"receipt_id"}}`, encodeURIComponent(String(receiptId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundReceiptInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refund a ticket by: 1. Getting the ticket receipt 2. Initiating a Stripe refund (if payment_intent_id exists) 3. Updating the receipt status to REFUNDED 4. Deactivating the ticket 5. Decreasing the sold count  Community owners and editors (or global admins) can refund tickets.
         * @summary Refund Ticket
         * @param {string} ticketId 
         * @param {string} communityId 
         * @param {RefundTicketInput} refundTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost: async (ticketId: string, communityId: string, refundTicketInput: RefundTicketInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost', 'ticketId', ticketId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost', 'communityId', communityId)
            // verify required parameter 'refundTicketInput' is not null or undefined
            assertParamExists('refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost', 'refundTicketInput', refundTicketInput)
            const localVarPath = `/tickets/{ticket_id}/communities/{community_id}/refund/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundTicketInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ticket Checkout V2
         * @param {CheckoutInput} checkoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketCheckoutV2TicketsCheckoutV2Post: async (checkoutInput: CheckoutInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutInput' is not null or undefined
            assertParamExists('ticketCheckoutV2TicketsCheckoutV2Post', 'checkoutInput', checkoutInput)
            const localVarPath = `/tickets/checkout_v2/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer Ticket
         * @param {TransferTicketInput} transferTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTicketTicketsTransferPost: async (transferTicketInput: TransferTicketInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferTicketInput' is not null or undefined
            assertParamExists('transferTicketTicketsTransferPost', 'transferTicketInput', transferTicketInput)
            const localVarPath = `/tickets/transfer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferTicketInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Undo Check In User
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost: async (eventId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost', 'eventId', eventId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost', 'userId', userId)
            const localVarPath = `/tickets/events/{event_id}/users/{user_id}/check-in/undo`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove ticket_id link from a receipt (set to NULL) - Admin only
         * @summary Unlink ticket from receipt
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost: async (receiptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost', 'receiptId', receiptId)
            const localVarPath = `/tickets/receipts/{receipt_id}/unlink/`
                .replace(`{${"receipt_id"}}`, encodeURIComponent(String(receiptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only endpoint to update the quantity of a ticket.  Args:     payload: The data for updating ticket quantity     current_user: The authenticated admin user     db: Database session      Returns:     GetTicketOutput: The updated ticket
         * @summary Update Ticket Quantity
         * @param {string} ticketId 
         * @param {UpdateTicketQuantityInput} updateTicketQuantityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketQuantityTicketsTicketIdUpdateQuantityPatch: async (ticketId: string, updateTicketQuantityInput: UpdateTicketQuantityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('updateTicketQuantityTicketsTicketIdUpdateQuantityPatch', 'ticketId', ticketId)
            // verify required parameter 'updateTicketQuantityInput' is not null or undefined
            assertParamExists('updateTicketQuantityTicketsTicketIdUpdateQuantityPatch', 'updateTicketQuantityInput', updateTicketQuantityInput)
            const localVarPath = `/tickets/{ticket_id}/update-quantity/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketQuantityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a ticket receipt
         * @summary Update ticket receipt status
         * @param {string} receiptId 
         * @param {UpdateTicketReceiptStatusInput} updateTicketReceiptStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut: async (receiptId: string, updateTicketReceiptStatusInput: UpdateTicketReceiptStatusInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut', 'receiptId', receiptId)
            // verify required parameter 'updateTicketReceiptStatusInput' is not null or undefined
            assertParamExists('updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut', 'updateTicketReceiptStatusInput', updateTicketReceiptStatusInput)
            const localVarPath = `/tickets/receipts/{receipt_id}/status/`
                .replace(`{${"receipt_id"}}`, encodeURIComponent(String(receiptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketReceiptStatusInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update ticket receipt fields (ticket_id, ticket_type_id, payment_intent_id) - Admin only
         * @summary Update ticket receipt
         * @param {string} receiptId 
         * @param {UpdateTicketReceiptInput} updateTicketReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketReceiptTicketsReceiptsReceiptIdPatch: async (receiptId: string, updateTicketReceiptInput: UpdateTicketReceiptInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('updateTicketReceiptTicketsReceiptsReceiptIdPatch', 'receiptId', receiptId)
            // verify required parameter 'updateTicketReceiptInput' is not null or undefined
            assertParamExists('updateTicketReceiptTicketsReceiptsReceiptIdPatch', 'updateTicketReceiptInput', updateTicketReceiptInput)
            const localVarPath = `/tickets/receipts/{receipt_id}/`
                .replace(`{${"receipt_id"}}`, encodeURIComponent(String(receiptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketReceiptInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update ticket type - Community OWNER/EDITOR only
         * @summary Update ticket type
         * @param {string} ticketId 
         * @param {UpdateTicketInput} updateTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketTicketsTicketIdPatch: async (ticketId: string, updateTicketInput: UpdateTicketInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('updateTicketTicketsTicketIdPatch', 'ticketId', ticketId)
            // verify required parameter 'updateTicketInput' is not null or undefined
            assertParamExists('updateTicketTicketsTicketIdPatch', 'updateTicketInput', updateTicketInput)
            const localVarPath = `/tickets/{ticket_id}/`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ticket type
         * @summary Update Ticket Type
         * @param {string} communityId 
         * @param {string} ticketTypeId 
         * @param {UpdateTicketTypeInput} updateTicketTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut: async (communityId: string, ticketTypeId: string, updateTicketTypeInput: UpdateTicketTypeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut', 'communityId', communityId)
            // verify required parameter 'ticketTypeId' is not null or undefined
            assertParamExists('updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut', 'ticketTypeId', ticketTypeId)
            // verify required parameter 'updateTicketTypeInput' is not null or undefined
            assertParamExists('updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut', 'updateTicketTypeInput', updateTicketTypeInput)
            const localVarPath = `/tickets/communities/{community_id}/type/{ticket_type_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"ticket_type_id"}}`, encodeURIComponent(String(ticketTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication Ticket-Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Ticket-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketsApi - functional programming interface
 * @export
 */
export const TicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ticket type IDs grouped by event ID for multiple events. Returns a dictionary mapping event_id to list of ticket_type_ids.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing list of event IDs to fetch ticket types for     jwt: JWT token for authentication and authorization     db: Database session      Returns:     BulkGetTicketTypesByEventIdOutput with event_ticket_types mapping      Raises:     HTTPException: 400 if no events found, 403 if unauthorized
         * @summary Get ticket types for multiple events
         * @param {BulkGetTicketTypesByEventIdInput} bulkGetTicketTypesByEventIdInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(bulkGetTicketTypesByEventIdInput: BulkGetTicketTypesByEventIdInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkGetTicketTypesByEventIdOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(bulkGetTicketTypesByEventIdInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Calculate the total cost including taxes for a set of tickets.  This endpoint is used by the frontend to display pricing before checkout. It calculates subtotal, tax amount, and total based on ticket type prices and quantities.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing ticket types and quantities     db: Database session      Returns:     CalculateTotalOutput with line items, subtotal, tax, and total      Raises:     HTTPException: 404 if any ticket type not found
         * @summary Calculate checkout total with taxes
         * @param {CalculateTotalInput} calculateTotalInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateTotalTicketsCalculateTotalPost(calculateTotalInput: CalculateTotalInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateTotalOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateTotalTicketsCalculateTotalPost(calculateTotalInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.calculateTotalTicketsCalculateTotalPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Check In User
         * @param {string} eventId 
         * @param {string} userId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(eventId: string, userId: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(eventId, userId, token, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.checkInUserTicketsEventsEventIdUsersUserIdCheckInPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Count tickets for a list of events.  All events must belong to the same community. User must have OWNER  or EDITOR role in that community (or be a global ADMIN).
         * @summary Count Tickets By Events
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTicketsByEventsTicketsEventsCountPost(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTicketCountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTicketsByEventsTicketsEventsCountPost(requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.countTicketsByEventsTicketsEventsCountPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a checkout intent for Payment Sheet.  This is the first step in the Payment Sheet flow: 1. Client calls this endpoint with ticket details 2. Server validates tickets, calculates total, creates PaymentIntent 3. Returns credentials for Payment Sheet initialization 4. Client displays Payment Sheet 5. After payment, webhook triggers fulfillment 6. Client polls /checkout/{checkout_id}/status/ for completion  Headers: - Idempotency-Key: Required. Passed to Stripe to prevent duplicate charges.  Returns:     CheckoutIntentOutput with client_secret, ephemeral_key, customer_id
         * @summary Create Checkout Intent
         * @param {string} idempotencyKey Unique key to ensure idempotent checkout. Required for all requests. Passed to Stripe to prevent duplicate charges. Same key with same payload returns cached result without re-processing.
         * @param {CreateCheckoutIntentInput} createCheckoutIntentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckoutIntentTicketsCheckoutCreateIntentPost(idempotencyKey: string, createCheckoutIntentInput: CreateCheckoutIntentInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutIntentOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutIntentTicketsCheckoutCreateIntentPost(idempotencyKey, createCheckoutIntentInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createCheckoutIntentTicketsCheckoutCreateIntentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Event Ticket Token
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventTicketTokenTicketsEventsEventIdTokenPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTicketTokenOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventTicketTokenTicketsEventsEventIdTokenPost(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createEventTicketTokenTicketsEventsEventIdTokenPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new ticket receipt
         * @summary Create ticket receipt
         * @param {CreateTicketReceiptInput} createTicketReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketReceiptTicketsReceiptsPost(createTicketReceiptInput: CreateTicketReceiptInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTicketReceiptOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketReceiptTicketsReceiptsPost(createTicketReceiptInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicketReceiptTicketsReceiptsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Ticket
         * @param {string} communityId 
         * @param {CreateTicketInput} createTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketTicketsCommunitiesCommunityIdPost(communityId: string, createTicketInput: CreateTicketInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketTicketsCommunitiesCommunityIdPost(communityId, createTicketInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicketTicketsCommunitiesCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Ticket Type
         * @param {string} communityId 
         * @param {CreateTicketTypeInput} createTicketTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketTypeTicketsCommunitiesCommunityIdTypePost(communityId: string, createTicketTypeInput: CreateTicketTypeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketTypeTicketsCommunitiesCommunityIdTypePost(communityId, createTicketTypeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicketTypeTicketsCommunitiesCommunityIdTypePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deactivate a ticket by setting is_active=False. Only admins can deactivate tickets. This will also decrease the sold count for the ticket type.
         * @summary Deactivate Ticket
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateTicketTicketsTicketIdDeactivatePatch(ticketId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivateTicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateTicketTicketsTicketIdDeactivatePatch(ticketId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.deactivateTicketTicketsTicketIdDeactivatePatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a ticket by ID. Admin-only endpoint.  Args:     request: The HTTP request     ticket_id: The ID of the ticket to delete     current_user: The authenticated admin user\'s JWT payload     db: Database session      Returns:     DeleteTicketOutput: Response with ticket_id of the deleted ticket
         * @summary Delete Ticket
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketTicketsTicketIdDelete(ticketId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketTicketsTicketIdDelete(ticketId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.deleteTicketTicketsTicketIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Generates a CSV file with all ticket information for given event_ids and uploads it to S3
         * @summary Export tickets for multiple events as CSV
         * @param {BulkExportTicketsInput} bulkExportTicketsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEventTicketsTicketsEventsExportPost(bulkExportTicketsInput: BulkExportTicketsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEventTicketsTicketsEventsExportPost(bulkExportTicketsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.exportEventTicketsTicketsEventsExportPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the status of a checkout.  Mobile clients poll this endpoint after Payment Sheet completes to check if fulfillment (ticket creation) has finished.  Status values: - pending: Waiting for payment confirmation - processing: Payment confirmed, creating tickets - completed: Tickets created successfully - failed: Error occurred  Returns:     CheckoutStatusOutput with current status and ticket_ids (if completed)
         * @summary Get Checkout Status
         * @param {string} checkoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(checkoutId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutStatusOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(checkoutId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all ticket receipts for a specific user
         * @summary Get receipts by user ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getReceiptsByUserIdTicketsReceiptsUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a ticket by ID - Admin or ticket owner only
         * @summary Get Ticket By Id
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketByIdTicketsTicketIdGet(ticketId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketByIdTicketsTicketIdGet(ticketId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketByIdTicketsTicketIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ticket By Token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketByTokenTicketsTokenTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketByTokenTicketsTokenTokenGet(token, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketByTokenTicketsTokenTokenGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * DEPRECATED: Get all ticket receipts for a specific event and user
         * @summary Get receipts by event and user (DEPRECATED)
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(eventId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(eventId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a specific ticket receipt by ID
         * @summary Get ticket receipt by ID
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketReceiptTicketsReceiptsReceiptIdGet(receiptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketReceiptOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReceiptTicketsReceiptsReceiptIdGet(receiptId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketReceiptTicketsReceiptsReceiptIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * DEPRECATED: Use /receipts_v2/events/{event_id}/ instead. Get all ticket receipts for a specific event
         * @summary Get receipts by event (DEPRECATED)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all receipts for a specific event using the new Receipt model
         * @summary Get receipts by event (V2)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get ticket receipts missing ticket_id for a specific event - Admin only
         * @summary Get receipts missing ticket_id by event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all ticket type summaries for a specific event.
         * @summary Get Ticket Summaries By Event
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(communityId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTicketSummariesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(communityId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get ticket type summary for a specific ticket type.
         * @summary Get Ticket Summary By Ticket Type
         * @param {string} communityId 
         * @param {string} ticketTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(communityId: string, ticketTypeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketTypeSummaryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(communityId, ticketTypeId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ticket
         * @param {string} ticketId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketTicketsTicketIdCommunitiesCommunityIdGet(ticketId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketTicketsTicketIdCommunitiesCommunityIdGet(ticketId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketTicketsTicketIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ticket Types
         * @param {string} eventId 
         * @param {boolean} [isOnSale] 
         * @param {boolean} [isHidden] 
         * @param {boolean} [isWaitlistable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketTypesTicketsTypesEventsEventIdGet(eventId: string, isOnSale?: boolean, isHidden?: boolean, isWaitlistable?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketTypesTicketsTypesEventsEventIdGet(eventId, isOnSale, isHidden, isWaitlistable, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketTypesTicketsTypesEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tickets By Event Id
         * @param {string} communityId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(communityId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTicketOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(communityId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsTicketsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ticket>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsTicketsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketsTicketsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Tickets Temporal
         * @param {TemporalRelation} temporalRelation 
         * @param {string} userId 
         * @param {Array<ExperienceType>} [experienceTypes] Types of experiences to filter tickets by. Virtual types include SUNRISE, PRIVATE_ROOM, and TOPIC. In-person type is IN_PERSON.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(temporalRelation: TemporalRelation, userId: string, experienceTypes?: Array<ExperienceType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTicketOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(temporalRelation, userId, experienceTypes, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users Attending Same Event
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsersAtSameEventOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users Overlapping Events
         * @param {string} user1Id 
         * @param {string} user2Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(user1Id: string, user2Id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(user1Id, user2Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getUsersOverlappingEventsTicketsUsersOverlappingEventsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all ticket receipts - Admin only
         * @summary List all ticket receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTicketReceiptsTicketsReceiptsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReceiptOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTicketReceiptsTicketsReceiptsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.listTicketReceiptsTicketsReceiptsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Refund a receipt by receipt_id with line item validation.  Each line item must include: - ticket_type_id: Must match a line item on the receipt - Either ticket_id OR promo_id to deactivate  The ticket_type_id on each item is validated against: - The receipt line items - The ticket\'s ticket_type_id (if ticket_id provided) - The promo\'s linked ticket types (if promo_id provided)  Community owners and editors (or global admins) can refund receipts.
         * @summary Refund Receipt
         * @param {string} receiptId 
         * @param {string} communityId 
         * @param {RefundReceiptInput} refundReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(receiptId: string, communityId: string, refundReceiptInput: RefundReceiptInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundReceiptOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(receiptId, communityId, refundReceiptInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Refund a ticket by: 1. Getting the ticket receipt 2. Initiating a Stripe refund (if payment_intent_id exists) 3. Updating the receipt status to REFUNDED 4. Deactivating the ticket 5. Decreasing the sold count  Community owners and editors (or global admins) can refund tickets.
         * @summary Refund Ticket
         * @param {string} ticketId 
         * @param {string} communityId 
         * @param {RefundTicketInput} refundTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(ticketId: string, communityId: string, refundTicketInput: RefundTicketInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundTicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(ticketId, communityId, refundTicketInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Ticket Checkout V2
         * @param {CheckoutInput} checkoutInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ticketCheckoutV2TicketsCheckoutV2Post(checkoutInput: CheckoutInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ticketCheckoutV2TicketsCheckoutV2Post(checkoutInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.ticketCheckoutV2TicketsCheckoutV2Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Transfer Ticket
         * @param {TransferTicketInput} transferTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferTicketTicketsTransferPost(transferTicketInput: TransferTicketInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketTransferOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferTicketTicketsTransferPost(transferTicketInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.transferTicketTicketsTransferPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Undo Check In User
         * @param {string} eventId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(eventId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(eventId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove ticket_id link from a receipt (set to NULL) - Admin only
         * @summary Unlink ticket from receipt
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(receiptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTicketReceiptOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(receiptId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Admin-only endpoint to update the quantity of a ticket.  Args:     payload: The data for updating ticket quantity     current_user: The authenticated admin user     db: Database session      Returns:     GetTicketOutput: The updated ticket
         * @summary Update Ticket Quantity
         * @param {string} ticketId 
         * @param {UpdateTicketQuantityInput} updateTicketQuantityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(ticketId: string, updateTicketQuantityInput: UpdateTicketQuantityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTicketQuantityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(ticketId, updateTicketQuantityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketQuantityTicketsTicketIdUpdateQuantityPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update the status of a ticket receipt
         * @summary Update ticket receipt status
         * @param {string} receiptId 
         * @param {UpdateTicketReceiptStatusInput} updateTicketReceiptStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(receiptId: string, updateTicketReceiptStatusInput: UpdateTicketReceiptStatusInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTicketReceiptStatusOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(receiptId, updateTicketReceiptStatusInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update ticket receipt fields (ticket_id, ticket_type_id, payment_intent_id) - Admin only
         * @summary Update ticket receipt
         * @param {string} receiptId 
         * @param {UpdateTicketReceiptInput} updateTicketReceiptInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketReceiptTicketsReceiptsReceiptIdPatch(receiptId: string, updateTicketReceiptInput: UpdateTicketReceiptInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTicketReceiptOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketReceiptTicketsReceiptsReceiptIdPatch(receiptId, updateTicketReceiptInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketReceiptTicketsReceiptsReceiptIdPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update ticket type - Community OWNER/EDITOR only
         * @summary Update ticket type
         * @param {string} ticketId 
         * @param {UpdateTicketInput} updateTicketInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketTicketsTicketIdPatch(ticketId: string, updateTicketInput: UpdateTicketInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketTicketsTicketIdPatch(ticketId, updateTicketInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketTicketsTicketIdPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a ticket type
         * @summary Update Ticket Type
         * @param {string} communityId 
         * @param {string} ticketTypeId 
         * @param {UpdateTicketTypeInput} updateTicketTypeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(communityId: string, ticketTypeId: string, updateTicketTypeInput: UpdateTicketTypeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketTypeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(communityId, ticketTypeId, updateTicketTypeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TicketsApi - factory interface
 * @export
 */
export const TicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketsApiFp(configuration)
    return {
        /**
         * Get ticket type IDs grouped by event ID for multiple events. Returns a dictionary mapping event_id to list of ticket_type_ids.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing list of event IDs to fetch ticket types for     jwt: JWT token for authentication and authorization     db: Database session      Returns:     BulkGetTicketTypesByEventIdOutput with event_ticket_types mapping      Raises:     HTTPException: 400 if no events found, 403 if unauthorized
         * @summary Get ticket types for multiple events
         * @param {TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(requestParameters: TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkGetTicketTypesByEventIdOutput> {
            return localVarFp.bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(requestParameters.bulkGetTicketTypesByEventIdInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculate the total cost including taxes for a set of tickets.  This endpoint is used by the frontend to display pricing before checkout. It calculates subtotal, tax amount, and total based on ticket type prices and quantities.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing ticket types and quantities     db: Database session      Returns:     CalculateTotalOutput with line items, subtotal, tax, and total      Raises:     HTTPException: 404 if any ticket type not found
         * @summary Calculate checkout total with taxes
         * @param {TicketsApiCalculateTotalTicketsCalculateTotalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTotalTicketsCalculateTotalPost(requestParameters: TicketsApiCalculateTotalTicketsCalculateTotalPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateTotalOutput> {
            return localVarFp.calculateTotalTicketsCalculateTotalPost(requestParameters.calculateTotalInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check In User
         * @param {TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(requestParameters: TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(requestParameters.eventId, requestParameters.userId, requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * Count tickets for a list of events.  All events must belong to the same community. User must have OWNER  or EDITOR role in that community (or be a global ADMIN).
         * @summary Count Tickets By Events
         * @param {TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTicketsByEventsTicketsEventsCountPost(requestParameters: TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventTicketCountsResponse> {
            return localVarFp.countTicketsByEventsTicketsEventsCountPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a checkout intent for Payment Sheet.  This is the first step in the Payment Sheet flow: 1. Client calls this endpoint with ticket details 2. Server validates tickets, calculates total, creates PaymentIntent 3. Returns credentials for Payment Sheet initialization 4. Client displays Payment Sheet 5. After payment, webhook triggers fulfillment 6. Client polls /checkout/{checkout_id}/status/ for completion  Headers: - Idempotency-Key: Required. Passed to Stripe to prevent duplicate charges.  Returns:     CheckoutIntentOutput with client_secret, ephemeral_key, customer_id
         * @summary Create Checkout Intent
         * @param {TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutIntentTicketsCheckoutCreateIntentPost(requestParameters: TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutIntentOutput> {
            return localVarFp.createCheckoutIntentTicketsCheckoutCreateIntentPost(requestParameters.idempotencyKey, requestParameters.createCheckoutIntentInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Event Ticket Token
         * @param {TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTicketTokenTicketsEventsEventIdTokenPost(requestParameters: TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTicketTokenOutput> {
            return localVarFp.createEventTicketTokenTicketsEventsEventIdTokenPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new ticket receipt
         * @summary Create ticket receipt
         * @param {TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketReceiptTicketsReceiptsPost(requestParameters: TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTicketReceiptOutput> {
            return localVarFp.createTicketReceiptTicketsReceiptsPost(requestParameters.createTicketReceiptInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Ticket
         * @param {TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketTicketsCommunitiesCommunityIdPost(requestParameters: TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Ticket> {
            return localVarFp.createTicketTicketsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createTicketInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Ticket Type
         * @param {TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketTypeTicketsCommunitiesCommunityIdTypePost(requestParameters: TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketType> {
            return localVarFp.createTicketTypeTicketsCommunitiesCommunityIdTypePost(requestParameters.communityId, requestParameters.createTicketTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a ticket by setting is_active=False. Only admins can deactivate tickets. This will also decrease the sold count for the ticket type.
         * @summary Deactivate Ticket
         * @param {TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateTicketTicketsTicketIdDeactivatePatch(requestParameters: TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeactivateTicketOutput> {
            return localVarFp.deactivateTicketTicketsTicketIdDeactivatePatch(requestParameters.ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ticket by ID. Admin-only endpoint.  Args:     request: The HTTP request     ticket_id: The ID of the ticket to delete     current_user: The authenticated admin user\'s JWT payload     db: Database session      Returns:     DeleteTicketOutput: Response with ticket_id of the deleted ticket
         * @summary Delete Ticket
         * @param {TicketsApiDeleteTicketTicketsTicketIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketTicketsTicketIdDelete(requestParameters: TicketsApiDeleteTicketTicketsTicketIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTicketOutput> {
            return localVarFp.deleteTicketTicketsTicketIdDelete(requestParameters.ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a CSV file with all ticket information for given event_ids and uploads it to S3
         * @summary Export tickets for multiple events as CSV
         * @param {TicketsApiExportEventTicketsTicketsEventsExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEventTicketsTicketsEventsExportPost(requestParameters: TicketsApiExportEventTicketsTicketsEventsExportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketExportResponse> {
            return localVarFp.exportEventTicketsTicketsEventsExportPost(requestParameters.bulkExportTicketsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of a checkout.  Mobile clients poll this endpoint after Payment Sheet completes to check if fulfillment (ticket creation) has finished.  Status values: - pending: Waiting for payment confirmation - processing: Payment confirmed, creating tickets - completed: Tickets created successfully - failed: Error occurred  Returns:     CheckoutStatusOutput with current status and ticket_ids (if completed)
         * @summary Get Checkout Status
         * @param {TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(requestParameters: TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutStatusOutput> {
            return localVarFp.getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(requestParameters.checkoutId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ticket receipts for a specific user
         * @summary Get receipts by user ID
         * @param {TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(requestParameters: TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketReceiptOutput>> {
            return localVarFp.getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a ticket by ID - Admin or ticket owner only
         * @summary Get Ticket By Id
         * @param {TicketsApiGetTicketByIdTicketsTicketIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByIdTicketsTicketIdGet(requestParameters: TicketsApiGetTicketByIdTicketsTicketIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Ticket> {
            return localVarFp.getTicketByIdTicketsTicketIdGet(requestParameters.ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ticket By Token
         * @param {TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByTokenTicketsTokenTokenGet(requestParameters: TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Ticket> {
            return localVarFp.getTicketByTokenTicketsTokenTokenGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED: Get all ticket receipts for a specific event and user
         * @summary Get receipts by event and user (DEPRECATED)
         * @param {TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(requestParameters: TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketReceiptOutput>> {
            return localVarFp.getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(requestParameters.eventId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific ticket receipt by ID
         * @summary Get ticket receipt by ID
         * @param {TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptTicketsReceiptsReceiptIdGet(requestParameters: TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketReceiptOutput> {
            return localVarFp.getTicketReceiptTicketsReceiptsReceiptIdGet(requestParameters.receiptId, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED: Use /receipts_v2/events/{event_id}/ instead. Get all ticket receipts for a specific event
         * @summary Get receipts by event (DEPRECATED)
         * @param {TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(requestParameters: TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketReceiptOutput>> {
            return localVarFp.getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all receipts for a specific event using the new Receipt model
         * @summary Get receipts by event (V2)
         * @param {TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(requestParameters: TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReceiptOutput>> {
            return localVarFp.getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ticket receipts missing ticket_id for a specific event - Admin only
         * @summary Get receipts missing ticket_id by event
         * @param {TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(requestParameters: TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketReceiptOutput>> {
            return localVarFp.getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ticket type summaries for a specific event.
         * @summary Get Ticket Summaries By Event
         * @param {TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(requestParameters: TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventTicketSummariesOutput> {
            return localVarFp.getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(requestParameters.communityId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ticket type summary for a specific ticket type.
         * @summary Get Ticket Summary By Ticket Type
         * @param {TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(requestParameters: TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketTypeSummaryOutput> {
            return localVarFp.getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(requestParameters.communityId, requestParameters.ticketTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ticket
         * @param {TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketTicketsTicketIdCommunitiesCommunityIdGet(requestParameters: TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicTicket> {
            return localVarFp.getTicketTicketsTicketIdCommunitiesCommunityIdGet(requestParameters.ticketId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ticket Types
         * @param {TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketTypesTicketsTypesEventsEventIdGet(requestParameters: TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketType>> {
            return localVarFp.getTicketTypesTicketsTypesEventsEventIdGet(requestParameters.eventId, requestParameters.isOnSale, requestParameters.isHidden, requestParameters.isWaitlistable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tickets By Event Id
         * @param {TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(requestParameters: TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTicketOutput>> {
            return localVarFp.getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(requestParameters.communityId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsTicketsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Ticket>> {
            return localVarFp.getTicketsTicketsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Tickets Temporal
         * @param {TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(requestParameters: TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTicketOutput>> {
            return localVarFp.getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(requestParameters.temporalRelation, requestParameters.userId, requestParameters.experienceTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users Attending Same Event
         * @param {TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(requestParameters: TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UsersAtSameEventOutput>> {
            return localVarFp.getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users Overlapping Events
         * @param {TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(requestParameters: TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(requestParameters.user1Id, requestParameters.user2Id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ticket receipts - Admin only
         * @summary List all ticket receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketReceiptsTicketsReceiptsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TicketReceiptOutput>> {
            return localVarFp.listTicketReceiptsTicketsReceiptsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Refund a receipt by receipt_id with line item validation.  Each line item must include: - ticket_type_id: Must match a line item on the receipt - Either ticket_id OR promo_id to deactivate  The ticket_type_id on each item is validated against: - The receipt line items - The ticket\'s ticket_type_id (if ticket_id provided) - The promo\'s linked ticket types (if promo_id provided)  Community owners and editors (or global admins) can refund receipts.
         * @summary Refund Receipt
         * @param {TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(requestParameters: TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundReceiptOutput> {
            return localVarFp.refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(requestParameters.receiptId, requestParameters.communityId, requestParameters.refundReceiptInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Refund a ticket by: 1. Getting the ticket receipt 2. Initiating a Stripe refund (if payment_intent_id exists) 3. Updating the receipt status to REFUNDED 4. Deactivating the ticket 5. Decreasing the sold count  Community owners and editors (or global admins) can refund tickets.
         * @summary Refund Ticket
         * @param {TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(requestParameters: TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundTicketOutput> {
            return localVarFp.refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(requestParameters.ticketId, requestParameters.communityId, requestParameters.refundTicketInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ticket Checkout V2
         * @param {TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketCheckoutV2TicketsCheckoutV2Post(requestParameters: TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.ticketCheckoutV2TicketsCheckoutV2Post(requestParameters.checkoutInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer Ticket
         * @param {TicketsApiTransferTicketTicketsTransferPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTicketTicketsTransferPost(requestParameters: TicketsApiTransferTicketTicketsTransferPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketTransferOutput> {
            return localVarFp.transferTicketTicketsTransferPost(requestParameters.transferTicketInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Undo Check In User
         * @param {TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(requestParameters: TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(requestParameters.eventId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove ticket_id link from a receipt (set to NULL) - Admin only
         * @summary Unlink ticket from receipt
         * @param {TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(requestParameters: TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTicketReceiptOutput> {
            return localVarFp.unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(requestParameters.receiptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only endpoint to update the quantity of a ticket.  Args:     payload: The data for updating ticket quantity     current_user: The authenticated admin user     db: Database session      Returns:     GetTicketOutput: The updated ticket
         * @summary Update Ticket Quantity
         * @param {TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(requestParameters: TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTicketQuantityOutput> {
            return localVarFp.updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(requestParameters.ticketId, requestParameters.updateTicketQuantityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a ticket receipt
         * @summary Update ticket receipt status
         * @param {TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(requestParameters: TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTicketReceiptStatusOutput> {
            return localVarFp.updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(requestParameters.receiptId, requestParameters.updateTicketReceiptStatusInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update ticket receipt fields (ticket_id, ticket_type_id, payment_intent_id) - Admin only
         * @summary Update ticket receipt
         * @param {TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketReceiptTicketsReceiptsReceiptIdPatch(requestParameters: TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTicketReceiptOutput> {
            return localVarFp.updateTicketReceiptTicketsReceiptsReceiptIdPatch(requestParameters.receiptId, requestParameters.updateTicketReceiptInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update ticket type - Community OWNER/EDITOR only
         * @summary Update ticket type
         * @param {TicketsApiUpdateTicketTicketsTicketIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketTicketsTicketIdPatch(requestParameters: TicketsApiUpdateTicketTicketsTicketIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTicketOutput> {
            return localVarFp.updateTicketTicketsTicketIdPatch(requestParameters.ticketId, requestParameters.updateTicketInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ticket type
         * @summary Update Ticket Type
         * @param {TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(requestParameters: TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TicketTypeOutput> {
            return localVarFp.updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(requestParameters.communityId, requestParameters.ticketTypeId, requestParameters.updateTicketTypeInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost operation in TicketsApi.
 * @export
 * @interface TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest
 */
export interface TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest {
    /**
     * 
     * @type {BulkGetTicketTypesByEventIdInput}
     * @memberof TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost
     */
    readonly bulkGetTicketTypesByEventIdInput: BulkGetTicketTypesByEventIdInput
}

/**
 * Request parameters for calculateTotalTicketsCalculateTotalPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCalculateTotalTicketsCalculateTotalPostRequest
 */
export interface TicketsApiCalculateTotalTicketsCalculateTotalPostRequest {
    /**
     * 
     * @type {CalculateTotalInput}
     * @memberof TicketsApiCalculateTotalTicketsCalculateTotalPost
     */
    readonly calculateTotalInput: CalculateTotalInput
}

/**
 * Request parameters for checkInUserTicketsEventsEventIdUsersUserIdCheckInPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest
 */
export interface TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPost
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPost
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPost
     */
    readonly token: string
}

/**
 * Request parameters for countTicketsByEventsTicketsEventsCountPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest
 */
export interface TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketsApiCountTicketsByEventsTicketsEventsCountPost
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for createCheckoutIntentTicketsCheckoutCreateIntentPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest
 */
export interface TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest {
    /**
     * Unique key to ensure idempotent checkout. Required for all requests. Passed to Stripe to prevent duplicate charges. Same key with same payload returns cached result without re-processing.
     * @type {string}
     * @memberof TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPost
     */
    readonly idempotencyKey: string

    /**
     * 
     * @type {CreateCheckoutIntentInput}
     * @memberof TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPost
     */
    readonly createCheckoutIntentInput: CreateCheckoutIntentInput
}

/**
 * Request parameters for createEventTicketTokenTicketsEventsEventIdTokenPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest
 */
export interface TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPost
     */
    readonly eventId: string
}

/**
 * Request parameters for createTicketReceiptTicketsReceiptsPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest
 */
export interface TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest {
    /**
     * 
     * @type {CreateTicketReceiptInput}
     * @memberof TicketsApiCreateTicketReceiptTicketsReceiptsPost
     */
    readonly createTicketReceiptInput: CreateTicketReceiptInput
}

/**
 * Request parameters for createTicketTicketsCommunitiesCommunityIdPost operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest
 */
export interface TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicketTicketsCommunitiesCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateTicketInput}
     * @memberof TicketsApiCreateTicketTicketsCommunitiesCommunityIdPost
     */
    readonly createTicketInput: CreateTicketInput
}

/**
 * Request parameters for createTicketTypeTicketsCommunitiesCommunityIdTypePost operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest
 */
export interface TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateTicketTypeInput}
     * @memberof TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePost
     */
    readonly createTicketTypeInput: CreateTicketTypeInput
}

/**
 * Request parameters for deactivateTicketTicketsTicketIdDeactivatePatch operation in TicketsApi.
 * @export
 * @interface TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest
 */
export interface TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatch
     */
    readonly ticketId: string
}

/**
 * Request parameters for deleteTicketTicketsTicketIdDelete operation in TicketsApi.
 * @export
 * @interface TicketsApiDeleteTicketTicketsTicketIdDeleteRequest
 */
export interface TicketsApiDeleteTicketTicketsTicketIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicketTicketsTicketIdDelete
     */
    readonly ticketId: string
}

/**
 * Request parameters for exportEventTicketsTicketsEventsExportPost operation in TicketsApi.
 * @export
 * @interface TicketsApiExportEventTicketsTicketsEventsExportPostRequest
 */
export interface TicketsApiExportEventTicketsTicketsEventsExportPostRequest {
    /**
     * 
     * @type {BulkExportTicketsInput}
     * @memberof TicketsApiExportEventTicketsTicketsEventsExportPost
     */
    readonly bulkExportTicketsInput: BulkExportTicketsInput
}

/**
 * Request parameters for getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest
 */
export interface TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGet
     */
    readonly checkoutId: string
}

/**
 * Request parameters for getReceiptsByUserIdTicketsReceiptsUsersUserIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest
 */
export interface TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getTicketByIdTicketsTicketIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketByIdTicketsTicketIdGetRequest
 */
export interface TicketsApiGetTicketByIdTicketsTicketIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketByIdTicketsTicketIdGet
     */
    readonly ticketId: string
}

/**
 * Request parameters for getTicketByTokenTicketsTokenTokenGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest
 */
export interface TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketByTokenTicketsTokenTokenGet
     */
    readonly token: string
}

/**
 * Request parameters for getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest
 */
export interface TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getTicketReceiptTicketsReceiptsReceiptIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest
 */
export interface TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGet
     */
    readonly receiptId: string
}

/**
 * Request parameters for getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest
 */
export interface TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest
 */
export interface TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest
 */
export interface TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest
 */
export interface TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest
 */
export interface TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet
     */
    readonly ticketTypeId: string
}

/**
 * Request parameters for getTicketTicketsTicketIdCommunitiesCommunityIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest
 */
export interface TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGet
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getTicketTypesTicketsTypesEventsEventIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest
 */
export interface TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketTypesTicketsTypesEventsEventIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {boolean}
     * @memberof TicketsApiGetTicketTypesTicketsTypesEventsEventIdGet
     */
    readonly isOnSale?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TicketsApiGetTicketTypesTicketsTypesEventsEventIdGet
     */
    readonly isHidden?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TicketsApiGetTicketTypesTicketsTypesEventsEventIdGet
     */
    readonly isWaitlistable?: boolean
}

/**
 * Request parameters for getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest
 */
export interface TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest
 */
export interface TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest {
    /**
     * 
     * @type {TemporalRelation}
     * @memberof TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet
     */
    readonly temporalRelation: TemporalRelation

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet
     */
    readonly userId: string

    /**
     * Types of experiences to filter tickets by. Virtual types include SUNRISE, PRIVATE_ROOM, and TOPIC. In-person type is IN_PERSON.
     * @type {Array<ExperienceType>}
     * @memberof TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet
     */
    readonly experienceTypes?: Array<ExperienceType>
}

/**
 * Request parameters for getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest
 */
export interface TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet
     */
    readonly userId: string
}

/**
 * Request parameters for getUsersOverlappingEventsTicketsUsersOverlappingEventsGet operation in TicketsApi.
 * @export
 * @interface TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest
 */
export interface TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGet
     */
    readonly user1Id: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGet
     */
    readonly user2Id: string
}

/**
 * Request parameters for refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost operation in TicketsApi.
 * @export
 * @interface TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest
 */
export interface TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost
     */
    readonly receiptId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost
     */
    readonly communityId: string

    /**
     * 
     * @type {RefundReceiptInput}
     * @memberof TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost
     */
    readonly refundReceiptInput: RefundReceiptInput
}

/**
 * Request parameters for refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost operation in TicketsApi.
 * @export
 * @interface TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest
 */
export interface TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost
     */
    readonly communityId: string

    /**
     * 
     * @type {RefundTicketInput}
     * @memberof TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost
     */
    readonly refundTicketInput: RefundTicketInput
}

/**
 * Request parameters for ticketCheckoutV2TicketsCheckoutV2Post operation in TicketsApi.
 * @export
 * @interface TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest
 */
export interface TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest {
    /**
     * 
     * @type {CheckoutInput}
     * @memberof TicketsApiTicketCheckoutV2TicketsCheckoutV2Post
     */
    readonly checkoutInput: CheckoutInput
}

/**
 * Request parameters for transferTicketTicketsTransferPost operation in TicketsApi.
 * @export
 * @interface TicketsApiTransferTicketTicketsTransferPostRequest
 */
export interface TicketsApiTransferTicketTicketsTransferPostRequest {
    /**
     * 
     * @type {TransferTicketInput}
     * @memberof TicketsApiTransferTicketTicketsTransferPost
     */
    readonly transferTicketInput: TransferTicketInput
}

/**
 * Request parameters for undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost operation in TicketsApi.
 * @export
 * @interface TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest
 */
export interface TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost
     */
    readonly userId: string
}

/**
 * Request parameters for unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost operation in TicketsApi.
 * @export
 * @interface TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest
 */
export interface TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost
     */
    readonly receiptId: string
}

/**
 * Request parameters for updateTicketQuantityTicketsTicketIdUpdateQuantityPatch operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest
 */
export interface TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatch
     */
    readonly ticketId: string

    /**
     * 
     * @type {UpdateTicketQuantityInput}
     * @memberof TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatch
     */
    readonly updateTicketQuantityInput: UpdateTicketQuantityInput
}

/**
 * Request parameters for updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest
 */
export interface TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut
     */
    readonly receiptId: string

    /**
     * 
     * @type {UpdateTicketReceiptStatusInput}
     * @memberof TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut
     */
    readonly updateTicketReceiptStatusInput: UpdateTicketReceiptStatusInput
}

/**
 * Request parameters for updateTicketReceiptTicketsReceiptsReceiptIdPatch operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest
 */
export interface TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatch
     */
    readonly receiptId: string

    /**
     * 
     * @type {UpdateTicketReceiptInput}
     * @memberof TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatch
     */
    readonly updateTicketReceiptInput: UpdateTicketReceiptInput
}

/**
 * Request parameters for updateTicketTicketsTicketIdPatch operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketTicketsTicketIdPatchRequest
 */
export interface TicketsApiUpdateTicketTicketsTicketIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketTicketsTicketIdPatch
     */
    readonly ticketId: string

    /**
     * 
     * @type {UpdateTicketInput}
     * @memberof TicketsApiUpdateTicketTicketsTicketIdPatch
     */
    readonly updateTicketInput: UpdateTicketInput
}

/**
 * Request parameters for updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest
 */
export interface TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut
     */
    readonly ticketTypeId: string

    /**
     * 
     * @type {UpdateTicketTypeInput}
     * @memberof TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut
     */
    readonly updateTicketTypeInput: UpdateTicketTypeInput
}

/**
 * TicketsApi - object-oriented interface
 * @export
 * @class TicketsApi
 * @extends {BaseAPI}
 */
export class TicketsApi extends BaseAPI {
    /**
     * Get ticket type IDs grouped by event ID for multiple events. Returns a dictionary mapping event_id to list of ticket_type_ids.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing list of event IDs to fetch ticket types for     jwt: JWT token for authentication and authorization     db: Database session      Returns:     BulkGetTicketTypesByEventIdOutput with event_ticket_types mapping      Raises:     HTTPException: 400 if no events found, 403 if unauthorized
     * @summary Get ticket types for multiple events
     * @param {TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(requestParameters: TicketsApiBulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).bulkGetTicketTypesByEventIdsTicketsBulkTicketTypesByEventIdsPost(requestParameters.bulkGetTicketTypesByEventIdInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculate the total cost including taxes for a set of tickets.  This endpoint is used by the frontend to display pricing before checkout. It calculates subtotal, tax amount, and total based on ticket type prices and quantities.  Args:     request: HTTP request object (for rate limiting)     payload: Input containing ticket types and quantities     db: Database session      Returns:     CalculateTotalOutput with line items, subtotal, tax, and total      Raises:     HTTPException: 404 if any ticket type not found
     * @summary Calculate checkout total with taxes
     * @param {TicketsApiCalculateTotalTicketsCalculateTotalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public calculateTotalTicketsCalculateTotalPost(requestParameters: TicketsApiCalculateTotalTicketsCalculateTotalPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).calculateTotalTicketsCalculateTotalPost(requestParameters.calculateTotalInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check In User
     * @param {TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(requestParameters: TicketsApiCheckInUserTicketsEventsEventIdUsersUserIdCheckInPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).checkInUserTicketsEventsEventIdUsersUserIdCheckInPost(requestParameters.eventId, requestParameters.userId, requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count tickets for a list of events.  All events must belong to the same community. User must have OWNER  or EDITOR role in that community (or be a global ADMIN).
     * @summary Count Tickets By Events
     * @param {TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public countTicketsByEventsTicketsEventsCountPost(requestParameters: TicketsApiCountTicketsByEventsTicketsEventsCountPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).countTicketsByEventsTicketsEventsCountPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a checkout intent for Payment Sheet.  This is the first step in the Payment Sheet flow: 1. Client calls this endpoint with ticket details 2. Server validates tickets, calculates total, creates PaymentIntent 3. Returns credentials for Payment Sheet initialization 4. Client displays Payment Sheet 5. After payment, webhook triggers fulfillment 6. Client polls /checkout/{checkout_id}/status/ for completion  Headers: - Idempotency-Key: Required. Passed to Stripe to prevent duplicate charges.  Returns:     CheckoutIntentOutput with client_secret, ephemeral_key, customer_id
     * @summary Create Checkout Intent
     * @param {TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createCheckoutIntentTicketsCheckoutCreateIntentPost(requestParameters: TicketsApiCreateCheckoutIntentTicketsCheckoutCreateIntentPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createCheckoutIntentTicketsCheckoutCreateIntentPost(requestParameters.idempotencyKey, requestParameters.createCheckoutIntentInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Event Ticket Token
     * @param {TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createEventTicketTokenTicketsEventsEventIdTokenPost(requestParameters: TicketsApiCreateEventTicketTokenTicketsEventsEventIdTokenPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createEventTicketTokenTicketsEventsEventIdTokenPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new ticket receipt
     * @summary Create ticket receipt
     * @param {TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicketReceiptTicketsReceiptsPost(requestParameters: TicketsApiCreateTicketReceiptTicketsReceiptsPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicketReceiptTicketsReceiptsPost(requestParameters.createTicketReceiptInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Ticket
     * @param {TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicketTicketsCommunitiesCommunityIdPost(requestParameters: TicketsApiCreateTicketTicketsCommunitiesCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicketTicketsCommunitiesCommunityIdPost(requestParameters.communityId, requestParameters.createTicketInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Ticket Type
     * @param {TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicketTypeTicketsCommunitiesCommunityIdTypePost(requestParameters: TicketsApiCreateTicketTypeTicketsCommunitiesCommunityIdTypePostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicketTypeTicketsCommunitiesCommunityIdTypePost(requestParameters.communityId, requestParameters.createTicketTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a ticket by setting is_active=False. Only admins can deactivate tickets. This will also decrease the sold count for the ticket type.
     * @summary Deactivate Ticket
     * @param {TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deactivateTicketTicketsTicketIdDeactivatePatch(requestParameters: TicketsApiDeactivateTicketTicketsTicketIdDeactivatePatchRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deactivateTicketTicketsTicketIdDeactivatePatch(requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ticket by ID. Admin-only endpoint.  Args:     request: The HTTP request     ticket_id: The ID of the ticket to delete     current_user: The authenticated admin user\'s JWT payload     db: Database session      Returns:     DeleteTicketOutput: Response with ticket_id of the deleted ticket
     * @summary Delete Ticket
     * @param {TicketsApiDeleteTicketTicketsTicketIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteTicketTicketsTicketIdDelete(requestParameters: TicketsApiDeleteTicketTicketsTicketIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteTicketTicketsTicketIdDelete(requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a CSV file with all ticket information for given event_ids and uploads it to S3
     * @summary Export tickets for multiple events as CSV
     * @param {TicketsApiExportEventTicketsTicketsEventsExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public exportEventTicketsTicketsEventsExportPost(requestParameters: TicketsApiExportEventTicketsTicketsEventsExportPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).exportEventTicketsTicketsEventsExportPost(requestParameters.bulkExportTicketsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of a checkout.  Mobile clients poll this endpoint after Payment Sheet completes to check if fulfillment (ticket creation) has finished.  Status values: - pending: Waiting for payment confirmation - processing: Payment confirmed, creating tickets - completed: Tickets created successfully - failed: Error occurred  Returns:     CheckoutStatusOutput with current status and ticket_ids (if completed)
     * @summary Get Checkout Status
     * @param {TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(requestParameters: TicketsApiGetCheckoutStatusTicketsCheckoutCheckoutIdStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getCheckoutStatusTicketsCheckoutCheckoutIdStatusGet(requestParameters.checkoutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ticket receipts for a specific user
     * @summary Get receipts by user ID
     * @param {TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(requestParameters: TicketsApiGetReceiptsByUserIdTicketsReceiptsUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getReceiptsByUserIdTicketsReceiptsUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a ticket by ID - Admin or ticket owner only
     * @summary Get Ticket By Id
     * @param {TicketsApiGetTicketByIdTicketsTicketIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketByIdTicketsTicketIdGet(requestParameters: TicketsApiGetTicketByIdTicketsTicketIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketByIdTicketsTicketIdGet(requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ticket By Token
     * @param {TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketByTokenTicketsTokenTokenGet(requestParameters: TicketsApiGetTicketByTokenTicketsTokenTokenGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketByTokenTicketsTokenTokenGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED: Get all ticket receipts for a specific event and user
     * @summary Get receipts by event and user (DEPRECATED)
     * @param {TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(requestParameters: TicketsApiGetTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketReceiptByEventAndUserTicketsReceiptsEventsEventIdUsersUserIdGet(requestParameters.eventId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific ticket receipt by ID
     * @summary Get ticket receipt by ID
     * @param {TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketReceiptTicketsReceiptsReceiptIdGet(requestParameters: TicketsApiGetTicketReceiptTicketsReceiptsReceiptIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketReceiptTicketsReceiptsReceiptIdGet(requestParameters.receiptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED: Use /receipts_v2/events/{event_id}/ instead. Get all ticket receipts for a specific event
     * @summary Get receipts by event (DEPRECATED)
     * @param {TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(requestParameters: TicketsApiGetTicketReceiptsByEventTicketsReceiptsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketReceiptsByEventTicketsReceiptsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all receipts for a specific event using the new Receipt model
     * @summary Get receipts by event (V2)
     * @param {TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(requestParameters: TicketsApiGetTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketReceiptsByEventV2TicketsReceiptsV2EventsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ticket receipts missing ticket_id for a specific event - Admin only
     * @summary Get receipts missing ticket_id by event
     * @param {TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(requestParameters: TicketsApiGetTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketReceiptsMissingTicketIdByEventTicketsReceiptsEventsEventIdMissingTicketIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ticket type summaries for a specific event.
     * @summary Get Ticket Summaries By Event
     * @param {TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(requestParameters: TicketsApiGetTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketSummariesByEventTicketsCommunitiesCommunityIdSummariesEventEventIdGet(requestParameters.communityId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ticket type summary for a specific ticket type.
     * @summary Get Ticket Summary By Ticket Type
     * @param {TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(requestParameters: TicketsApiGetTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketSummaryByTicketTypeTicketsCommunitiesCommunityIdSummariesTicketTypeTicketTypeIdGet(requestParameters.communityId, requestParameters.ticketTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ticket
     * @param {TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketTicketsTicketIdCommunitiesCommunityIdGet(requestParameters: TicketsApiGetTicketTicketsTicketIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketTicketsTicketIdCommunitiesCommunityIdGet(requestParameters.ticketId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ticket Types
     * @param {TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketTypesTicketsTypesEventsEventIdGet(requestParameters: TicketsApiGetTicketTypesTicketsTypesEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketTypesTicketsTypesEventsEventIdGet(requestParameters.eventId, requestParameters.isOnSale, requestParameters.isHidden, requestParameters.isWaitlistable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tickets By Event Id
     * @param {TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(requestParameters: TicketsApiGetTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketsByEventIdTicketsCommunitiesCommunityIdEventsEventIdGet(requestParameters.communityId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tickets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketsTicketsGet(options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketsTicketsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Tickets Temporal
     * @param {TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(requestParameters: TicketsApiGetUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getUserTicketsTemporalTicketsTemporalTemporalRelationUsersUserIdGet(requestParameters.temporalRelation, requestParameters.userId, requestParameters.experienceTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users Attending Same Event
     * @param {TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(requestParameters: TicketsApiGetUsersAttendingSameEventTicketsUserIdUsersAtSameEventGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getUsersAttendingSameEventTicketsUserIdUsersAtSameEventGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users Overlapping Events
     * @param {TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(requestParameters: TicketsApiGetUsersOverlappingEventsTicketsUsersOverlappingEventsGetRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getUsersOverlappingEventsTicketsUsersOverlappingEventsGet(requestParameters.user1Id, requestParameters.user2Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ticket receipts - Admin only
     * @summary List all ticket receipts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public listTicketReceiptsTicketsReceiptsGet(options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).listTicketReceiptsTicketsReceiptsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refund a receipt by receipt_id with line item validation.  Each line item must include: - ticket_type_id: Must match a line item on the receipt - Either ticket_id OR promo_id to deactivate  The ticket_type_id on each item is validated against: - The receipt line items - The ticket\'s ticket_type_id (if ticket_id provided) - The promo\'s linked ticket types (if promo_id provided)  Community owners and editors (or global admins) can refund receipts.
     * @summary Refund Receipt
     * @param {TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(requestParameters: TicketsApiRefundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).refundReceiptTicketsReceiptsReceiptIdCommunitiesCommunityIdRefundPost(requestParameters.receiptId, requestParameters.communityId, requestParameters.refundReceiptInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refund a ticket by: 1. Getting the ticket receipt 2. Initiating a Stripe refund (if payment_intent_id exists) 3. Updating the receipt status to REFUNDED 4. Deactivating the ticket 5. Decreasing the sold count  Community owners and editors (or global admins) can refund tickets.
     * @summary Refund Ticket
     * @param {TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(requestParameters: TicketsApiRefundTicketTicketsTicketIdCommunitiesCommunityIdRefundPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).refundTicketTicketsTicketIdCommunitiesCommunityIdRefundPost(requestParameters.ticketId, requestParameters.communityId, requestParameters.refundTicketInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ticket Checkout V2
     * @param {TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public ticketCheckoutV2TicketsCheckoutV2Post(requestParameters: TicketsApiTicketCheckoutV2TicketsCheckoutV2PostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).ticketCheckoutV2TicketsCheckoutV2Post(requestParameters.checkoutInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer Ticket
     * @param {TicketsApiTransferTicketTicketsTransferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public transferTicketTicketsTransferPost(requestParameters: TicketsApiTransferTicketTicketsTransferPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).transferTicketTicketsTransferPost(requestParameters.transferTicketInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Undo Check In User
     * @param {TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(requestParameters: TicketsApiUndoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).undoCheckInUserTicketsEventsEventIdUsersUserIdCheckInUndoPost(requestParameters.eventId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove ticket_id link from a receipt (set to NULL) - Admin only
     * @summary Unlink ticket from receipt
     * @param {TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(requestParameters: TicketsApiUnlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPostRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).unlinkTicketReceiptTicketsReceiptsReceiptIdUnlinkPost(requestParameters.receiptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only endpoint to update the quantity of a ticket.  Args:     payload: The data for updating ticket quantity     current_user: The authenticated admin user     db: Database session      Returns:     GetTicketOutput: The updated ticket
     * @summary Update Ticket Quantity
     * @param {TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(requestParameters: TicketsApiUpdateTicketQuantityTicketsTicketIdUpdateQuantityPatchRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketQuantityTicketsTicketIdUpdateQuantityPatch(requestParameters.ticketId, requestParameters.updateTicketQuantityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a ticket receipt
     * @summary Update ticket receipt status
     * @param {TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(requestParameters: TicketsApiUpdateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPutRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketReceiptStatusTicketsReceiptsReceiptIdStatusPut(requestParameters.receiptId, requestParameters.updateTicketReceiptStatusInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update ticket receipt fields (ticket_id, ticket_type_id, payment_intent_id) - Admin only
     * @summary Update ticket receipt
     * @param {TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketReceiptTicketsReceiptsReceiptIdPatch(requestParameters: TicketsApiUpdateTicketReceiptTicketsReceiptsReceiptIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketReceiptTicketsReceiptsReceiptIdPatch(requestParameters.receiptId, requestParameters.updateTicketReceiptInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update ticket type - Community OWNER/EDITOR only
     * @summary Update ticket type
     * @param {TicketsApiUpdateTicketTicketsTicketIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketTicketsTicketIdPatch(requestParameters: TicketsApiUpdateTicketTicketsTicketIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketTicketsTicketIdPatch(requestParameters.ticketId, requestParameters.updateTicketInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ticket type
     * @summary Update Ticket Type
     * @param {TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(requestParameters: TicketsApiUpdateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketTypeTicketsCommunitiesCommunityIdTypeTicketTypeIdPut(requestParameters.communityId, requestParameters.ticketTypeId, requestParameters.updateTicketTypeInput, options).then((request) => request(this.axios, this.basePath));
    }
}



